"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataStore = void 0;
var DataStore = (function () {
    function DataStore(json) {
        this.json = json;
    }
    DataStore.prototype.getAllStates = function () {
        var states = this.json.states;
        return states.map(function (s) {
            return { value: s.name, name: s.name };
        });
    };
    DataStore.prototype.getCampuses = function () {
        var campuses = this.json.campuses;
        return campuses.map(function (_a) {
            var id = _a.id, name = _a.name, value = _a.value;
            return ({ id: id, name: name, value: value });
        });
    };
    Object.defineProperty(DataStore.prototype, "programs", {
        get: function () {
            var json = this.json;
            var programs = [];
            if (json.programs) {
                programs = json.programs;
                programs.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            return programs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "ethnicity", {
        get: function () {
            return [
                { id: 1, value: "asian", label: "Asian" },
                { id: 2, value: "white", label: "White" },
                { id: 3, value: "hispanic", label: "Hispanic/Latino" },
                { id: 4, value: "black-african", label: "Black/African American" },
                { id: 5, value: "american-indian", label: "American Indian/Alaska Native" },
                { id: 6, value: "native-hawaiia", label: "Native Hawaiian/Pacific Islander" },
                { id: 7, value: "two-or-more", label: "Two or more races" },
                { id: 8, value: "unknown", label: "Race or Ethnicity unknown" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "marital_status", {
        get: function () {
            return [
                { id: 1, value: "single", label: "Single" },
                { id: 2, value: "married", label: "Married" },
                { id: 3, value: "divorced", label: "Divorced" },
                { id: 4, value: "widowed", label: "Widowed" },
                { id: 5, value: "separated", label: "Separated" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "gender", {
        get: function () {
            return [
                { value: "Male", name: "Male" },
                { value: "Female", name: "Female" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "countries", {
        get: function () {
            return [
                {
                    countryId: 89,
                    code: "US",
                    name: "United States",
                    value: "United States",
                    states: [
                        {
                            stateId: 34,
                            name: "Alabama",
                            value: "Alabama",
                            countryId: 89
                        },
                        {
                            stateId: 38,
                            name: "Alaska",
                            value: "Alaska",
                            countryId: 89
                        },
                        {
                            stateId: 72,
                            name: "Arizona",
                            value: "Arizona",
                            countryId: 89
                        },
                        {
                            stateId: 73,
                            name: "Arkansas",
                            value: "Arkansas",
                            countryId: 89
                        },
                        {
                            stateId: 192,
                            name: "California",
                            value: "California",
                            countryId: 89
                        },
                        {
                            stateId: 277,
                            name: "Colorado",
                            value: "Colorado",
                            countryId: 89
                        },
                        {
                            stateId: 281,
                            name: "Connecticut",
                            value: "Connecticut",
                            countryId: 89
                        },
                        {
                            stateId: 306,
                            name: "Delaware",
                            value: "Delaware",
                            countryId: 89
                        },
                        {
                            stateId: 336,
                            name: "District of Columbia",
                            value: "District of Columbia",
                            countryId: 89
                        },
                        {
                            stateId: 392,
                            name: "Florida",
                            value: "Florida",
                            countryId: 89
                        },
                        {
                            stateId: 409,
                            name: "Georgia",
                            value: "Georgia",
                            countryId: 89
                        },
                        {
                            stateId: 467,
                            name: "Hawaii",
                            value: "Hawaii",
                            countryId: 89
                        },
                        {
                            stateId: 491,
                            name: "Idaho",
                            value: "Idaho",
                            countryId: 89
                        },
                        {
                            stateId: 513,
                            name: "Illinois",
                            value: "Illinois",
                            countryId: 89
                        },
                        {
                            stateId: 520,
                            name: "Indiana",
                            value: "Indiana",
                            countryId: 89
                        },
                        {
                            stateId: 521,
                            name: "Iowa",
                            value: "Iowa",
                            countryId: 89
                        },
                        {
                            stateId: 574,
                            name: "Kansas",
                            value: "Kansas",
                            countryId: 89
                        },
                        {
                            stateId: 609,
                            name: "Kentucky",
                            value: "Kentucky",
                            countryId: 89
                        },
                        {
                            stateId: 702,
                            name: "Louisiana",
                            value: "Louisiana",
                            countryId: 89
                        },
                        {
                            stateId: 724,
                            name: "Maine",
                            value: "Maine",
                            countryId: 89
                        },
                        {
                            stateId: 746,
                            name: "Maryland",
                            value: "Maryland",
                            countryId: 89
                        },
                        {
                            stateId: 749,
                            name: "Massachusetts",
                            value: "Massachusetts",
                            countryId: 89
                        },
                        {
                            stateId: 772,
                            name: "Michigan",
                            value: "Michigan",
                            countryId: 89
                        },
                        {
                            stateId: 778,
                            name: "Minnesota",
                            value: "Minnesota",
                            countryId: 89
                        },
                        {
                            stateId: 782,
                            name: "Mississippi",
                            value: "Mississippi",
                            countryId: 89
                        },
                        {
                            stateId: 783,
                            name: "Missouri",
                            value: "Missouri",
                            countryId: 89
                        },
                        {
                            stateId: 792,
                            name: "Montana",
                            value: "Montana",
                            countryId: 89
                        },
                        {
                            stateId: 829,
                            name: "Nebraska",
                            value: "Nebraska",
                            countryId: 89
                        },
                        {
                            stateId: 836,
                            name: "Nevada",
                            value: "Nevada",
                            countryId: 89
                        },
                        {
                            stateId: 839,
                            name: "New Hampshire",
                            value: "New Hampshire",
                            countryId: 89
                        },
                        {
                            stateId: 840,
                            name: "New Jersey",
                            value: "New Jersey",
                            countryId: 89
                        },
                        {
                            stateId: 841,
                            name: "New Mexico",
                            value: "New Mexico",
                            countryId: 89
                        },
                        {
                            stateId: 843,
                            name: "New York",
                            value: "New York",
                            countryId: 89
                        },
                        {
                            stateId: 864,
                            name: "North Carolina",
                            value: "North Carolina",
                            countryId: 89
                        },
                        {
                            stateId: 866,
                            name: "North Dakota",
                            value: "North Dakota",
                            countryId: 89
                        },
                        {
                            stateId: 890,
                            name: "Ohio",
                            value: "Ohio",
                            countryId: 89
                        },
                        {
                            stateId: 894,
                            name: "Oklahoma",
                            value: "Oklahoma",
                            countryId: 89
                        },
                        {
                            stateId: 905,
                            name: "Oregon",
                            value: "Oregon",
                            countryId: 89
                        },
                        {
                            stateId: 941,
                            name: "Pennsylvania",
                            value: "Pennsylvania",
                            countryId: 89
                        },
                        {
                            stateId: 1047,
                            name: "Rhode Island",
                            value: "Rhode Island",
                            countryId: 89
                        },
                        {
                            stateId: 1195,
                            name: "South Carolina",
                            value: "South Carolina",
                            countryId: 89
                        },
                        {
                            stateId: 1196,
                            name: "South Dakota",
                            value: "South Dakota",
                            countryId: 89
                        },
                        {
                            stateId: 1257,
                            name: "Tennessee",
                            value: "Tennessee",
                            countryId: 89
                        },
                        {
                            stateId: 1261,
                            name: "Texas",
                            value: "Texas",
                            countryId: 89
                        },
                        {
                            stateId: 1317,
                            name: "Utah",
                            value: "Utah",
                            countryId: 89
                        },
                        {
                            stateId: 1352,
                            name: "Vermont",
                            value: "Vermont",
                            countryId: 89
                        },
                        {
                            stateId: 1371,
                            name: "Virginia",
                            value: "Virginia",
                            countryId: 89
                        },
                        {
                            stateId: 1388,
                            name: "Washington",
                            value: "Washington",
                            countryId: 89
                        },
                        {
                            stateId: 1393,
                            name: "West Virginia",
                            value: "West Virginia",
                            countryId: 89
                        },
                        {
                            stateId: 1398,
                            name: "Wisconsin",
                            value: "Wisconsin",
                            countryId: 89
                        },
                        {
                            stateId: 1399,
                            name: "Wyoming",
                            value: "Wyoming",
                            countryId: 89
                        }
                    ]
                },
                {
                    countryId: 93,
                    code: "AF",
                    name: "Afghanistan",
                    value: "Afghanistan",
                    states: [
                        {
                            stateId: 1570,
                            name: "Kabul",
                            value: "Kabul",
                            countryId: 93
                        }
                    ]
                },
                {
                    countryId: 2,
                    code: "AX",
                    name: "Aland Islands",
                    value: "Aland Islands",
                    states: [
                        {
                            stateId: 36,
                            name: "Ålands landsbygd",
                            value: "Ålands landsbygd",
                            countryId: 2
                        },
                        {
                            stateId: 37,
                            name: "Ålands skärgård",
                            value: "Ålands skärgård",
                            countryId: 2
                        },
                        {
                            stateId: 739,
                            name: "Mariehamns stad",
                            value: "Mariehamns stad",
                            countryId: 2
                        }
                    ]
                },
                {
                    countryId: 95,
                    code: "AL",
                    name: "Albania",
                    value: "Albania",
                    states: [
                        {
                            stateId: 1571,
                            name: "Tirana",
                            value: "Tirana",
                            countryId: 95
                        }
                    ]
                },
                {
                    countryId: 3,
                    code: "DZ",
                    name: "Algeria",
                    value: "Algeria",
                    states: [
                        {
                            stateId: 11,
                            name: "Adrar",
                            value: "Adrar",
                            countryId: 3
                        },
                        {
                            stateId: 26,
                            name: "Ain-Defla",
                            value: "Ain-Defla",
                            countryId: 3
                        },
                        {
                            stateId: 27,
                            name: "Ain-Temouchent",
                            value: "Ain-Temouchent",
                            countryId: 3
                        },
                        {
                            stateId: 41,
                            name: "Alger",
                            value: "Alger",
                            countryId: 3
                        },
                        {
                            stateId: 60,
                            name: "Annaba",
                            value: "Annaba",
                            countryId: 3
                        },
                        {
                            stateId: 121,
                            name: "Batna",
                            value: "Batna",
                            countryId: 3
                        },
                        {
                            stateId: 127,
                            name: "Bechar",
                            value: "Bechar",
                            countryId: 3
                        },
                        {
                            stateId: 129,
                            name: "Bejaia",
                            value: "Bejaia",
                            countryId: 3
                        },
                        {
                            stateId: 142,
                            name: "Biskra",
                            value: "Biskra",
                            countryId: 3
                        },
                        {
                            stateId: 147,
                            name: "Blida",
                            value: "Blida",
                            countryId: 3
                        },
                        {
                            stateId: 151,
                            name: "Bordj-Bou-Arreridj",
                            value: "Bordj-Bou-Arreridj",
                            countryId: 3
                        },
                        {
                            stateId: 156,
                            name: "Bouira",
                            value: "Bouira",
                            countryId: 3
                        },
                        {
                            stateId: 157,
                            name: "Boumerdes",
                            value: "Boumerdes",
                            countryId: 3
                        },
                        {
                            stateId: 257,
                            name: "Chlef",
                            value: "Chlef",
                            countryId: 3
                        },
                        {
                            stateId: 283,
                            name: "Constantine",
                            value: "Constantine",
                            countryId: 3
                        },
                        {
                            stateId: 340,
                            name: "Djelfa",
                            value: "Djelfa",
                            countryId: 3
                        },
                        {
                            stateId: 363,
                            name: "El-Bayadh",
                            value: "El-Bayadh",
                            countryId: 3
                        },
                        {
                            stateId: 364,
                            name: "El-Oued",
                            value: "El-Oued",
                            countryId: 3
                        },
                        {
                            stateId: 365,
                            name: "El-Taref",
                            value: "El-Taref",
                            countryId: 3
                        },
                        {
                            stateId: 410,
                            name: "Ghardaia",
                            value: "Ghardaia",
                            countryId: 3
                        },
                        {
                            stateId: 443,
                            name: "Guelma",
                            value: "Guelma",
                            countryId: 3
                        },
                        {
                            stateId: 514,
                            name: "Illizi",
                            value: "Illizi",
                            countryId: 3
                        },
                        {
                            stateId: 555,
                            name: "Jijel",
                            value: "Jijel",
                            countryId: 3
                        },
                        {
                            stateId: 612,
                            name: "Khenchela",
                            value: "Khenchela",
                            countryId: 3
                        },
                        {
                            stateId: 662,
                            name: "L.Aghouat",
                            value: "L.Aghouat",
                            countryId: 3
                        },
                        {
                            stateId: 714,
                            name: "M'Sila",
                            value: "M'Sila",
                            countryId: 3
                        },
                        {
                            stateId: 748,
                            name: "Mascara",
                            value: "Mascara",
                            countryId: 3
                        },
                        {
                            stateId: 759,
                            name: "Medea",
                            value: "Medea",
                            countryId: 3
                        },
                        {
                            stateId: 775,
                            name: "Mila",
                            value: "Mila",
                            countryId: 3
                        },
                        {
                            stateId: 797,
                            name: "Mostaganem",
                            value: "Mostaganem",
                            countryId: 3
                        },
                        {
                            stateId: 808,
                            name: "Naama",
                            value: "Naama",
                            countryId: 3
                        },
                        {
                            stateId: 901,
                            name: "Oran",
                            value: "Oran",
                            countryId: 3
                        },
                        {
                            stateId: 916,
                            name: "Ouargla",
                            value: "Ouargla",
                            countryId: 3
                        },
                        {
                            stateId: 917,
                            name: "Oum-El-Bouaghi",
                            value: "Oum-El-Bouaghi",
                            countryId: 3
                        },
                        {
                            stateId: 1040,
                            name: "Relizane",
                            value: "Relizane",
                            countryId: 3
                        },
                        {
                            stateId: 1089,
                            name: "Saida",
                            value: "Saida",
                            countryId: 3
                        },
                        {
                            stateId: 1153,
                            name: "Setif",
                            value: "Setif",
                            countryId: 3
                        },
                        {
                            stateId: 1163,
                            name: "Sidi-Bel-Abbes",
                            value: "Sidi-Bel-Abbes",
                            countryId: 3
                        },
                        {
                            stateId: 1178,
                            name: "Skikda",
                            value: "Skikda",
                            countryId: 3
                        },
                        {
                            stateId: 1193,
                            name: "Souk-Ahras",
                            value: "Souk-Ahras",
                            countryId: 3
                        },
                        {
                            stateId: 1237,
                            name: "Tamanrasset",
                            value: "Tamanrasset",
                            countryId: 3
                        },
                        {
                            stateId: 1250,
                            name: "Tebessa",
                            value: "Tebessa",
                            countryId: 3
                        },
                        {
                            stateId: 1263,
                            name: "Tiaret",
                            value: "Tiaret",
                            countryId: 3
                        },
                        {
                            stateId: 1267,
                            name: "Tindouf",
                            value: "Tindouf",
                            countryId: 3
                        },
                        {
                            stateId: 1269,
                            name: "Tipaza",
                            value: "Tipaza",
                            countryId: 3
                        },
                        {
                            stateId: 1272,
                            name: "Tissemsilt",
                            value: "Tissemsilt",
                            countryId: 3
                        },
                        {
                            stateId: 1273,
                            name: "Tizi-Ouzou",
                            value: "Tizi-Ouzou",
                            countryId: 3
                        },
                        {
                            stateId: 1275,
                            name: "Tlemcen",
                            value: "Tlemcen",
                            countryId: 3
                        }
                    ]
                },
                {
                    countryId: 4,
                    code: "AS",
                    name: "American Samoa",
                    value: "American Samoa",
                    states: [
                        {
                            stateId: 78,
                            name: "As",
                            value: "As",
                            countryId: 4
                        }
                    ]
                },
                {
                    countryId: 5,
                    code: "AD",
                    name: "Andorra",
                    value: "Andorra",
                    states: [
                        {
                            stateId: 56,
                            name: "Andorra la Vella",
                            value: "Andorra la Vella",
                            countryId: 5
                        },
                        {
                            stateId: 200,
                            name: "Canillo",
                            value: "Canillo",
                            countryId: 5
                        },
                        {
                            stateId: 368,
                            name: "Encamp",
                            value: "Encamp",
                            countryId: 5
                        },
                        {
                            stateId: 375,
                            name: "Escaldes-Engordany",
                            value: "Escaldes-Engordany",
                            countryId: 5
                        },
                        {
                            stateId: 664,
                            name: "La Massana",
                            value: "La Massana",
                            countryId: 5
                        },
                        {
                            stateId: 902,
                            name: "Ordino",
                            value: "Ordino",
                            countryId: 5
                        },
                        {
                            stateId: 1129,
                            name: "Sant Julià de Lòria",
                            value: "Sant Julià de Lòria",
                            countryId: 5
                        }
                    ]
                },
                {
                    countryId: 99,
                    code: "AO",
                    name: "Angola",
                    value: "Angola",
                    states: [
                        {
                            stateId: 1572,
                            name: "Luanda",
                            value: "Luanda",
                            countryId: 99
                        }
                    ]
                },
                {
                    countryId: 100,
                    code: "AI",
                    name: "Anguilla",
                    value: "Anguilla",
                    states: [
                        {
                            stateId: 1573,
                            name: "The Valley",
                            value: "The Valley",
                            countryId: 100
                        }
                    ]
                },
                {
                    countryId: 102,
                    code: "AG",
                    name: "Antigua and Barbuda",
                    value: "Antigua and Barbuda",
                    states: [
                        {
                            stateId: 1574,
                            name: "Saint John’s",
                            value: "Saint John’s",
                            countryId: 102
                        }
                    ]
                },
                {
                    countryId: 6,
                    code: "AR",
                    name: "Argentina",
                    value: "Argentina",
                    states: [
                        {
                            stateId: 176,
                            name: "Buenos Aires",
                            value: "Buenos Aires",
                            countryId: 6
                        },
                        {
                            stateId: 222,
                            name: "Catamarca",
                            value: "Catamarca",
                            countryId: 6
                        },
                        {
                            stateId: 240,
                            name: "Chaco",
                            value: "Chaco",
                            countryId: 6
                        },
                        {
                            stateId: 260,
                            name: "Chubut",
                            value: "Chubut",
                            countryId: 6
                        },
                        {
                            stateId: 284,
                            name: "Cordoba",
                            value: "Cordoba",
                            countryId: 6
                        },
                        {
                            stateId: 287,
                            name: "Corrientes",
                            value: "Corrientes",
                            countryId: 6
                        },
                        {
                            stateId: 371,
                            name: "Entre Rios",
                            value: "Entre Rios",
                            countryId: 6
                        },
                        {
                            stateId: 394,
                            name: "Formosa",
                            value: "Formosa",
                            countryId: 6
                        },
                        {
                            stateId: 560,
                            name: "Jujuy",
                            value: "Jujuy",
                            countryId: 6
                        },
                        {
                            stateId: 665,
                            name: "La Pampa",
                            value: "La Pampa",
                            countryId: 6
                        },
                        {
                            stateId: 666,
                            name: "La Rioja",
                            value: "La Rioja",
                            countryId: 6
                        },
                        {
                            stateId: 764,
                            name: "Mendoza",
                            value: "Mendoza",
                            countryId: 6
                        },
                        {
                            stateId: 781,
                            name: "Misiones",
                            value: "Misiones",
                            countryId: 6
                        },
                        {
                            stateId: 835,
                            name: "Neuquen",
                            value: "Neuquen",
                            countryId: 6
                        },
                        {
                            stateId: 1055,
                            name: "Rio Negro",
                            value: "Rio Negro",
                            countryId: 6
                        },
                        {
                            stateId: 1108,
                            name: "Salta",
                            value: "Salta",
                            countryId: 6
                        },
                        {
                            stateId: 1120,
                            name: "San Juan",
                            value: "San Juan",
                            countryId: 6
                        },
                        {
                            stateId: 1123,
                            name: "San Luis",
                            value: "San Luis",
                            countryId: 6
                        },
                        {
                            stateId: 1131,
                            name: "Santa Cruz",
                            value: "Santa Cruz",
                            countryId: 6
                        },
                        {
                            stateId: 1132,
                            name: "Santa Fe",
                            value: "Santa Fe",
                            countryId: 6
                        },
                        {
                            stateId: 1136,
                            name: "Santiago Del Estero",
                            value: "Santiago Del Estero",
                            countryId: 6
                        },
                        {
                            stateId: 1265,
                            name: "Tierra Del Fuego",
                            value: "Tierra Del Fuego",
                            countryId: 6
                        },
                        {
                            stateId: 1303,
                            name: "Tucuman",
                            value: "Tucuman",
                            countryId: 6
                        }
                    ]
                },
                {
                    countryId: 104,
                    code: "AM",
                    name: "Armenia",
                    value: "Armenia",
                    states: [
                        {
                            stateId: 1575,
                            name: "Yerevan",
                            value: "Yerevan",
                            countryId: 104
                        }
                    ]
                },
                {
                    countryId: 105,
                    code: "AW",
                    name: "Aruba",
                    value: "Aruba",
                    states: [
                        {
                            stateId: 1576,
                            name: "Oranjestad",
                            value: "Oranjestad",
                            countryId: 105
                        }
                    ]
                },
                {
                    countryId: 7,
                    code: "AU",
                    name: "Australia",
                    value: "Australia",
                    states: [
                        {
                            stateId: 87,
                            name: "Australian Capital Territory",
                            value: "Australian Capital Territory",
                            countryId: 7
                        },
                        {
                            stateId: 842,
                            name: "New South Wales",
                            value: "New South Wales",
                            countryId: 7
                        },
                        {
                            stateId: 874,
                            name: "Northern Territory",
                            value: "Northern Territory",
                            countryId: 7
                        },
                        {
                            stateId: 1005,
                            name: "Queensland",
                            value: "Queensland",
                            countryId: 7
                        },
                        {
                            stateId: 1194,
                            name: "South Australia",
                            value: "South Australia",
                            countryId: 7
                        },
                        {
                            stateId: 1246,
                            name: "Tasmania",
                            value: "Tasmania",
                            countryId: 7
                        },
                        {
                            stateId: 1360,
                            name: "Victoria",
                            value: "Victoria",
                            countryId: 7
                        },
                        {
                            stateId: 1394,
                            name: "Western Australia",
                            value: "Western Australia",
                            countryId: 7
                        }
                    ]
                },
                {
                    countryId: 8,
                    code: "AT",
                    name: "Austria",
                    value: "Austria",
                    states: [
                        {
                            stateId: 178,
                            name: "Burgenland",
                            value: "Burgenland",
                            countryId: 8
                        },
                        {
                            stateId: 599,
                            name: "Kärnten",
                            value: "Kärnten",
                            countryId: 8
                        },
                        {
                            stateId: 846,
                            name: "Niederösterreich",
                            value: "Niederösterreich",
                            countryId: 8
                        },
                        {
                            stateId: 883,
                            name: "Oberösterreich",
                            value: "Oberösterreich",
                            countryId: 8
                        },
                        {
                            stateId: 1111,
                            name: "Salzburg",
                            value: "Salzburg",
                            countryId: 8
                        },
                        {
                            stateId: 1211,
                            name: "Steiermark",
                            value: "Steiermark",
                            countryId: 8
                        },
                        {
                            stateId: 1271,
                            name: "Tirol",
                            value: "Tirol",
                            countryId: 8
                        },
                        {
                            stateId: 1378,
                            name: "Vorarlberg",
                            value: "Vorarlberg",
                            countryId: 8
                        },
                        {
                            stateId: 1396,
                            name: "Wien",
                            value: "Wien",
                            countryId: 8
                        }
                    ]
                },
                {
                    countryId: 9,
                    code: "AZ",
                    name: "Azerbaijan",
                    value: "Azerbaijan",
                    states: [
                        {
                            stateId: 4,
                            name: "Abşeron",
                            value: "Abşeron",
                            countryId: 9
                        },
                        {
                            stateId: 13,
                            name: "Ağcabədi",
                            value: "Ağcabədi",
                            countryId: 9
                        },
                        {
                            stateId: 14,
                            name: "Ağdam",
                            value: "Ağdam",
                            countryId: 9
                        },
                        {
                            stateId: 15,
                            name: "Ağdaş",
                            value: "Ağdaş",
                            countryId: 9
                        },
                        {
                            stateId: 18,
                            name: "Ağstafa",
                            value: "Ağstafa",
                            countryId: 9
                        },
                        {
                            stateId: 19,
                            name: "Ağsu",
                            value: "Ağsu",
                            countryId: 9
                        },
                        {
                            stateId: 80,
                            name: "Astara",
                            value: "Astara",
                            countryId: 9
                        },
                        {
                            stateId: 99,
                            name: "Baki",
                            value: "Baki",
                            countryId: 9
                        },
                        {
                            stateId: 100,
                            name: "Balakən",
                            value: "Balakən",
                            countryId: 9
                        },
                        {
                            stateId: 134,
                            name: "Beyləqan",
                            value: "Beyləqan",
                            countryId: 9
                        },
                        {
                            stateId: 138,
                            name: "Biləsuvar",
                            value: "Biləsuvar",
                            countryId: 9
                        },
                        {
                            stateId: 184,
                            name: "Bərdə",
                            value: "Bərdə",
                            countryId: 9
                        },
                        {
                            stateId: 298,
                            name: "Cəlilabad",
                            value: "Cəlilabad",
                            countryId: 9
                        },
                        {
                            stateId: 304,
                            name: "Daşkəsən",
                            value: "Daşkəsən",
                            countryId: 9
                        },
                        {
                            stateId: 400,
                            name: "Füzuli",
                            value: "Füzuli",
                            countryId: 9
                        },
                        {
                            stateId: 419,
                            name: "Goranboy",
                            value: "Goranboy",
                            countryId: 9
                        },
                        {
                            stateId: 422,
                            name: "Göy-Göl",
                            value: "Göy-Göl",
                            countryId: 9
                        },
                        {
                            stateId: 423,
                            name: "Göyçay",
                            value: "Göyçay",
                            countryId: 9
                        },
                        {
                            stateId: 453,
                            name: "Gədəbəy",
                            value: "Gədəbəy",
                            countryId: 9
                        },
                        {
                            stateId: 454,
                            name: "Gəncə",
                            value: "Gəncə",
                            countryId: 9
                        },
                        {
                            stateId: 455,
                            name: "Haciqabul",
                            value: "Haciqabul",
                            countryId: 9
                        },
                        {
                            stateId: 516,
                            name: "Imişli",
                            value: "Imişli",
                            countryId: 9
                        },
                        {
                            stateId: 527,
                            name: "Ismayilli",
                            value: "Ismayilli",
                            countryId: 9
                        },
                        {
                            stateId: 646,
                            name: "Kürdəmir",
                            value: "Kürdəmir",
                            countryId: 9
                        },
                        {
                            stateId: 652,
                            name: "Kəlbəcər",
                            value: "Kəlbəcər",
                            countryId: 9
                        },
                        {
                            stateId: 671,
                            name: "Laçin",
                            value: "Laçin",
                            countryId: 9
                        },
                        {
                            stateId: 686,
                            name: "Lerik",
                            value: "Lerik",
                            countryId: 9
                        },
                        {
                            stateId: 713,
                            name: "Lənkəran",
                            value: "Lənkəran",
                            countryId: 9
                        },
                        {
                            stateId: 747,
                            name: "Masalli",
                            value: "Masalli",
                            countryId: 9
                        },
                        {
                            stateId: 777,
                            name: "Mingəçevir",
                            value: "Mingəçevir",
                            countryId: 9
                        },
                        {
                            stateId: 809,
                            name: "Naftalan",
                            value: "Naftalan",
                            countryId: 9
                        },
                        {
                            stateId: 830,
                            name: "Neftçala",
                            value: "Neftçala",
                            countryId: 9
                        },
                        {
                            stateId: 889,
                            name: "Oğuz",
                            value: "Oğuz",
                            countryId: 9
                        },
                        {
                            stateId: 997,
                            name: "Qax",
                            value: "Qax",
                            countryId: 9
                        },
                        {
                            stateId: 998,
                            name: "Qazax",
                            value: "Qazax",
                            countryId: 9
                        },
                        {
                            stateId: 999,
                            name: "Qobustan",
                            value: "Qobustan",
                            countryId: 9
                        },
                        {
                            stateId: 1001,
                            name: "Quba",
                            value: "Quba",
                            countryId: 9
                        },
                        {
                            stateId: 1002,
                            name: "Qubadli",
                            value: "Qubadli",
                            countryId: 9
                        },
                        {
                            stateId: 1009,
                            name: "Qusar",
                            value: "Qusar",
                            countryId: 9
                        },
                        {
                            stateId: 1010,
                            name: "Qəbələ",
                            value: "Qəbələ",
                            countryId: 9
                        },
                        {
                            stateId: 1078,
                            name: "Saatli",
                            value: "Saatli",
                            countryId: 9
                        },
                        {
                            stateId: 1082,
                            name: "Sabirabad",
                            value: "Sabirabad",
                            countryId: 9
                        },
                        {
                            stateId: 1083,
                            name: "Şabran",
                            value: "Şabran",
                            countryId: 9
                        },
                        {
                            stateId: 1110,
                            name: "Salyan",
                            value: "Salyan",
                            countryId: 9
                        },
                        {
                            stateId: 1112,
                            name: "Şamaxi",
                            value: "Şamaxi",
                            countryId: 9
                        },
                        {
                            stateId: 1117,
                            name: "Samux",
                            value: "Samux",
                            countryId: 9
                        },
                        {
                            stateId: 1173,
                            name: "Şirvan",
                            value: "Şirvan",
                            countryId: 9
                        },
                        {
                            stateId: 1176,
                            name: "Siyəzən",
                            value: "Siyəzən",
                            countryId: 9
                        },
                        {
                            stateId: 1221,
                            name: "Sumqayit",
                            value: "Sumqayit",
                            countryId: 9
                        },
                        {
                            stateId: 1225,
                            name: "Şuşa",
                            value: "Şuşa",
                            countryId: 9
                        },
                        {
                            stateId: 1230,
                            name: "Şəki",
                            value: "Şəki",
                            countryId: 9
                        },
                        {
                            stateId: 1231,
                            name: "Şəmkir",
                            value: "Şəmkir",
                            countryId: 9
                        },
                        {
                            stateId: 1287,
                            name: "Tovuz",
                            value: "Tovuz",
                            countryId: 9
                        },
                        {
                            stateId: 1307,
                            name: "Tər-Tər",
                            value: "Tər-Tər",
                            countryId: 9
                        },
                        {
                            stateId: 1309,
                            name: "Ucar",
                            value: "Ucar",
                            countryId: 9
                        },
                        {
                            stateId: 1400,
                            name: "Xaçmaz",
                            value: "Xaçmaz",
                            countryId: 9
                        },
                        {
                            stateId: 1401,
                            name: "Xankəndi",
                            value: "Xankəndi",
                            countryId: 9
                        },
                        {
                            stateId: 1402,
                            name: "Xizi",
                            value: "Xizi",
                            countryId: 9
                        },
                        {
                            stateId: 1403,
                            name: "Xocali",
                            value: "Xocali",
                            countryId: 9
                        },
                        {
                            stateId: 1404,
                            name: "Xocavənd",
                            value: "Xocavənd",
                            countryId: 9
                        },
                        {
                            stateId: 1411,
                            name: "Yardimli",
                            value: "Yardimli",
                            countryId: 9
                        },
                        {
                            stateId: 1414,
                            name: "Yevlax",
                            value: "Yevlax",
                            countryId: 9
                        },
                        {
                            stateId: 1424,
                            name: "Zaqatala",
                            value: "Zaqatala",
                            countryId: 9
                        },
                        {
                            stateId: 1432,
                            name: "Zəngilan",
                            value: "Zəngilan",
                            countryId: 9
                        },
                        {
                            stateId: 1433,
                            name: "Zərdab",
                            value: "Zərdab",
                            countryId: 9
                        }
                    ]
                },
                {
                    countryId: 109,
                    code: "BS",
                    name: "Bahamas",
                    value: "Bahamas",
                    states: [
                        {
                            stateId: 1577,
                            name: "Nassau",
                            value: "Nassau",
                            countryId: 109
                        }
                    ]
                },
                {
                    countryId: 110,
                    code: "BH",
                    name: "Bahrain",
                    value: "Bahrain",
                    states: [
                        {
                            stateId: 1578,
                            name: "Manama",
                            value: "Manama",
                            countryId: 110
                        }
                    ]
                },
                {
                    countryId: 10,
                    code: "BD",
                    name: "Bangladesh",
                    value: "Bangladesh",
                    states: [
                        {
                            stateId: 116,
                            name: "Barisal Division",
                            value: "Barisal Division",
                            countryId: 10
                        },
                        {
                            stateId: 256,
                            name: "Chittagong",
                            value: "Chittagong",
                            countryId: 10
                        },
                        {
                            stateId: 333,
                            name: "Dhaka Division",
                            value: "Dhaka Division",
                            countryId: 10
                        },
                        {
                            stateId: 616,
                            name: "Khulna Division",
                            value: "Khulna Division",
                            countryId: 10
                        },
                        {
                            stateId: 1012,
                            name: "Rājshāhi Division",
                            value: "Rājshāhi Division",
                            countryId: 10
                        },
                        {
                            stateId: 1013,
                            name: "Rangpur Division",
                            value: "Rangpur Division",
                            countryId: 10
                        },
                        {
                            stateId: 1228,
                            name: "Sylhet Division",
                            value: "Sylhet Division",
                            countryId: 10
                        }
                    ]
                },
                {
                    countryId: 112,
                    code: "BB",
                    name: "Barbados",
                    value: "Barbados",
                    states: [
                        {
                            stateId: 1579,
                            name: "Bridgetown",
                            value: "Bridgetown",
                            countryId: 112
                        }
                    ]
                },
                {
                    countryId: 11,
                    code: "BY",
                    name: "Belarus",
                    value: "Belarus",
                    states: [
                        {
                            stateId: 167,
                            name: "Brest",
                            value: "Brest",
                            countryId: 11
                        },
                        {
                            stateId: 418,
                            name: "Gomel",
                            value: "Gomel",
                            countryId: 11
                        },
                        {
                            stateId: 430,
                            name: "Grodno",
                            value: "Grodno",
                            countryId: 11
                        },
                        {
                            stateId: 432,
                            name: "Grosno",
                            value: "Grosno",
                            countryId: 11
                        },
                        {
                            stateId: 779,
                            name: "Minsk",
                            value: "Minsk",
                            countryId: 11
                        },
                        {
                            stateId: 788,
                            name: "Moghilev",
                            value: "Moghilev",
                            countryId: 11
                        },
                        {
                            stateId: 789,
                            name: "Mogholev",
                            value: "Mogholev",
                            countryId: 11
                        },
                        {
                            stateId: 1374,
                            name: "Vitebk",
                            value: "Vitebk",
                            countryId: 11
                        },
                        {
                            stateId: 1375,
                            name: "Vitebsk",
                            value: "Vitebsk",
                            countryId: 11
                        }
                    ]
                },
                {
                    countryId: 12,
                    code: "BE",
                    name: "Belgium",
                    value: "Belgium",
                    states: [
                        {
                            stateId: 173,
                            name: "Bruxelles-Capitale",
                            value: "Bruxelles-Capitale",
                            countryId: 12
                        },
                        {
                            stateId: 1376,
                            name: "Vlaanderen",
                            value: "Vlaanderen",
                            countryId: 12
                        },
                        {
                            stateId: 1385,
                            name: "Wallonie",
                            value: "Wallonie",
                            countryId: 12
                        }
                    ]
                },
                {
                    countryId: 115,
                    code: "BZ",
                    name: "Belize",
                    value: "Belize",
                    states: [
                        {
                            stateId: 1580,
                            name: "Belmopan",
                            value: "Belmopan",
                            countryId: 115
                        }
                    ]
                },
                {
                    countryId: 116,
                    code: "BJ",
                    name: "Benin",
                    value: "Benin",
                    states: [
                        {
                            stateId: 1581,
                            name: "Porto-Novo",
                            value: "Porto-Novo",
                            countryId: 116
                        }
                    ]
                },
                {
                    countryId: 13,
                    code: "BM",
                    name: "Bermuda",
                    value: "Bermuda",
                    states: [
                        {
                            stateId: 332,
                            name: "Devonshire Parish",
                            value: "Devonshire Parish",
                            countryId: 13
                        },
                        {
                            stateId: 460,
                            name: "Hamilton",
                            value: "Hamilton",
                            countryId: 13
                        },
                        {
                            stateId: 920,
                            name: "Paget Parish",
                            value: "Paget Parish",
                            countryId: 13
                        },
                        {
                            stateId: 940,
                            name: "Pembroke Parish",
                            value: "Pembroke Parish",
                            countryId: 13
                        },
                        {
                            stateId: 1090,
                            name: "Saint George",
                            value: "Saint George",
                            countryId: 13
                        },
                        {
                            stateId: 1091,
                            name: "Saint George’s Parish",
                            value: "Saint George’s Parish",
                            countryId: 13
                        },
                        {
                            stateId: 1126,
                            name: "Sandys Parish",
                            value: "Sandys Parish",
                            countryId: 13
                        },
                        {
                            stateId: 1183,
                            name: "Smith’s Parish",
                            value: "Smith’s Parish",
                            countryId: 13
                        },
                        {
                            stateId: 1199,
                            name: "Southampton Parish",
                            value: "Southampton Parish",
                            countryId: 13
                        },
                        {
                            stateId: 1387,
                            name: "Warwick Parish",
                            value: "Warwick Parish",
                            countryId: 13
                        }
                    ]
                },
                {
                    countryId: 118,
                    code: "BT",
                    name: "Bhutan",
                    value: "Bhutan",
                    states: [
                        {
                            stateId: 1582,
                            name: "Thimphu",
                            value: "Thimphu",
                            countryId: 118
                        }
                    ]
                },
                {
                    countryId: 119,
                    code: "BO",
                    name: "Bolivia (Plurinational State of)",
                    value: "Bolivia (Plurinational State of)",
                    states: [
                        {
                            stateId: 1583,
                            name: "Sucre",
                            value: "Sucre",
                            countryId: 119
                        }
                    ]
                },
                {
                    countryId: 120,
                    code: "BQ",
                    name: "Bonaire, Sint Eustatius and Saba",
                    value: "Bonaire, Sint Eustatius and Saba",
                    states: [
                        {
                            stateId: 1584,
                            name: "Kralendijk",
                            value: "Kralendijk",
                            countryId: 120
                        },
                        {
                            stateId: 1585,
                            name: "Oranjestad",
                            value: "Oranjestad",
                            countryId: 120
                        },
                        {
                            stateId: 1586,
                            name: "The Bottom",
                            value: "The Bottom",
                            countryId: 120
                        }
                    ]
                },
                {
                    countryId: 121,
                    code: "BA",
                    name: "Bosnia and Herzegovina",
                    value: "Bosnia and Herzegovina",
                    states: [
                        {
                            stateId: 1587,
                            name: "Sarajevo",
                            value: "Sarajevo",
                            countryId: 121
                        }
                    ]
                },
                {
                    countryId: 122,
                    code: "BW",
                    name: "Botswana",
                    value: "Botswana",
                    states: [
                        {
                            stateId: 1588,
                            name: "Gaborone",
                            value: "Gaborone",
                            countryId: 122
                        }
                    ]
                },
                {
                    countryId: 14,
                    code: "BR",
                    name: "Brazil",
                    value: "Brazil",
                    states: [
                        {
                            stateId: 6,
                            name: "Acre",
                            value: "Acre",
                            countryId: 14
                        },
                        {
                            stateId: 35,
                            name: "Alagoas ",
                            value: "Alagoas ",
                            countryId: 14
                        },
                        {
                            stateId: 46,
                            name: "Amapa",
                            value: "Amapa",
                            countryId: 14
                        },
                        {
                            stateId: 49,
                            name: "Amazonas ",
                            value: "Amazonas ",
                            countryId: 14
                        },
                        {
                            stateId: 96,
                            name: "Bahia",
                            value: "Bahia",
                            countryId: 14
                        },
                        {
                            stateId: 227,
                            name: "Ceara",
                            value: "Ceara",
                            countryId: 14
                        },
                        {
                            stateId: 337,
                            name: "Distrito Federal",
                            value: "Distrito Federal",
                            countryId: 14
                        },
                        {
                            stateId: 379,
                            name: "Espirito Santo",
                            value: "Espirito Santo",
                            countryId: 14
                        },
                        {
                            stateId: 417,
                            name: "Goias",
                            value: "Goias",
                            countryId: 14
                        },
                        {
                            stateId: 735,
                            name: "Maranhao ",
                            value: "Maranhao ",
                            countryId: 14
                        },
                        {
                            stateId: 750,
                            name: "Mato Grosso ",
                            value: "Mato Grosso ",
                            countryId: 14
                        },
                        {
                            stateId: 751,
                            name: "Mato Grosso do Sul",
                            value: "Mato Grosso do Sul",
                            countryId: 14
                        },
                        {
                            stateId: 776,
                            name: "Minas Gerais",
                            value: "Minas Gerais",
                            countryId: 14
                        },
                        {
                            stateId: 927,
                            name: "Para",
                            value: "Para",
                            countryId: 14
                        },
                        {
                            stateId: 928,
                            name: "Paraiba",
                            value: "Paraiba",
                            countryId: 14
                        },
                        {
                            stateId: 929,
                            name: "Parana",
                            value: "Parana",
                            countryId: 14
                        },
                        {
                            stateId: 945,
                            name: "Pernambuco ",
                            value: "Pernambuco ",
                            countryId: 14
                        },
                        {
                            stateId: 956,
                            name: "Piaui",
                            value: "Piaui",
                            countryId: 14
                        },
                        {
                            stateId: 1051,
                            name: "Rio de Janeiro ",
                            value: "Rio de Janeiro ",
                            countryId: 14
                        },
                        {
                            stateId: 1053,
                            name: "Rio Grande do Norte ",
                            value: "Rio Grande do Norte ",
                            countryId: 14
                        },
                        {
                            stateId: 1054,
                            name: "Rio Grande do Sul",
                            value: "Rio Grande do Sul",
                            countryId: 14
                        },
                        {
                            stateId: 1066,
                            name: "Rondonia",
                            value: "Rondonia",
                            countryId: 14
                        },
                        {
                            stateId: 1068,
                            name: "Roraima",
                            value: "Roraima",
                            countryId: 14
                        },
                        {
                            stateId: 1130,
                            name: "Santa Catarina ",
                            value: "Santa Catarina ",
                            countryId: 14
                        },
                        {
                            stateId: 1137,
                            name: "Sao Paulo",
                            value: "Sao Paulo",
                            countryId: 14
                        },
                        {
                            stateId: 1152,
                            name: "Sergipe",
                            value: "Sergipe",
                            countryId: 14
                        },
                        {
                            stateId: 1278,
                            name: "Tocantins",
                            value: "Tocantins",
                            countryId: 14
                        }
                    ]
                },
                {
                    countryId: 129,
                    code: "BN",
                    name: "Brunei Darussalam",
                    value: "Brunei Darussalam",
                    states: [
                        {
                            stateId: 1589,
                            name: "Bandar Seri Begawan",
                            value: "Bandar Seri Begawan",
                            countryId: 129
                        }
                    ]
                },
                {
                    countryId: 15,
                    code: "BG",
                    name: "Bulgaria",
                    value: "Bulgaria",
                    states: [
                        {
                            stateId: 1449,
                            name: "Благоевград / Blagoevgrad",
                            value: "Благоевград / Blagoevgrad",
                            countryId: 15
                        },
                        {
                            stateId: 1451,
                            name: "Бургас / Burgas",
                            value: "Бургас / Burgas",
                            countryId: 15
                        },
                        {
                            stateId: 1453,
                            name: "Варна / Varna",
                            value: "Варна / Varna",
                            countryId: 15
                        },
                        {
                            stateId: 1454,
                            name: "Велико Търново / Veliko Turnovo",
                            value: "Велико Търново / Veliko Turnovo",
                            countryId: 15
                        },
                        {
                            stateId: 1455,
                            name: "Видин / Vidin",
                            value: "Видин / Vidin",
                            countryId: 15
                        },
                        {
                            stateId: 1460,
                            name: "Враца / Vraca",
                            value: "Враца / Vraca",
                            countryId: 15
                        },
                        {
                            stateId: 1461,
                            name: "Габрово / Gabrovo",
                            value: "Габрово / Gabrovo",
                            countryId: 15
                        },
                        {
                            stateId: 1463,
                            name: "Добрич / Dobrich",
                            value: "Добрич / Dobrich",
                            countryId: 15
                        },
                        {
                            stateId: 1482,
                            name: "Кърджали / Kurdzhali",
                            value: "Кърджали / Kurdzhali",
                            countryId: 15
                        },
                        {
                            stateId: 1483,
                            name: "Кюстендил / Kjustendil",
                            value: "Кюстендил / Kjustendil",
                            countryId: 15
                        },
                        {
                            stateId: 1486,
                            name: "Ловеч / Lovech",
                            value: "Ловеч / Lovech",
                            countryId: 15
                        },
                        {
                            stateId: 1489,
                            name: "Монтана / Montana",
                            value: "Монтана / Montana",
                            countryId: 15
                        },
                        {
                            stateId: 1500,
                            name: "Пазарджик / Pazardzhik",
                            value: "Пазарджик / Pazardzhik",
                            countryId: 15
                        },
                        {
                            stateId: 1503,
                            name: "Перник / Pernik",
                            value: "Перник / Pernik",
                            countryId: 15
                        },
                        {
                            stateId: 1504,
                            name: "Плевен / Pleven",
                            value: "Плевен / Pleven",
                            countryId: 15
                        },
                        {
                            stateId: 1505,
                            name: "Пловдив / Plovdiv",
                            value: "Пловдив / Plovdiv",
                            countryId: 15
                        },
                        {
                            stateId: 1508,
                            name: "Разград / Razgrad",
                            value: "Разград / Razgrad",
                            countryId: 15
                        },
                        {
                            stateId: 1510,
                            name: "Русе / Ruse",
                            value: "Русе / Ruse",
                            countryId: 15
                        },
                        {
                            stateId: 1519,
                            name: "Силистра / Silistra",
                            value: "Силистра / Silistra",
                            countryId: 15
                        },
                        {
                            stateId: 1520,
                            name: "Сливен / Sliven",
                            value: "Сливен / Sliven",
                            countryId: 15
                        },
                        {
                            stateId: 1522,
                            name: "Смолян / Smoljan",
                            value: "Смолян / Smoljan",
                            countryId: 15
                        },
                        {
                            stateId: 1523,
                            name: "София (столица) / Sofija (stolica)",
                            value: "София (столица) / Sofija (stolica)",
                            countryId: 15
                        },
                        {
                            stateId: 1524,
                            name: "София / Sofija",
                            value: "София / Sofija",
                            countryId: 15
                        },
                        {
                            stateId: 1526,
                            name: "Стара Загора / Stara Zagora",
                            value: "Стара Загора / Stara Zagora",
                            countryId: 15
                        },
                        {
                            stateId: 1532,
                            name: "Търговище / Turgovishhe",
                            value: "Търговище / Turgovishhe",
                            countryId: 15
                        },
                        {
                            stateId: 1539,
                            name: "Хасково / Khaskovo",
                            value: "Хасково / Khaskovo",
                            countryId: 15
                        },
                        {
                            stateId: 1544,
                            name: "Шумен / Shumen",
                            value: "Шумен / Shumen",
                            countryId: 15
                        },
                        {
                            stateId: 1545,
                            name: "Ямбол / Jambol",
                            value: "Ямбол / Jambol",
                            countryId: 15
                        }
                    ]
                },
                {
                    countryId: 131,
                    code: "BF",
                    name: "Burkina Faso",
                    value: "Burkina Faso",
                    states: [
                        {
                            stateId: 1590,
                            name: "Ouagadougou",
                            value: "Ouagadougou",
                            countryId: 131
                        }
                    ]
                },
                {
                    countryId: 132,
                    code: "BI",
                    name: "Burundi",
                    value: "Burundi",
                    states: [
                        {
                            stateId: 1591,
                            name: "Gitega",
                            value: "Gitega",
                            countryId: 132
                        }
                    ]
                },
                {
                    countryId: 136,
                    code: "CV",
                    name: "Cabo Verde",
                    value: "Cabo Verde",
                    states: [
                        {
                            stateId: 1592,
                            name: "Praia",
                            value: "Praia",
                            countryId: 136
                        }
                    ]
                },
                {
                    countryId: 133,
                    code: "KH",
                    name: "Cambodia",
                    value: "Cambodia",
                    states: [
                        {
                            stateId: 1593,
                            name: "Phnom Penh",
                            value: "Phnom Penh",
                            countryId: 133
                        }
                    ]
                },
                {
                    countryId: 134,
                    code: "CM",
                    name: "Cameroon",
                    value: "Cameroon",
                    states: [
                        {
                            stateId: 1738,
                            name: "Yaounde",
                            value: "Yaounde",
                            countryId: 134
                        }
                    ]
                },
                {
                    countryId: 16,
                    code: "CA",
                    name: "Canada",
                    value: "Canada",
                    states: [
                        {
                            stateId: 40,
                            name: "Alberta",
                            value: "Alberta",
                            countryId: 16
                        },
                        {
                            stateId: 170,
                            name: "British Columbia",
                            value: "British Columbia",
                            countryId: 16
                        },
                        {
                            stateId: 733,
                            name: "Manitoba",
                            value: "Manitoba",
                            countryId: 16
                        },
                        {
                            stateId: 838,
                            name: "New Brunswick",
                            value: "New Brunswick",
                            countryId: 16
                        },
                        {
                            stateId: 844,
                            name: "Newfoundland and Labrador",
                            value: "Newfoundland and Labrador",
                            countryId: 16
                        },
                        {
                            stateId: 876,
                            name: "Northwest Territory",
                            value: "Northwest Territory",
                            countryId: 16
                        },
                        {
                            stateId: 878,
                            name: "Nova Scotia",
                            value: "Nova Scotia",
                            countryId: 16
                        },
                        {
                            stateId: 880,
                            name: "Nunavut Territory",
                            value: "Nunavut Territory",
                            countryId: 16
                        },
                        {
                            stateId: 898,
                            name: "Ontario",
                            value: "Ontario",
                            countryId: 16
                        },
                        {
                            stateId: 979,
                            name: "Prince Edward Island",
                            value: "Prince Edward Island",
                            countryId: 16
                        },
                        {
                            stateId: 1003,
                            name: "Quebec",
                            value: "Quebec",
                            countryId: 16
                        },
                        {
                            stateId: 1141,
                            name: "Saskatchewan",
                            value: "Saskatchewan",
                            countryId: 16
                        },
                        {
                            stateId: 1417,
                            name: "Yukon",
                            value: "Yukon",
                            countryId: 16
                        }
                    ]
                },
                {
                    countryId: 137,
                    code: "KY",
                    name: "Cayman Islands",
                    value: "Cayman Islands",
                    states: [
                        {
                            stateId: 1594,
                            name: "George Town",
                            value: "George Town",
                            countryId: 137
                        }
                    ]
                },
                {
                    countryId: 138,
                    code: "CF",
                    name: "Central African Republic",
                    value: "Central African Republic",
                    states: [
                        {
                            stateId: 1595,
                            name: "Bangui",
                            value: "Bangui",
                            countryId: 138
                        }
                    ]
                },
                {
                    countryId: 139,
                    code: "TD",
                    name: "Chad",
                    value: "Chad",
                    states: [
                        {
                            stateId: 1596,
                            name: "N'Djamena",
                            value: "N'Djamena",
                            countryId: 139
                        }
                    ]
                },
                {
                    countryId: 17,
                    code: "CL",
                    name: "Chile",
                    value: "Chile",
                    states: [
                        {
                            stateId: 1020,
                            name: "Región Aysén",
                            value: "Región Aysén",
                            countryId: 17
                        },
                        {
                            stateId: 1021,
                            name: "Región de Antofagasta",
                            value: "Región de Antofagasta",
                            countryId: 17
                        },
                        {
                            stateId: 1022,
                            name: "Región de Arica y Parinacota",
                            value: "Región de Arica y Parinacota",
                            countryId: 17
                        },
                        {
                            stateId: 1023,
                            name: "Región de Atacama",
                            value: "Región de Atacama",
                            countryId: 17
                        },
                        {
                            stateId: 1024,
                            name: "Región de Coquimbo",
                            value: "Región de Coquimbo",
                            countryId: 17
                        },
                        {
                            stateId: 1025,
                            name: "Región de la Araucanía",
                            value: "Región de la Araucanía",
                            countryId: 17
                        },
                        {
                            stateId: 1026,
                            name: "Región de los Lagos",
                            value: "Región de los Lagos",
                            countryId: 17
                        },
                        {
                            stateId: 1027,
                            name: "Región de los Ríos",
                            value: "Región de los Ríos",
                            countryId: 17
                        },
                        {
                            stateId: 1028,
                            name: "Región de Magallanes y Antártica Chilena",
                            value: "Región de Magallanes y Antártica Chilena",
                            countryId: 17
                        },
                        {
                            stateId: 1029,
                            name: "Región de Tarapacá",
                            value: "Región de Tarapacá",
                            countryId: 17
                        },
                        {
                            stateId: 1030,
                            name: "Región de Valparaíso",
                            value: "Región de Valparaíso",
                            countryId: 17
                        },
                        {
                            stateId: 1031,
                            name: "Región del Biobío",
                            value: "Región del Biobío",
                            countryId: 17
                        },
                        {
                            stateId: 1032,
                            name: "Región del Libertador General Bernardo O’Higgins",
                            value: "Región del Libertador General Bernardo O’Higgins",
                            countryId: 17
                        },
                        {
                            stateId: 1033,
                            name: "Región del Maule",
                            value: "Región del Maule",
                            countryId: 17
                        },
                        {
                            stateId: 1035,
                            name: "Región Metropolitana",
                            value: "Región Metropolitana",
                            countryId: 17
                        }
                    ]
                },
                {
                    countryId: 141,
                    code: "CN",
                    name: "China",
                    value: "China",
                    states: [
                        {
                            stateId: 1597,
                            name: "Beijing",
                            value: "Beijing",
                            countryId: 141
                        }
                    ]
                },
                {
                    countryId: 142,
                    code: "CX",
                    name: "Christmas Island",
                    value: "Christmas Island",
                    states: [
                        {
                            stateId: 1598,
                            name: "Flying Fish Cove",
                            value: "Flying Fish Cove",
                            countryId: 142
                        }
                    ]
                },
                {
                    countryId: 143,
                    code: "CC",
                    name: "Cocos (Keeling) Islands",
                    value: "Cocos (Keeling) Islands",
                    states: [
                        {
                            stateId: 1599,
                            name: "West Island",
                            value: "West Island",
                            countryId: 143
                        }
                    ]
                },
                {
                    countryId: 18,
                    code: "CO",
                    name: "Colombia",
                    value: "Colombia",
                    states: [
                        {
                            stateId: 50,
                            name: "Amazonas",
                            value: "Amazonas",
                            countryId: 18
                        },
                        {
                            stateId: 62,
                            name: "Antioquia",
                            value: "Antioquia",
                            countryId: 18
                        },
                        {
                            stateId: 67,
                            name: "Arauca",
                            value: "Arauca",
                            countryId: 18
                        },
                        {
                            stateId: 68,
                            name: "Archipielago De San Andres",
                            value: "Archipielago De San Andres",
                            countryId: 18
                        },
                        {
                            stateId: 82,
                            name: "Atlantico",
                            value: "Atlantico",
                            countryId: 18
                        },
                        {
                            stateId: 148,
                            name: "Bogota, D.C.",
                            value: "Bogota, D.C.",
                            countryId: 18
                        },
                        {
                            stateId: 149,
                            name: "Bolivar",
                            value: "Bolivar",
                            countryId: 18
                        },
                        {
                            stateId: 159,
                            name: "Boyaca",
                            value: "Boyaca",
                            countryId: 18
                        },
                        {
                            stateId: 191,
                            name: "Caldas",
                            value: "Caldas",
                            countryId: 18
                        },
                        {
                            stateId: 213,
                            name: "Caqueta",
                            value: "Caqueta",
                            countryId: 18
                        },
                        {
                            stateId: 217,
                            name: "Casanare",
                            value: "Casanare",
                            countryId: 18
                        },
                        {
                            stateId: 224,
                            name: "Cauca",
                            value: "Cauca",
                            countryId: 18
                        },
                        {
                            stateId: 235,
                            name: "Cesar",
                            value: "Cesar",
                            countryId: 18
                        },
                        {
                            stateId: 258,
                            name: "Choco",
                            value: "Choco",
                            countryId: 18
                        },
                        {
                            stateId: 285,
                            name: "Cordoba",
                            value: "Cordoba",
                            countryId: 18
                        },
                        {
                            stateId: 297,
                            name: "Cundinamarca",
                            value: "Cundinamarca",
                            countryId: 18
                        },
                        {
                            stateId: 435,
                            name: "Guainia",
                            value: "Guainia",
                            countryId: 18
                        },
                        {
                            stateId: 439,
                            name: "Guaviare",
                            value: "Guaviare",
                            countryId: 18
                        },
                        {
                            stateId: 481,
                            name: "Huila",
                            value: "Huila",
                            countryId: 18
                        },
                        {
                            stateId: 663,
                            name: "La Guajira",
                            value: "La Guajira",
                            countryId: 18
                        },
                        {
                            stateId: 721,
                            name: "Magdalena",
                            value: "Magdalena",
                            countryId: 18
                        },
                        {
                            stateId: 768,
                            name: "Meta",
                            value: "Meta",
                            countryId: 18
                        },
                        {
                            stateId: 824,
                            name: "Nariño",
                            value: "Nariño",
                            countryId: 18
                        },
                        {
                            stateId: 863,
                            name: "Norte De Santander",
                            value: "Norte De Santander",
                            countryId: 18
                        },
                        {
                            stateId: 996,
                            name: "Putumayo",
                            value: "Putumayo",
                            countryId: 18
                        },
                        {
                            stateId: 1007,
                            name: "Quindio",
                            value: "Quindio",
                            countryId: 18
                        },
                        {
                            stateId: 1057,
                            name: "Risaralda",
                            value: "Risaralda",
                            countryId: 18
                        },
                        {
                            stateId: 1134,
                            name: "Santander",
                            value: "Santander",
                            countryId: 18
                        },
                        {
                            stateId: 1219,
                            name: "Sucre",
                            value: "Sucre",
                            countryId: 18
                        },
                        {
                            stateId: 1283,
                            name: "Tolima",
                            value: "Tolima",
                            countryId: 18
                        },
                        {
                            stateId: 1332,
                            name: "Valle Del Cauca",
                            value: "Valle Del Cauca",
                            countryId: 18
                        },
                        {
                            stateId: 1344,
                            name: "Vaupes",
                            value: "Vaupes",
                            countryId: 18
                        },
                        {
                            stateId: 1359,
                            name: "Vichada",
                            value: "Vichada",
                            countryId: 18
                        }
                    ]
                },
                {
                    countryId: 145,
                    code: "KM",
                    name: "Comoros",
                    value: "Comoros",
                    states: [
                        {
                            stateId: 1600,
                            name: "Moroni",
                            value: "Moroni",
                            countryId: 145
                        }
                    ]
                },
                {
                    countryId: 146,
                    code: "CG",
                    name: "Congo",
                    value: "Congo",
                    states: [
                        {
                            stateId: 1601,
                            name: "Brazzaville",
                            value: "Brazzaville",
                            countryId: 146
                        }
                    ]
                },
                {
                    countryId: 147,
                    code: "CD",
                    name: "Congo (Democratic Republic of the)",
                    value: "Congo (Democratic Republic of the)",
                    states: [
                        {
                            stateId: 1602,
                            name: "Kinshasa",
                            value: "Kinshasa",
                            countryId: 147
                        }
                    ]
                },
                {
                    countryId: 148,
                    code: "CK",
                    name: "Cook Islands",
                    value: "Cook Islands",
                    states: [
                        {
                            stateId: 1739,
                            name: "Avarua",
                            value: "Avarua",
                            countryId: 35
                        }
                    ]
                },
                {
                    countryId: 19,
                    code: "CR",
                    name: "Costa Rica",
                    value: "Costa Rica",
                    states: [
                        {
                            stateId: 984,
                            name: "Provincia de Alajuela",
                            value: "Provincia de Alajuela",
                            countryId: 19
                        },
                        {
                            stateId: 985,
                            name: "Provincia de Cartago",
                            value: "Provincia de Cartago",
                            countryId: 19
                        },
                        {
                            stateId: 986,
                            name: "Provincia de Guanacaste",
                            value: "Provincia de Guanacaste",
                            countryId: 19
                        },
                        {
                            stateId: 987,
                            name: "Provincia de Heredia",
                            value: "Provincia de Heredia",
                            countryId: 19
                        },
                        {
                            stateId: 988,
                            name: "Provincia de Limón",
                            value: "Provincia de Limón",
                            countryId: 19
                        },
                        {
                            stateId: 989,
                            name: "Provincia de Puntarenas",
                            value: "Provincia de Puntarenas",
                            countryId: 19
                        },
                        {
                            stateId: 990,
                            name: "Provincia de San José",
                            value: "Provincia de San José",
                            countryId: 19
                        }
                    ]
                },
                {
                    countryId: 199,
                    code: "CI",
                    name: "Côte d'Ivoire",
                    value: "Côte d'Ivoire",
                    states: [
                        {
                            stateId: 1603,
                            name: "Yamoussoukro",
                            value: "Yamoussoukro",
                            countryId: 199
                        }
                    ]
                },
                {
                    countryId: 20,
                    code: "HR",
                    name: "Croatia",
                    value: "Croatia",
                    states: [
                        {
                            stateId: 145,
                            name: "Bjelovarsko-Bilogorska",
                            value: "Bjelovarsko-Bilogorska",
                            countryId: 20
                        },
                        {
                            stateId: 172,
                            name: "Brodsko-Posavska",
                            value: "Brodsko-Posavska",
                            countryId: 20
                        },
                        {
                            stateId: 351,
                            name: "Dubrovačko-Neretvanska",
                            value: "Dubrovačko-Neretvanska",
                            countryId: 20
                        },
                        {
                            stateId: 424,
                            name: "Grad Zagreb",
                            value: "Grad Zagreb",
                            countryId: 20
                        },
                        {
                            stateId: 530,
                            name: "Istarska",
                            value: "Istarska",
                            countryId: 20
                        },
                        {
                            stateId: 596,
                            name: "Karlovačka",
                            value: "Karlovačka",
                            countryId: 20
                        },
                        {
                            stateId: 631,
                            name: "Koprivničko-Križevačka",
                            value: "Koprivničko-Križevačka",
                            countryId: 20
                        },
                        {
                            stateId: 637,
                            name: "Krapinsko-Zagorska",
                            value: "Krapinsko-Zagorska",
                            countryId: 20
                        },
                        {
                            stateId: 689,
                            name: "Ličko-Senjska",
                            value: "Ličko-Senjska",
                            countryId: 20
                        },
                        {
                            stateId: 770,
                            name: "Međimurska",
                            value: "Međimurska",
                            countryId: 20
                        },
                        {
                            stateId: 909,
                            name: "Osječko-Baranjska",
                            value: "Osječko-Baranjska",
                            countryId: 20
                        },
                        {
                            stateId: 970,
                            name: "Požeško-Slavonska",
                            value: "Požeško-Slavonska",
                            countryId: 20
                        },
                        {
                            stateId: 978,
                            name: "Primorsko-Goranska",
                            value: "Primorsko-Goranska",
                            countryId: 20
                        },
                        {
                            stateId: 1160,
                            name: "Šibensko-Kninska",
                            value: "Šibensko-Kninska",
                            countryId: 20
                        },
                        {
                            stateId: 1174,
                            name: "Sisačko-Moslavačka",
                            value: "Sisačko-Moslavačka",
                            countryId: 20
                        },
                        {
                            stateId: 1205,
                            name: "Splitsko-Dalmatinska",
                            value: "Splitsko-Dalmatinska",
                            countryId: 20
                        },
                        {
                            stateId: 1335,
                            name: "Varaždinska",
                            value: "Varaždinska",
                            countryId: 20
                        },
                        {
                            stateId: 1372,
                            name: "Virovitičko-Podravska",
                            value: "Virovitičko-Podravska",
                            countryId: 20
                        },
                        {
                            stateId: 1381,
                            name: "Vukovarsko-Srijemska",
                            value: "Vukovarsko-Srijemska",
                            countryId: 20
                        },
                        {
                            stateId: 1419,
                            name: "Zadarska",
                            value: "Zadarska",
                            countryId: 20
                        },
                        {
                            stateId: 1420,
                            name: "Zagrebačka",
                            value: "Zagrebačka",
                            countryId: 20
                        }
                    ]
                },
                {
                    countryId: 151,
                    code: "CU",
                    name: "Cuba",
                    value: "Cuba",
                    states: [
                        {
                            stateId: 1604,
                            name: "Havana",
                            value: "Havana",
                            countryId: 151
                        }
                    ]
                },
                {
                    countryId: 152,
                    code: "CW",
                    name: "Curaçao",
                    value: "Curaçao",
                    states: [
                        {
                            stateId: 1605,
                            name: "Willemstad",
                            value: "Willemstad",
                            countryId: 152
                        }
                    ]
                },
                {
                    countryId: 153,
                    code: "CY",
                    name: "Cyprus",
                    value: "Cyprus",
                    states: [
                        {
                            stateId: 1606,
                            name: "Nicosia",
                            value: "Nicosia",
                            countryId: 153
                        }
                    ]
                },
                {
                    countryId: 21,
                    code: "CZ",
                    name: "Czech Republic",
                    value: "Czech Republic",
                    states: [
                        {
                            stateId: 477,
                            name: "Hlavní město Praha",
                            value: "Hlavní město Praha",
                            countryId: 21
                        },
                        {
                            stateId: 553,
                            name: "Jihočeský kraj",
                            value: "Jihočeský kraj",
                            countryId: 21
                        },
                        {
                            stateId: 554,
                            name: "Jihomoravský kraj",
                            value: "Jihomoravský kraj",
                            countryId: 21
                        },
                        {
                            stateId: 597,
                            name: "Karlovarský kraj",
                            value: "Karlovarský kraj",
                            countryId: 21
                        },
                        {
                            stateId: 635,
                            name: "Kraj Vysočina",
                            value: "Kraj Vysočina",
                            countryId: 21
                        },
                        {
                            stateId: 636,
                            name: "Královéhradecký kraj",
                            value: "Královéhradecký kraj",
                            countryId: 21
                        },
                        {
                            stateId: 688,
                            name: "Liberecký kraj",
                            value: "Liberecký kraj",
                            countryId: 21
                        },
                        {
                            stateId: 794,
                            name: "Moravskoslezský kraj",
                            value: "Moravskoslezský kraj",
                            countryId: 21
                        },
                        {
                            stateId: 896,
                            name: "Olomoucký kraj",
                            value: "Olomoucký kraj",
                            countryId: 21
                        },
                        {
                            stateId: 930,
                            name: "Pardubický kraj",
                            value: "Pardubický kraj",
                            countryId: 21
                        },
                        {
                            stateId: 961,
                            name: "Plzeňský kraj",
                            value: "Plzeňský kraj",
                            countryId: 21
                        },
                        {
                            stateId: 1215,
                            name: "Středočeský kraj",
                            value: "Středočeský kraj",
                            countryId: 21
                        },
                        {
                            stateId: 1316,
                            name: "Ústecký kraj",
                            value: "Ústecký kraj",
                            countryId: 21
                        },
                        {
                            stateId: 1429,
                            name: "Zlínský kraj",
                            value: "Zlínský kraj",
                            countryId: 21
                        }
                    ]
                },
                {
                    countryId: 22,
                    code: "DK",
                    name: "Denmark",
                    value: "Denmark",
                    states: [
                        {
                            stateId: 1034,
                            name: "Region Hovedstaden",
                            value: "Region Hovedstaden",
                            countryId: 22
                        },
                        {
                            stateId: 1036,
                            name: "Region Midtjylland",
                            value: "Region Midtjylland",
                            countryId: 22
                        },
                        {
                            stateId: 1037,
                            name: "Region Nordjylland",
                            value: "Region Nordjylland",
                            countryId: 22
                        },
                        {
                            stateId: 1038,
                            name: "Region Sjælland",
                            value: "Region Sjælland",
                            countryId: 22
                        },
                        {
                            stateId: 1039,
                            name: "Region Syddanmark",
                            value: "Region Syddanmark",
                            countryId: 22
                        }
                    ]
                },
                {
                    countryId: 156,
                    code: "DJ",
                    name: "Djibouti",
                    value: "Djibouti",
                    states: [
                        {
                            stateId: 1607,
                            name: "Djibouti",
                            value: "Djibouti",
                            countryId: 156
                        }
                    ]
                },
                {
                    countryId: 157,
                    code: "DM",
                    name: "Dominica",
                    value: "Dominica",
                    states: [
                        {
                            stateId: 1608,
                            name: "Roseau",
                            value: "Roseau",
                            countryId: 157
                        }
                    ]
                },
                {
                    countryId: 23,
                    code: "DO",
                    name: "Dominican Republic",
                    value: "Dominican Republic",
                    states: [
                        {
                            stateId: 1609,
                            name: "Santo Domingo",
                            value: "Santo Domingo",
                            countryId: 23
                        }
                    ]
                },
                {
                    countryId: 159,
                    code: "EC",
                    name: "Ecuador",
                    value: "Ecuador",
                    states: [
                        {
                            stateId: 1610,
                            name: "Quito",
                            value: "Quito",
                            countryId: 159
                        }
                    ]
                },
                {
                    countryId: 160,
                    code: "EG",
                    name: "Egypt",
                    value: "Egypt",
                    states: [
                        {
                            stateId: 1611,
                            name: "Cairo",
                            value: "Cairo",
                            countryId: 160
                        }
                    ]
                },
                {
                    countryId: 161,
                    code: "SV",
                    name: "El Salvador",
                    value: "El Salvador",
                    states: [
                        {
                            stateId: 1612,
                            name: "San Salvador",
                            value: "San Salvador",
                            countryId: 161
                        }
                    ]
                },
                {
                    countryId: 162,
                    code: "GQ",
                    name: "Equatorial Guinea",
                    value: "Equatorial Guinea",
                    states: [
                        {
                            stateId: 1613,
                            name: "Malabo",
                            value: "Malabo",
                            countryId: 162
                        }
                    ]
                },
                {
                    countryId: 163,
                    code: "ER",
                    name: "Eritrea",
                    value: "Eritrea",
                    states: [
                        {
                            stateId: 1614,
                            name: "Asmara",
                            value: "Asmara",
                            countryId: 163
                        }
                    ]
                },
                {
                    countryId: 24,
                    code: "EE",
                    name: "Estonia",
                    value: "Estonia",
                    states: [
                        {
                            stateId: 462,
                            name: "Harju maakond",
                            value: "Harju maakond",
                            countryId: 24
                        },
                        {
                            stateId: 473,
                            name: "Hiiu maakond",
                            value: "Hiiu maakond",
                            countryId: 24
                        },
                        {
                            stateId: 490,
                            name: "Ida-Viru maakond",
                            value: "Ida-Viru maakond",
                            countryId: 24
                        },
                        {
                            stateId: 544,
                            name: "Järva maakond",
                            value: "Järva maakond",
                            countryId: 24
                        },
                        {
                            stateId: 556,
                            name: "Jõgeva maakond",
                            value: "Jõgeva maakond",
                            countryId: 24
                        },
                        {
                            stateId: 668,
                            name: "Lääne maakond",
                            value: "Lääne maakond",
                            countryId: 24
                        },
                        {
                            stateId: 669,
                            name: "Lääne-Viru maakond",
                            value: "Lääne-Viru maakond",
                            countryId: 24
                        },
                        {
                            stateId: 932,
                            name: "Pärnu maakond",
                            value: "Pärnu maakond",
                            countryId: 24
                        },
                        {
                            stateId: 964,
                            name: "Põlva maakond",
                            value: "Põlva maakond",
                            countryId: 24
                        },
                        {
                            stateId: 1015,
                            name: "Rapla maakond",
                            value: "Rapla maakond",
                            countryId: 24
                        },
                        {
                            stateId: 1076,
                            name: "Saare maakond",
                            value: "Saare maakond",
                            countryId: 24
                        },
                        {
                            stateId: 1242,
                            name: "Tartu maakond",
                            value: "Tartu maakond",
                            countryId: 24
                        },
                        {
                            stateId: 1329,
                            name: "Valga maakond",
                            value: "Valga maakond",
                            countryId: 24
                        },
                        {
                            stateId: 1367,
                            name: "Viljandi maakond",
                            value: "Viljandi maakond",
                            countryId: 24
                        },
                        {
                            stateId: 1379,
                            name: "Võru maakond",
                            value: "Võru maakond",
                            countryId: 24
                        }
                    ]
                },
                {
                    countryId: 165,
                    code: "ET",
                    name: "Ethiopia",
                    value: "Ethiopia",
                    states: [
                        {
                            stateId: 1615,
                            name: "Addis Ababa",
                            value: "Addis Ababa",
                            countryId: 165
                        }
                    ]
                },
                {
                    countryId: 166,
                    code: "FK",
                    name: "Falkland Islands (Malvinas)",
                    value: "Falkland Islands (Malvinas)",
                    states: [
                        {
                            stateId: 1616,
                            name: "Stanley",
                            value: "Stanley",
                            countryId: 166
                        }
                    ]
                },
                {
                    countryId: 25,
                    code: "FO",
                    name: "Faroe Islands",
                    value: "Faroe Islands",
                    states: [
                        {
                            stateId: 1617,
                            name: "Tórshavn",
                            value: "Tórshavn",
                            countryId: 25
                        }
                    ]
                },
                {
                    countryId: 168,
                    code: "FJ",
                    name: "Fiji",
                    value: "Fiji",
                    states: [
                        {
                            stateId: 1618,
                            name: "Suva",
                            value: "Suva",
                            countryId: 168
                        }
                    ]
                },
                {
                    countryId: 26,
                    code: "FI",
                    name: "Finland",
                    value: "Finland",
                    states: [
                        {
                            stateId: 229,
                            name: "Central Finland Region",
                            value: "Central Finland Region",
                            countryId: 26
                        },
                        {
                            stateId: 230,
                            name: "Central Ostrobothnia Region",
                            value: "Central Ostrobothnia Region",
                            countryId: 26
                        },
                        {
                            stateId: 566,
                            name: "Kainuu",
                            value: "Kainuu",
                            countryId: 26
                        },
                        {
                            stateId: 575,
                            name: "Kanta-Häme",
                            value: "Kanta-Häme",
                            countryId: 26
                        },
                        {
                            stateId: 650,
                            name: "Kymenlaakso",
                            value: "Kymenlaakso",
                            countryId: 26
                        },
                        {
                            stateId: 677,
                            name: "Lapland",
                            value: "Lapland",
                            countryId: 26
                        },
                        {
                            stateId: 867,
                            name: "North Karelia",
                            value: "North Karelia",
                            countryId: 26
                        },
                        {
                            stateId: 868,
                            name: "North Ostrobothnia Region",
                            value: "North Ostrobothnia Region",
                            countryId: 26
                        },
                        {
                            stateId: 873,
                            name: "Northern Savo",
                            value: "Northern Savo",
                            countryId: 26
                        },
                        {
                            stateId: 913,
                            name: "Ostrobothnia Region",
                            value: "Ostrobothnia Region",
                            countryId: 26
                        },
                        {
                            stateId: 922,
                            name: "Päijänne Tavastia",
                            value: "Päijänne Tavastia",
                            countryId: 26
                        },
                        {
                            stateId: 958,
                            name: "Pirkanmaa",
                            value: "Pirkanmaa",
                            countryId: 26
                        },
                        {
                            stateId: 1142,
                            name: "Satakunta",
                            value: "Satakunta",
                            countryId: 26
                        },
                        {
                            stateId: 1197,
                            name: "South Karelia",
                            value: "South Karelia",
                            countryId: 26
                        },
                        {
                            stateId: 1198,
                            name: "South Ostrobothnia Region",
                            value: "South Ostrobothnia Region",
                            countryId: 26
                        },
                        {
                            stateId: 1202,
                            name: "Southern Savonia",
                            value: "Southern Savonia",
                            countryId: 26
                        },
                        {
                            stateId: 1204,
                            name: "Southwest Finland",
                            value: "Southwest Finland",
                            countryId: 26
                        },
                        {
                            stateId: 1325,
                            name: "Uusimaa",
                            value: "Uusimaa",
                            countryId: 26
                        }
                    ]
                },
                {
                    countryId: 27,
                    code: "FR",
                    name: "France",
                    value: "France",
                    states: [
                        {
                            stateId: 88,
                            name: "Auvergne-Rhône-Alpes",
                            value: "Auvergne-Rhône-Alpes",
                            countryId: 27
                        },
                        {
                            stateId: 158,
                            name: "Bourgogne-Franche-Comté",
                            value: "Bourgogne-Franche-Comté",
                            countryId: 27
                        },
                        {
                            stateId: 168,
                            name: "Bretagne",
                            value: "Bretagne",
                            countryId: 27
                        },
                        {
                            stateId: 233,
                            name: "Centre-Val de Loire",
                            value: "Centre-Val de Loire",
                            countryId: 27
                        },
                        {
                            stateId: 288,
                            name: "Corse",
                            value: "Corse",
                            countryId: 27
                        },
                        {
                            stateId: 425,
                            name: "Grand Est",
                            value: "Grand Est",
                            countryId: 27
                        },
                        {
                            stateId: 466,
                            name: "Hauts-de-France",
                            value: "Hauts-de-France",
                            countryId: 27
                        },
                        {
                            stateId: 510,
                            name: "Île-de-France",
                            value: "Île-de-France",
                            countryId: 27
                        },
                        {
                            stateId: 861,
                            name: "Normandie",
                            value: "Normandie",
                            countryId: 27
                        },
                        {
                            stateId: 877,
                            name: "Nouvelle-Aquitaine",
                            value: "Nouvelle-Aquitaine",
                            countryId: 27
                        },
                        {
                            stateId: 884,
                            name: "Occitanie",
                            value: "Occitanie",
                            countryId: 27
                        },
                        {
                            stateId: 937,
                            name: "Pays de la Loire",
                            value: "Pays de la Loire",
                            countryId: 27
                        },
                        {
                            stateId: 980,
                            name: "Provence-Alpes-Côte d'Azur",
                            value: "Provence-Alpes-Côte d'Azur",
                            countryId: 27
                        }
                    ]
                },
                {
                    countryId: 28,
                    code: "GF",
                    name: "French Guiana",
                    value: "French Guiana",
                    states: [
                        {
                            stateId: 450,
                            name: "Guyane",
                            value: "Guyane",
                            countryId: 28
                        }
                    ]
                },
                {
                    countryId: 172,
                    code: "PF",
                    name: "French Polynesia",
                    value: "French Polynesia",
                    states: [
                        {
                            stateId: 1619,
                            name: "Papeete",
                            value: "Papeete",
                            countryId: 172
                        }
                    ]
                },
                {
                    countryId: 173,
                    code: "TF",
                    name: "French Southern Territories",
                    value: "French Southern Territories",
                    states: [
                        {
                            stateId: 1620,
                            name: "Saint Pierre, Réunion",
                            value: "Saint Pierre, Réunion",
                            countryId: 173
                        }
                    ]
                },
                {
                    countryId: 174,
                    code: "GA",
                    name: "Gabon",
                    value: "Gabon",
                    states: [
                        {
                            stateId: 1621,
                            name: "Gabon",
                            value: "Gabon",
                            countryId: 174
                        }
                    ]
                },
                {
                    countryId: 175,
                    code: "GM",
                    name: "Gambia",
                    value: "Gambia",
                    states: [
                        {
                            stateId: 1622,
                            name: "Banjul",
                            value: "Banjul",
                            countryId: 175
                        }
                    ]
                },
                {
                    countryId: 176,
                    code: "GE",
                    name: "Georgia",
                    value: "Georgia",
                    states: [
                        {
                            stateId: 1623,
                            name: "Tbilisi",
                            value: "Tbilisi",
                            countryId: 176
                        }
                    ]
                },
                {
                    countryId: 29,
                    code: "DE",
                    name: "Germany",
                    value: "Germany",
                    states: [
                        {
                            stateId: 95,
                            name: "Baden-Württemberg",
                            value: "Baden-Württemberg",
                            countryId: 29
                        },
                        {
                            stateId: 126,
                            name: "Bayern",
                            value: "Bayern",
                            countryId: 29
                        },
                        {
                            stateId: 132,
                            name: "Berlin",
                            value: "Berlin",
                            countryId: 29
                        },
                        {
                            stateId: 163,
                            name: "Brandenburg",
                            value: "Brandenburg",
                            countryId: 29
                        },
                        {
                            stateId: 166,
                            name: "Bremen",
                            value: "Bremen",
                            countryId: 29
                        },
                        {
                            stateId: 459,
                            name: "Hamburg",
                            value: "Hamburg",
                            countryId: 29
                        },
                        {
                            stateId: 470,
                            name: "Hessen",
                            value: "Hessen",
                            countryId: 29
                        },
                        {
                            stateId: 758,
                            name: "Mecklenburg-Vorpommern",
                            value: "Mecklenburg-Vorpommern",
                            countryId: 29
                        },
                        {
                            stateId: 847,
                            name: "Niedersachsen",
                            value: "Niedersachsen",
                            countryId: 29
                        },
                        {
                            stateId: 859,
                            name: "Nordrhein-Westfalen",
                            value: "Nordrhein-Westfalen",
                            countryId: 29
                        },
                        {
                            stateId: 1046,
                            name: "Rheinland-Pfalz",
                            value: "Rheinland-Pfalz",
                            countryId: 29
                        },
                        {
                            stateId: 1077,
                            name: "Saarland",
                            value: "Saarland",
                            countryId: 29
                        },
                        {
                            stateId: 1084,
                            name: "Sachsen",
                            value: "Sachsen",
                            countryId: 29
                        },
                        {
                            stateId: 1085,
                            name: "Sachsen-Anhalt",
                            value: "Sachsen-Anhalt",
                            countryId: 29
                        },
                        {
                            stateId: 1148,
                            name: "Schleswig-Holstein",
                            value: "Schleswig-Holstein",
                            countryId: 29
                        },
                        {
                            stateId: 1262,
                            name: "Thüringen",
                            value: "Thüringen",
                            countryId: 29
                        }
                    ]
                },
                {
                    countryId: 178,
                    code: "GH",
                    name: "Ghana",
                    value: "Ghana",
                    states: [
                        {
                            stateId: 1624,
                            name: "Accra",
                            value: "Accra",
                            countryId: 178
                        }
                    ]
                },
                {
                    countryId: 179,
                    code: "GI",
                    name: "Gibraltar",
                    value: "Gibraltar",
                    states: [
                        {
                            stateId: 1625,
                            name: "Gibraltar",
                            value: "Gibraltar",
                            countryId: 179
                        }
                    ]
                },
                {
                    countryId: 180,
                    code: "GR",
                    name: "Greece",
                    value: "Greece",
                    states: [
                        {
                            stateId: 1626,
                            name: "Athens",
                            value: "Athens",
                            countryId: 180
                        }
                    ]
                },
                {
                    countryId: 30,
                    code: "GL",
                    name: "Greenland",
                    value: "Greenland",
                    states: [
                        {
                            stateId: 1627,
                            name: "Nuuk",
                            value: "Nuuk",
                            countryId: 181
                        }
                    ]
                },
                {
                    countryId: 182,
                    code: "GD",
                    name: "Grenada",
                    value: "Grenada",
                    states: [
                        {
                            stateId: 1628,
                            name: "Saint George's",
                            value: "Saint George's",
                            countryId: 182
                        }
                    ]
                },
                {
                    countryId: 31,
                    code: "GP",
                    name: "Guadeloupe",
                    value: "Guadeloupe",
                    states: [
                        {
                            stateId: 434,
                            name: "Guadeloupe",
                            value: "Guadeloupe",
                            countryId: 31
                        }
                    ]
                },
                {
                    countryId: 32,
                    code: "GU",
                    name: "Guam",
                    value: "Guam",
                    states: [
                        {
                            stateId: 433,
                            name: "Gu",
                            value: "Gu",
                            countryId: 32
                        }
                    ]
                },
                {
                    countryId: 33,
                    code: "GT",
                    name: "Guatemala",
                    value: "Guatemala",
                    states: [
                        {
                            stateId: 269,
                            name: "Ciudad de Guatemala",
                            value: "Ciudad de Guatemala",
                            countryId: 33
                        },
                        {
                            stateId: 310,
                            name: "DEPTO DE ALTA VERAPAZ",
                            value: "DEPTO DE ALTA VERAPAZ",
                            countryId: 33
                        },
                        {
                            stateId: 311,
                            name: "DEPTO DE BAJA VERAPAZ",
                            value: "DEPTO DE BAJA VERAPAZ",
                            countryId: 33
                        },
                        {
                            stateId: 312,
                            name: "DEPTO DE CHIMALTENANGO",
                            value: "DEPTO DE CHIMALTENANGO",
                            countryId: 33
                        },
                        {
                            stateId: 313,
                            name: "DEPTO DE CHIQUIMULA",
                            value: "DEPTO DE CHIQUIMULA",
                            countryId: 33
                        },
                        {
                            stateId: 314,
                            name: "DEPTO DE EL PROGRESO",
                            value: "DEPTO DE EL PROGRESO",
                            countryId: 33
                        },
                        {
                            stateId: 315,
                            name: "DEPTO DE ESCUINTLA",
                            value: "DEPTO DE ESCUINTLA",
                            countryId: 33
                        },
                        {
                            stateId: 316,
                            name: "DEPTO DE GUATEMALA",
                            value: "DEPTO DE GUATEMALA",
                            countryId: 33
                        },
                        {
                            stateId: 317,
                            name: "DEPTO DE HUEHUETENANGO",
                            value: "DEPTO DE HUEHUETENANGO",
                            countryId: 33
                        },
                        {
                            stateId: 318,
                            name: "DEPTO DE IZABAL",
                            value: "DEPTO DE IZABAL",
                            countryId: 33
                        },
                        {
                            stateId: 319,
                            name: "DEPTO DE JALAPA",
                            value: "DEPTO DE JALAPA",
                            countryId: 33
                        },
                        {
                            stateId: 320,
                            name: "DEPTO DE JUTIAPA",
                            value: "DEPTO DE JUTIAPA",
                            countryId: 33
                        },
                        {
                            stateId: 321,
                            name: "DEPTO DE PETEN",
                            value: "DEPTO DE PETEN",
                            countryId: 33
                        },
                        {
                            stateId: 322,
                            name: "DEPTO DE QUETZALTENANGO",
                            value: "DEPTO DE QUETZALTENANGO",
                            countryId: 33
                        },
                        {
                            stateId: 323,
                            name: "DEPTO DE RETALHULEU",
                            value: "DEPTO DE RETALHULEU",
                            countryId: 33
                        },
                        {
                            stateId: 324,
                            name: "DEPTO DE SACATEPEQUEZ",
                            value: "DEPTO DE SACATEPEQUEZ",
                            countryId: 33
                        },
                        {
                            stateId: 325,
                            name: "DEPTO DE SAN MARCOS",
                            value: "DEPTO DE SAN MARCOS",
                            countryId: 33
                        },
                        {
                            stateId: 326,
                            name: "DEPTO DE SANTA ROSA",
                            value: "DEPTO DE SANTA ROSA",
                            countryId: 33
                        },
                        {
                            stateId: 327,
                            name: "DEPTO DE SOLOLA",
                            value: "DEPTO DE SOLOLA",
                            countryId: 33
                        },
                        {
                            stateId: 328,
                            name: "DEPTO DE SUCHITEPEQUEZ",
                            value: "DEPTO DE SUCHITEPEQUEZ",
                            countryId: 33
                        },
                        {
                            stateId: 329,
                            name: "DEPTO DE TOTONICAPAN",
                            value: "DEPTO DE TOTONICAPAN",
                            countryId: 33
                        },
                        {
                            stateId: 330,
                            name: "DEPTO DE ZACAPA",
                            value: "DEPTO DE ZACAPA",
                            countryId: 33
                        },
                        {
                            stateId: 331,
                            name: "DEPTO DEL QUICHE",
                            value: "DEPTO DEL QUICHE",
                            countryId: 33
                        }
                    ]
                },
                {
                    countryId: 34,
                    code: "GG",
                    name: "Guernsey",
                    value: "Guernsey",
                    states: [
                        {
                            stateId: 1629,
                            name: "Saint Peter Port",
                            value: "Saint Peter Port",
                            countryId: 34
                        }
                    ]
                },
                {
                    countryId: 187,
                    code: "GN",
                    name: "Guinea",
                    value: "Guinea",
                    states: [
                        {
                            stateId: 1630,
                            name: "Conakry",
                            value: "Conakry",
                            countryId: 187
                        }
                    ]
                },
                {
                    countryId: 188,
                    code: "GW",
                    name: "Guinea-Bissau",
                    value: "Guinea-Bissau",
                    states: [
                        {
                            stateId: 1631,
                            name: "Bissau",
                            value: "Bissau",
                            countryId: 188
                        }
                    ]
                },
                {
                    countryId: 189,
                    code: "GY",
                    name: "Guyana",
                    value: "Guyana",
                    states: [
                        {
                            stateId: 1632,
                            name: "Georgetown",
                            value: "Georgetown",
                            countryId: 189
                        }
                    ]
                },
                {
                    countryId: 190,
                    code: "HT",
                    name: "Haiti",
                    value: "Haiti",
                    states: [
                        {
                            stateId: 1633,
                            name: "Port-au-Prince",
                            value: "Port-au-Prince",
                            countryId: 190
                        }
                    ]
                },
                {
                    countryId: 193,
                    code: "HN",
                    name: "Honduras",
                    value: "Honduras",
                    states: [
                        {
                            stateId: 1634,
                            name: "Tegucigalpa",
                            value: "Tegucigalpa",
                            countryId: 193
                        }
                    ]
                },
                {
                    countryId: 194,
                    code: "HK",
                    name: "Hong Kong",
                    value: "Hong Kong",
                    states: [
                        {
                            stateId: 1635,
                            name: "Hong Kong",
                            value: "Hong Kong",
                            countryId: 194
                        }
                    ]
                },
                {
                    countryId: 35,
                    code: "HU",
                    name: "Hungary",
                    value: "Hungary",
                    states: [
                        {
                            stateId: 94,
                            name: "Bács-Kiskun",
                            value: "Bács-Kiskun",
                            countryId: 35
                        },
                        {
                            stateId: 114,
                            name: "Baranya",
                            value: "Baranya",
                            countryId: 35
                        },
                        {
                            stateId: 130,
                            name: "Békés",
                            value: "Békés",
                            countryId: 35
                        },
                        {
                            stateId: 153,
                            name: "Borsod-Abaúj-Zemplén",
                            value: "Borsod-Abaúj-Zemplén",
                            countryId: 35
                        },
                        {
                            stateId: 175,
                            name: "Budapest",
                            value: "Budapest",
                            countryId: 35
                        },
                        {
                            stateId: 295,
                            name: "Csongrád",
                            value: "Csongrád",
                            countryId: 35
                        },
                        {
                            stateId: 386,
                            name: "Fejér",
                            value: "Fejér",
                            countryId: 35
                        },
                        {
                            stateId: 451,
                            name: "Győr-Moson-Sopron",
                            value: "Győr-Moson-Sopron",
                            countryId: 35
                        },
                        {
                            stateId: 456,
                            name: "Hajdú-Bihar",
                            value: "Hajdú-Bihar",
                            countryId: 35
                        },
                        {
                            stateId: 471,
                            name: "Heves",
                            value: "Heves",
                            countryId: 35
                        },
                        {
                            stateId: 545,
                            name: "Jász-Nagykun-Szolnok",
                            value: "Jász-Nagykun-Szolnok",
                            countryId: 35
                        },
                        {
                            stateId: 629,
                            name: "Komárom-Esztergom",
                            value: "Komárom-Esztergom",
                            countryId: 35
                        },
                        {
                            stateId: 852,
                            name: "Nógrád",
                            value: "Nógrád",
                            countryId: 35
                        },
                        {
                            stateId: 946,
                            name: "Pest",
                            value: "Pest",
                            countryId: 35
                        },
                        {
                            stateId: 1187,
                            name: "Somogy",
                            value: "Somogy",
                            countryId: 35
                        },
                        {
                            stateId: 1229,
                            name: "Szabolcs-Szatmár-Bereg",
                            value: "Szabolcs-Szatmár-Bereg",
                            countryId: 35
                        },
                        {
                            stateId: 1284,
                            name: "Tolna",
                            value: "Tolna",
                            countryId: 35
                        },
                        {
                            stateId: 1338,
                            name: "Vas",
                            value: "Vas",
                            countryId: 35
                        },
                        {
                            stateId: 1355,
                            name: "Veszprém",
                            value: "Veszprém",
                            countryId: 35
                        },
                        {
                            stateId: 1422,
                            name: "Zala",
                            value: "Zala",
                            countryId: 35
                        }
                    ]
                },
                {
                    countryId: 36,
                    code: "IS",
                    name: "Iceland",
                    value: "Iceland",
                    states: [
                        {
                            stateId: 1636,
                            name: "Reykjavík",
                            value: "Reykjavík",
                            countryId: 36
                        }
                    ]
                },
                {
                    countryId: 1,
                    code: "IN",
                    name: "India",
                    value: "India",
                    states: [
                        {
                            stateId: 1740,
                            name: "New Delhi",
                            value: "New Delhi",
                            countryId: 1
                        }
                    ]
                },
                {
                    countryId: 198,
                    code: "ID",
                    name: "Indonesia",
                    value: "Indonesia",
                    states: [
                        {
                            stateId: 1637,
                            name: "Jakarta",
                            value: "Jakarta",
                            countryId: 198
                        }
                    ]
                },
                {
                    countryId: 200,
                    code: "IR",
                    name: "Iran (Islamic Republic of)",
                    value: "Iran (Islamic Republic of)",
                    states: [
                        {
                            stateId: 1638,
                            name: "Tehran",
                            value: "Tehran",
                            countryId: 200
                        }
                    ]
                },
                {
                    countryId: 201,
                    code: "IQ",
                    name: "Iraq",
                    value: "Iraq",
                    states: [
                        {
                            stateId: 1639,
                            name: "Baghdad",
                            value: "Baghdad",
                            countryId: 201
                        }
                    ]
                },
                {
                    countryId: 38,
                    code: "IE",
                    name: "Ireland",
                    value: "Ireland",
                    states: [
                        {
                            stateId: 1640,
                            name: "Dublin",
                            value: "Dublin",
                            countryId: 38
                        }
                    ]
                },
                {
                    countryId: 39,
                    code: "IM",
                    name: "Isle Of Man",
                    value: "Isle Of Man",
                    states: [
                        {
                            stateId: 1641,
                            name: "Douglas",
                            value: "Douglas",
                            countryId: 39
                        }
                    ]
                },
                {
                    countryId: 204,
                    code: "IL",
                    name: "Israel",
                    value: "Israel",
                    states: [
                        {
                            stateId: 1642,
                            name: "Jerusalem",
                            value: "Jerusalem",
                            countryId: 204
                        }
                    ]
                },
                {
                    countryId: 40,
                    code: "IT",
                    name: "Italy",
                    value: "Italy",
                    states: [
                        {
                            stateId: 3,
                            name: "Abruzzi",
                            value: "Abruzzi",
                            countryId: 40
                        },
                        {
                            stateId: 119,
                            name: "Basilicata",
                            value: "Basilicata",
                            countryId: 40
                        },
                        {
                            stateId: 188,
                            name: "Calabria",
                            value: "Calabria",
                            countryId: 40
                        },
                        {
                            stateId: 194,
                            name: "Campania",
                            value: "Campania",
                            countryId: 40
                        },
                        {
                            stateId: 367,
                            name: "Emilia-Romagna",
                            value: "Emilia-Romagna",
                            countryId: 40
                        },
                        {
                            stateId: 396,
                            name: "Friuli-Venezia Giulia",
                            value: "Friuli-Venezia Giulia",
                            countryId: 40
                        },
                        {
                            stateId: 682,
                            name: "Lazio",
                            value: "Lazio",
                            countryId: 40
                        },
                        {
                            stateId: 692,
                            name: "Liguria",
                            value: "Liguria",
                            countryId: 40
                        },
                        {
                            stateId: 700,
                            name: "Lombardia",
                            value: "Lombardia",
                            countryId: 40
                        },
                        {
                            stateId: 736,
                            name: "Marche",
                            value: "Marche",
                            countryId: 40
                        },
                        {
                            stateId: 790,
                            name: "Molise",
                            value: "Molise",
                            countryId: 40
                        },
                        {
                            stateId: 957,
                            name: "Piemonte",
                            value: "Piemonte",
                            countryId: 40
                        },
                        {
                            stateId: 992,
                            name: "Puglia",
                            value: "Puglia",
                            countryId: 40
                        },
                        {
                            stateId: 1140,
                            name: "Sardegna",
                            value: "Sardegna",
                            countryId: 40
                        },
                        {
                            stateId: 1162,
                            name: "Sicilia",
                            value: "Sicilia",
                            countryId: 40
                        },
                        {
                            stateId: 1285,
                            name: "Toscana",
                            value: "Toscana",
                            countryId: 40
                        },
                        {
                            stateId: 1294,
                            name: "Trentino-Alto Adige",
                            value: "Trentino-Alto Adige",
                            countryId: 40
                        },
                        {
                            stateId: 1312,
                            name: "Umbria",
                            value: "Umbria",
                            countryId: 40
                        },
                        {
                            stateId: 1331,
                            name: "Valle D'Aosta",
                            value: "Valle D'Aosta",
                            countryId: 40
                        },
                        {
                            stateId: 1349,
                            name: "Veneto",
                            value: "Veneto",
                            countryId: 40
                        }
                    ]
                },
                {
                    countryId: 206,
                    code: "JM",
                    name: "Jamaica",
                    value: "Jamaica",
                    states: [
                        {
                            stateId: 1643,
                            name: "Kingston",
                            value: "Kingston",
                            countryId: 206
                        }
                    ]
                },
                {
                    countryId: 41,
                    code: "JP",
                    name: "Japan",
                    value: "Japan",
                    states: [
                        {
                            stateId: 25,
                            name: "Aichi Ken",
                            value: "Aichi Ken",
                            countryId: 41
                        },
                        {
                            stateId: 31,
                            name: "Akita Ken",
                            value: "Akita Ken",
                            countryId: 41
                        },
                        {
                            stateId: 63,
                            name: "Aomori Ken",
                            value: "Aomori Ken",
                            countryId: 41
                        },
                        {
                            stateId: 252,
                            name: "Chiba Ken",
                            value: "Chiba Ken",
                            countryId: 41
                        },
                        {
                            stateId: 362,
                            name: "Ehime Ken",
                            value: "Ehime Ken",
                            countryId: 41
                        },
                        {
                            stateId: 397,
                            name: "Fukui Ken",
                            value: "Fukui Ken",
                            countryId: 41
                        },
                        {
                            stateId: 398,
                            name: "Fukuoka Ken",
                            value: "Fukuoka Ken",
                            countryId: 41
                        },
                        {
                            stateId: 399,
                            name: "Fukushima Ken",
                            value: "Fukushima Ken",
                            countryId: 41
                        },
                        {
                            stateId: 411,
                            name: "Gifu Ken",
                            value: "Gifu Ken",
                            countryId: 41
                        },
                        {
                            stateId: 447,
                            name: "Gumma Ken",
                            value: "Gumma Ken",
                            countryId: 41
                        },
                        {
                            stateId: 476,
                            name: "Hiroshima Ken",
                            value: "Hiroshima Ken",
                            countryId: 41
                        },
                        {
                            stateId: 478,
                            name: "Hokkaido",
                            value: "Hokkaido",
                            countryId: 41
                        },
                        {
                            stateId: 485,
                            name: "Hyogo Ken",
                            value: "Hyogo Ken",
                            countryId: 41
                        },
                        {
                            stateId: 489,
                            name: "Ibaraki Ken",
                            value: "Ibaraki Ken",
                            countryId: 41
                        },
                        {
                            stateId: 526,
                            name: "Ishikawa Ken",
                            value: "Ishikawa Ken",
                            countryId: 41
                        },
                        {
                            stateId: 532,
                            name: "Iwate Ken",
                            value: "Iwate Ken",
                            countryId: 41
                        },
                        {
                            stateId: 563,
                            name: "Kagawa Ken",
                            value: "Kagawa Ken",
                            countryId: 41
                        },
                        {
                            stateId: 564,
                            name: "Kagoshima Ken",
                            value: "Kagoshima Ken",
                            countryId: 41
                        },
                        {
                            stateId: 570,
                            name: "Kanagawa Ken",
                            value: "Kanagawa Ken",
                            countryId: 41
                        },
                        {
                            stateId: 627,
                            name: "Kochi Ken",
                            value: "Kochi Ken",
                            countryId: 41
                        },
                        {
                            stateId: 645,
                            name: "Kumamoto Ken",
                            value: "Kumamoto Ken",
                            countryId: 41
                        },
                        {
                            stateId: 651,
                            name: "Kyoto Fu",
                            value: "Kyoto Fu",
                            countryId: 41
                        },
                        {
                            stateId: 774,
                            name: "Mie Ken",
                            value: "Mie Ken",
                            countryId: 41
                        },
                        {
                            stateId: 784,
                            name: "Miyagi Ken",
                            value: "Miyagi Ken",
                            countryId: 41
                        },
                        {
                            stateId: 785,
                            name: "Miyazaki Ken",
                            value: "Miyazaki Ken",
                            countryId: 41
                        },
                        {
                            stateId: 811,
                            name: "Nagano Ken",
                            value: "Nagano Ken",
                            countryId: 41
                        },
                        {
                            stateId: 812,
                            name: "Nagasaki Ken",
                            value: "Nagasaki Ken",
                            countryId: 41
                        },
                        {
                            stateId: 821,
                            name: "Nara Ken",
                            value: "Nara Ken",
                            countryId: 41
                        },
                        {
                            stateId: 849,
                            name: "Niigata Ken",
                            value: "Niigata Ken",
                            countryId: 41
                        },
                        {
                            stateId: 891,
                            name: "Oita Ken",
                            value: "Oita Ken",
                            countryId: 41
                        },
                        {
                            stateId: 892,
                            name: "Okayama Ken",
                            value: "Okayama Ken",
                            countryId: 41
                        },
                        {
                            stateId: 893,
                            name: "Okinawa Ken",
                            value: "Okinawa Ken",
                            countryId: 41
                        },
                        {
                            stateId: 908,
                            name: "Osaka Fu",
                            value: "Osaka Fu",
                            countryId: 41
                        },
                        {
                            stateId: 1088,
                            name: "Saga Ken",
                            value: "Saga Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1100,
                            name: "Saitama Ken",
                            value: "Saitama Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1155,
                            name: "Shiga Ken",
                            value: "Shiga Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1156,
                            name: "Shimane Ken",
                            value: "Shimane Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1157,
                            name: "Shizuoka Ken",
                            value: "Shizuoka Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1279,
                            name: "Tochigi Ken",
                            value: "Tochigi Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1281,
                            name: "Tokushima Ken",
                            value: "Tokushima Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1282,
                            name: "Tokyo To",
                            value: "Tokyo To",
                            countryId: 41
                        },
                        {
                            stateId: 1286,
                            name: "Tottori Ken",
                            value: "Tottori Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1288,
                            name: "Toyama Ken",
                            value: "Toyama Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1383,
                            name: "Wakayama Ken",
                            value: "Wakayama Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1408,
                            name: "Yamagata Ken",
                            value: "Yamagata Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1409,
                            name: "Yamaguchi Ken",
                            value: "Yamaguchi Ken",
                            countryId: 41
                        },
                        {
                            stateId: 1410,
                            name: "Yamanashi Ken",
                            value: "Yamanashi Ken",
                            countryId: 41
                        }
                    ]
                },
                {
                    countryId: 42,
                    code: "JE",
                    name: "Jersey",
                    value: "Jersey",
                    states: [
                        {
                            stateId: 1644,
                            name: "Saint Helier",
                            value: "Saint Helier",
                            countryId: 42
                        }
                    ]
                },
                {
                    countryId: 209,
                    code: "JO",
                    name: "Jordan",
                    value: "Jordan",
                    states: [
                        {
                            stateId: 1645,
                            name: "Amman",
                            value: "Amman",
                            countryId: 209
                        }
                    ]
                },
                {
                    countryId: 210,
                    code: "KZ",
                    name: "Kazakhstan",
                    value: "Kazakhstan",
                    states: [
                        {
                            stateId: 1646,
                            name: "Nursultan",
                            value: "Nursultan",
                            countryId: 210
                        }
                    ]
                },
                {
                    countryId: 211,
                    code: "KE",
                    name: "Kenya",
                    value: "Kenya",
                    states: [
                        {
                            stateId: 1647,
                            name: "Nairobi",
                            value: "Nairobi",
                            countryId: 211
                        }
                    ]
                },
                {
                    countryId: 212,
                    code: "KI",
                    name: "Kiribati",
                    value: "Kiribati",
                    states: [
                        {
                            stateId: 1648,
                            name: "Tarawa",
                            value: "Tarawa",
                            countryId: 212
                        }
                    ]
                },
                {
                    countryId: 258,
                    code: "KP",
                    name: "Korea (Democratic People's Republic of)",
                    value: "Korea (Democratic People's Republic of)",
                    states: [
                        {
                            stateId: 1649,
                            name: "Pyongyang",
                            value: "Pyongyang",
                            countryId: 258
                        }
                    ]
                },
                {
                    countryId: 213,
                    code: "KW",
                    name: "Kuwait",
                    value: "Kuwait",
                    states: [
                        {
                            stateId: 1650,
                            name: "Kuwait City",
                            value: "Kuwait City",
                            countryId: 213
                        }
                    ]
                },
                {
                    countryId: 214,
                    code: "KG",
                    name: "Kyrgyzstan",
                    value: "Kyrgyzstan",
                    states: [
                        {
                            stateId: 1651,
                            name: "Bishkek",
                            value: "Bishkek",
                            countryId: 214
                        }
                    ]
                },
                {
                    countryId: 215,
                    code: "LA",
                    name: "Lao People's Democratic Republic",
                    value: "Lao People's Democratic Republic",
                    states: [
                        {
                            stateId: 1652,
                            name: "Vientiane",
                            value: "Vientiane",
                            countryId: 215
                        }
                    ]
                },
                {
                    countryId: 43,
                    code: "LV",
                    name: "Latvia",
                    value: "Latvia",
                    states: [
                        {
                            stateId: 8,
                            name: "Ādažu nov.",
                            value: "Ādažu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 16,
                            name: "Aglonas nov.",
                            value: "Aglonas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 28,
                            name: "Aizkraukles nov.",
                            value: "Aizkraukles nov.",
                            countryId: 43
                        },
                        {
                            stateId: 29,
                            name: "Aizputes nov.",
                            value: "Aizputes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 32,
                            name: "Aknīstes nov.",
                            value: "Aknīstes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 42,
                            name: "Alojas nov.",
                            value: "Alojas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 43,
                            name: "Alsungas nov.",
                            value: "Alsungas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 44,
                            name: "Alūksnes nov.",
                            value: "Alūksnes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 48,
                            name: "Amatas nov.",
                            value: "Amatas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 64,
                            name: "Apes nov.",
                            value: "Apes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 84,
                            name: "Auces nov.",
                            value: "Auces nov.",
                            countryId: 43
                        },
                        {
                            stateId: 92,
                            name: "Babītes nov.",
                            value: "Babītes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 101,
                            name: "Baldones nov.",
                            value: "Baldones nov.",
                            countryId: 43
                        },
                        {
                            stateId: 106,
                            name: "Baltinavas nov.",
                            value: "Baltinavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 107,
                            name: "Balvu nov.",
                            value: "Balvu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 122,
                            name: "Bauskas nov.",
                            value: "Bauskas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 133,
                            name: "Beverīnas nov.",
                            value: "Beverīnas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 171,
                            name: "Brocēnu nov.",
                            value: "Brocēnu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 181,
                            name: "Burtnieku nov.",
                            value: "Burtnieku nov.",
                            countryId: 43
                        },
                        {
                            stateId: 215,
                            name: "Carnikavas nov.",
                            value: "Carnikavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 236,
                            name: "Cēsu nov.",
                            value: "Cēsu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 237,
                            name: "Cesvaines nov.",
                            value: "Cesvaines nov.",
                            countryId: 43
                        },
                        {
                            stateId: 263,
                            name: "Ciblas nov.",
                            value: "Ciblas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 300,
                            name: "Dagdas nov.",
                            value: "Dagdas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 305,
                            name: "Daugavpils nov.",
                            value: "Daugavpils nov.",
                            countryId: 43
                        },
                        {
                            stateId: 342,
                            name: "Dobeles nov.",
                            value: "Dobeles nov.",
                            countryId: 43
                        },
                        {
                            stateId: 352,
                            name: "Dundagas nov.",
                            value: "Dundagas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 355,
                            name: "Durbes nov.",
                            value: "Durbes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 370,
                            name: "Engures nov.",
                            value: "Engures nov.",
                            countryId: 43
                        },
                        {
                            stateId: 372,
                            name: "Ērgļu nov.",
                            value: "Ērgļu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 404,
                            name: "Garkalnes nov.",
                            value: "Garkalnes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 429,
                            name: "Grobiņas nov.",
                            value: "Grobiņas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 446,
                            name: "Gulbenes nov.",
                            value: "Gulbenes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 492,
                            name: "Iecavas nov.",
                            value: "Iecavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 494,
                            name: "Ikšķiles nov.",
                            value: "Ikšķiles nov.",
                            countryId: 43
                        },
                        {
                            stateId: 515,
                            name: "Ilūkstes nov.",
                            value: "Ilūkstes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 519,
                            name: "Inčukalna nov.",
                            value: "Inčukalna nov.",
                            countryId: 43
                        },
                        {
                            stateId: 546,
                            name: "Jaunjelgavas nov.",
                            value: "Jaunjelgavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 547,
                            name: "Jaunpiebalgas nov.",
                            value: "Jaunpiebalgas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 548,
                            name: "Jaunpils nov.",
                            value: "Jaunpils nov.",
                            countryId: 43
                        },
                        {
                            stateId: 550,
                            name: "Jēkabpils nov.",
                            value: "Jēkabpils nov.",
                            countryId: 43
                        },
                        {
                            stateId: 551,
                            name: "Jelgavas nov.",
                            value: "Jelgavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 572,
                            name: "Kandavas nov.",
                            value: "Kandavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 601,
                            name: "Kārsavas nov.",
                            value: "Kārsavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 606,
                            name: "Ķeguma nov.",
                            value: "Ķeguma nov.",
                            countryId: 43
                        },
                        {
                            stateId: 607,
                            name: "Ķekavas nov.",
                            value: "Ķekavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 626,
                            name: "Kocēnu nov.",
                            value: "Kocēnu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 628,
                            name: "Kokneses nov.",
                            value: "Kokneses nov.",
                            countryId: 43
                        },
                        {
                            stateId: 638,
                            name: "Krāslavas nov.",
                            value: "Krāslavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 639,
                            name: "Krimuldas nov.",
                            value: "Krimuldas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 641,
                            name: "Krustpils nov.",
                            value: "Krustpils nov.",
                            countryId: 43
                        },
                        {
                            stateId: 644,
                            name: "Kuldīgas nov.",
                            value: "Kuldīgas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 690,
                            name: "Lielvārdes nov.",
                            value: "Lielvārdes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 691,
                            name: "Līgatnes nov.",
                            value: "Līgatnes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 694,
                            name: "Limbažu nov.",
                            value: "Limbažu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 697,
                            name: "Līvānu nov.",
                            value: "Līvānu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 704,
                            name: "Lubānas nov.",
                            value: "Lubānas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 707,
                            name: "Ludzas nov.",
                            value: "Ludzas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 718,
                            name: "Madonas nov.",
                            value: "Madonas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 727,
                            name: "Mālpils nov.",
                            value: "Mālpils nov.",
                            countryId: 43
                        },
                        {
                            stateId: 745,
                            name: "Mārupes nov.",
                            value: "Mārupes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 757,
                            name: "Mazsalacas nov.",
                            value: "Mazsalacas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 767,
                            name: "Mērsraga nov.",
                            value: "Mērsraga nov.",
                            countryId: 43
                        },
                        {
                            stateId: 825,
                            name: "Naukšēnu nov.",
                            value: "Naukšēnu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 833,
                            name: "Neretas nov.",
                            value: "Neretas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 845,
                            name: "Nīcas nov.",
                            value: "Nīcas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 888,
                            name: "Ogres nov.",
                            value: "Ogres nov.",
                            countryId: 43
                        },
                        {
                            stateId: 895,
                            name: "Olaines nov.",
                            value: "Olaines nov.",
                            countryId: 43
                        },
                        {
                            stateId: 919,
                            name: "Ozolnieku nov.",
                            value: "Ozolnieku nov.",
                            countryId: 43
                        },
                        {
                            stateId: 931,
                            name: "Pārgaujas nov.",
                            value: "Pārgaujas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 936,
                            name: "Pāvilostas nov.",
                            value: "Pāvilostas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 960,
                            name: "Pļaviņu nov.",
                            value: "Pļaviņu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 974,
                            name: "Preiļu nov.",
                            value: "Preiļu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 976,
                            name: "Priekules nov.",
                            value: "Priekules nov.",
                            countryId: 43
                        },
                        {
                            stateId: 977,
                            name: "Priekuļu nov.",
                            value: "Priekuļu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1017,
                            name: "Raunas nov.",
                            value: "Raunas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1044,
                            name: "Rēzeknes nov.",
                            value: "Rēzeknes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1049,
                            name: "Riebiņu nov.",
                            value: "Riebiņu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1065,
                            name: "Rojas nov.",
                            value: "Rojas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1067,
                            name: "Ropažu nov.",
                            value: "Ropažu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1070,
                            name: "Rucavas nov.",
                            value: "Rucavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1071,
                            name: "Rugāju nov.",
                            value: "Rugāju nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1073,
                            name: "Rūjienas nov.",
                            value: "Rūjienas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1074,
                            name: "Rundāles nov.",
                            value: "Rundāles nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1104,
                            name: "Salas nov.",
                            value: "Salas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1105,
                            name: "Salaspils nov.",
                            value: "Salaspils nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1106,
                            name: "Saldus nov.",
                            value: "Saldus nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1145,
                            name: "Saulkrastu nov.",
                            value: "Saulkrastu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1150,
                            name: "Sējas nov.",
                            value: "Sējas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1164,
                            name: "Siguldas nov.",
                            value: "Siguldas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1179,
                            name: "Skrīveru nov.",
                            value: "Skrīveru nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1180,
                            name: "Skrundas nov.",
                            value: "Skrundas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1182,
                            name: "Smiltenes nov.",
                            value: "Smiltenes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1213,
                            name: "Stopiņu nov.",
                            value: "Stopiņu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1216,
                            name: "Strenču nov.",
                            value: "Strenču nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1236,
                            name: "Talsu nov.",
                            value: "Talsu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1260,
                            name: "Tērvetes nov.",
                            value: "Tērvetes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1304,
                            name: "Tukuma nov.",
                            value: "Tukuma nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1327,
                            name: "Vaiņodes nov.",
                            value: "Vaiņodes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1330,
                            name: "Valkas nov.",
                            value: "Valkas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1334,
                            name: "Varakļānu nov.",
                            value: "Varakļānu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1336,
                            name: "Vārkavas nov.",
                            value: "Vārkavas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1345,
                            name: "Vecpiebalgas nov.",
                            value: "Vecpiebalgas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1346,
                            name: "Vecumnieku nov.",
                            value: "Vecumnieku nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1350,
                            name: "Ventspils nov.",
                            value: "Ventspils nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1363,
                            name: "Viesītes nov.",
                            value: "Viesītes nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1365,
                            name: "Viļakas nov.",
                            value: "Viļakas nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1366,
                            name: "Viļānu nov.",
                            value: "Viļānu nov.",
                            countryId: 43
                        },
                        {
                            stateId: 1428,
                            name: "Zilupes nov.",
                            value: "Zilupes nov.",
                            countryId: 43
                        }
                    ]
                },
                {
                    countryId: 217,
                    code: "LB",
                    name: "Lebanon",
                    value: "Lebanon",
                    states: [
                        {
                            stateId: 1653,
                            name: "Beirut",
                            value: "Beirut",
                            countryId: 217
                        }
                    ]
                },
                {
                    countryId: 218,
                    code: "LS",
                    name: "Lesotho",
                    value: "Lesotho",
                    states: [
                        {
                            stateId: 1654,
                            name: "Maseru",
                            value: "Maseru",
                            countryId: 218
                        }
                    ]
                },
                {
                    countryId: 219,
                    code: "LR",
                    name: "Liberia",
                    value: "Liberia",
                    states: [
                        {
                            stateId: 1655,
                            name: "Monrovia",
                            value: "Monrovia",
                            countryId: 219
                        }
                    ]
                },
                {
                    countryId: 220,
                    code: "LY",
                    name: "Libya",
                    value: "Libya",
                    states: [
                        {
                            stateId: 1741,
                            name: "Tripoli",
                            value: "Tripoli",
                            countryId: 220
                        }
                    ]
                },
                {
                    countryId: 44,
                    code: "LI",
                    name: "Liechtenstein",
                    value: "Liechtenstein",
                    states: [
                        {
                            stateId: 109,
                            name: "Balzers",
                            value: "Balzers",
                            countryId: 44
                        },
                        {
                            stateId: 377,
                            name: "Eschen",
                            value: "Eschen",
                            countryId: 44
                        },
                        {
                            stateId: 403,
                            name: "Gamprin",
                            value: "Gamprin",
                            countryId: 44
                        },
                        {
                            stateId: 753,
                            name: "Mauren",
                            value: "Mauren",
                            countryId: 44
                        },
                        {
                            stateId: 959,
                            name: "Planken",
                            value: "Planken",
                            countryId: 44
                        },
                        {
                            stateId: 1072,
                            name: "Ruggell",
                            value: "Ruggell",
                            countryId: 44
                        },
                        {
                            stateId: 1146,
                            name: "Schaan",
                            value: "Schaan",
                            countryId: 44
                        },
                        {
                            stateId: 1147,
                            name: "Schellenberg",
                            value: "Schellenberg",
                            countryId: 44
                        },
                        {
                            stateId: 1295,
                            name: "Triesen",
                            value: "Triesen",
                            countryId: 44
                        },
                        {
                            stateId: 1296,
                            name: "Triesenberg",
                            value: "Triesenberg",
                            countryId: 44
                        },
                        {
                            stateId: 1326,
                            name: "Vaduz",
                            value: "Vaduz",
                            countryId: 44
                        }
                    ]
                },
                {
                    countryId: 45,
                    code: "LT",
                    name: "Lithuania",
                    value: "Lithuania",
                    states: [
                        {
                            stateId: 45,
                            name: "Alytus County",
                            value: "Alytus County",
                            countryId: 45
                        },
                        {
                            stateId: 603,
                            name: "Kaunas County",
                            value: "Kaunas County",
                            countryId: 45
                        },
                        {
                            stateId: 624,
                            name: "Klaipėda County",
                            value: "Klaipėda County",
                            countryId: 45
                        },
                        {
                            stateId: 740,
                            name: "Marijampolė County",
                            value: "Marijampolė County",
                            countryId: 45
                        },
                        {
                            stateId: 925,
                            name: "Panevėžys",
                            value: "Panevėžys",
                            countryId: 45
                        },
                        {
                            stateId: 1159,
                            name: "Šiauliai County",
                            value: "Šiauliai County",
                            countryId: 45
                        },
                        {
                            stateId: 1247,
                            name: "Tauragė County",
                            value: "Tauragė County",
                            countryId: 45
                        },
                        {
                            stateId: 1256,
                            name: "Telšių apskritis",
                            value: "Telšių apskritis",
                            countryId: 45
                        },
                        {
                            stateId: 1318,
                            name: "Utena County",
                            value: "Utena County",
                            countryId: 45
                        },
                        {
                            stateId: 1369,
                            name: "Vilniaus apskritis",
                            value: "Vilniaus apskritis",
                            countryId: 45
                        }
                    ]
                },
                {
                    countryId: 46,
                    code: "LU",
                    name: "Luxembourg",
                    value: "Luxembourg",
                    states: [
                        {
                            stateId: 212,
                            name: "Capellen",
                            value: "Capellen",
                            countryId: 46
                        },
                        {
                            stateId: 270,
                            name: "Clervaux",
                            value: "Clervaux",
                            countryId: 46
                        },
                        {
                            stateId: 334,
                            name: "Diekirch",
                            value: "Diekirch",
                            countryId: 46
                        },
                        {
                            stateId: 359,
                            name: "Echternach",
                            value: "Echternach",
                            countryId: 46
                        },
                        {
                            stateId: 376,
                            name: "Esch-sur-Alzette",
                            value: "Esch-sur-Alzette",
                            countryId: 46
                        },
                        {
                            stateId: 427,
                            name: "Grevenmacher",
                            value: "Grevenmacher",
                            countryId: 46
                        },
                        {
                            stateId: 711,
                            name: "Luxembourg",
                            value: "Luxembourg",
                            countryId: 46
                        },
                        {
                            stateId: 765,
                            name: "Mersch",
                            value: "Mersch",
                            countryId: 46
                        },
                        {
                            stateId: 1019,
                            name: "Redange",
                            value: "Redange",
                            countryId: 46
                        },
                        {
                            stateId: 1041,
                            name: "Remich",
                            value: "Remich",
                            countryId: 46
                        },
                        {
                            stateId: 1358,
                            name: "Vianden",
                            value: "Vianden",
                            countryId: 46
                        },
                        {
                            stateId: 1397,
                            name: "Wiltz",
                            value: "Wiltz",
                            countryId: 46
                        }
                    ]
                },
                {
                    countryId: 224,
                    code: "MO",
                    name: "Macao",
                    value: "Macao",
                    states: [
                        {
                            stateId: 1656,
                            name: "Concelho de Macau",
                            value: "Concelho de Macau",
                            countryId: 224
                        }
                    ]
                },
                {
                    countryId: 226,
                    code: "MG",
                    name: "Madagascar",
                    value: "Madagascar",
                    states: [
                        {
                            stateId: 1657,
                            name: "Antananarivo",
                            value: "Antananarivo",
                            countryId: 226
                        }
                    ]
                },
                {
                    countryId: 47,
                    code: "MW",
                    name: "Malawi",
                    value: "Malawi",
                    states: [
                        {
                            stateId: 232,
                            name: "Central Region",
                            value: "Central Region",
                            countryId: 47
                        },
                        {
                            stateId: 872,
                            name: "Northern Region",
                            value: "Northern Region",
                            countryId: 47
                        },
                        {
                            stateId: 1201,
                            name: "Southern Region",
                            value: "Southern Region",
                            countryId: 47
                        }
                    ]
                },
                {
                    countryId: 48,
                    code: "MY",
                    name: "Malaysia",
                    value: "Malaysia",
                    states: [
                        {
                            stateId: 557,
                            name: "Johor",
                            value: "Johor",
                            countryId: 48
                        },
                        {
                            stateId: 605,
                            name: "Kedah",
                            value: "Kedah",
                            countryId: 48
                        },
                        {
                            stateId: 608,
                            name: "Kelantan",
                            value: "Kelantan",
                            countryId: 48
                        },
                        {
                            stateId: 642,
                            name: "Kuala Lumpur",
                            value: "Kuala Lumpur",
                            countryId: 48
                        },
                        {
                            stateId: 670,
                            name: "Labuan",
                            value: "Labuan",
                            countryId: 48
                        },
                        {
                            stateId: 762,
                            name: "Melaka",
                            value: "Melaka",
                            countryId: 48
                        },
                        {
                            stateId: 831,
                            name: "Negeri Sembilan",
                            value: "Negeri Sembilan",
                            countryId: 48
                        },
                        {
                            stateId: 921,
                            name: "Pahang",
                            value: "Pahang",
                            countryId: 48
                        },
                        {
                            stateId: 943,
                            name: "Perak",
                            value: "Perak",
                            countryId: 48
                        },
                        {
                            stateId: 944,
                            name: "Perlis",
                            value: "Perlis",
                            countryId: 48
                        },
                        {
                            stateId: 993,
                            name: "Pulau Pinang",
                            value: "Pulau Pinang",
                            countryId: 48
                        },
                        {
                            stateId: 995,
                            name: "Putrajaya",
                            value: "Putrajaya",
                            countryId: 48
                        },
                        {
                            stateId: 1079,
                            name: "Sabah",
                            value: "Sabah",
                            countryId: 48
                        },
                        {
                            stateId: 1139,
                            name: "Sarawak",
                            value: "Sarawak",
                            countryId: 48
                        },
                        {
                            stateId: 1151,
                            name: "Selangor",
                            value: "Selangor",
                            countryId: 48
                        },
                        {
                            stateId: 1258,
                            name: "Terengganu",
                            value: "Terengganu",
                            countryId: 48
                        }
                    ]
                },
                {
                    countryId: 229,
                    code: "MV",
                    name: "Maldives",
                    value: "Maldives",
                    states: [
                        {
                            stateId: 1658,
                            name: "Malé",
                            value: "Malé",
                            countryId: 229
                        }
                    ]
                },
                {
                    countryId: 230,
                    code: "ML",
                    name: "Mali",
                    value: "Mali",
                    states: [
                        {
                            stateId: 1659,
                            name: "Bamako",
                            value: "Bamako",
                            countryId: 230
                        }
                    ]
                },
                {
                    countryId: 49,
                    code: "MT",
                    name: "Malta",
                    value: "Malta",
                    states: [
                        {
                            stateId: 83,
                            name: "Attard",
                            value: "Attard",
                            countryId: 49
                        },
                        {
                            stateId: 108,
                            name: "Balzan",
                            value: "Balzan",
                            countryId: 49
                        },
                        {
                            stateId: 140,
                            name: "Birkirkara",
                            value: "Birkirkara",
                            countryId: 49
                        },
                        {
                            stateId: 141,
                            name: "Birżebbuġa",
                            value: "Birżebbuġa",
                            countryId: 49
                        },
                        {
                            stateId: 152,
                            name: "Bormla",
                            value: "Bormla",
                            countryId: 49
                        },
                        {
                            stateId: 335,
                            name: "Dingli",
                            value: "Dingli",
                            countryId: 49
                        },
                        {
                            stateId: 452,
                            name: "Għajnsielem",
                            value: "Għajnsielem",
                            countryId: 49
                        },
                        {
                            stateId: 495,
                            name: "Il-Belt Valletta",
                            value: "Il-Belt Valletta",
                            countryId: 49
                        },
                        {
                            stateId: 496,
                            name: "Il-Birgu",
                            value: "Il-Birgu",
                            countryId: 49
                        },
                        {
                            stateId: 497,
                            name: "Il-Fgura",
                            value: "Il-Fgura",
                            countryId: 49
                        },
                        {
                            stateId: 498,
                            name: "Il-Fontana",
                            value: "Il-Fontana",
                            countryId: 49
                        },
                        {
                            stateId: 499,
                            name: "Il-Furjana",
                            value: "Il-Furjana",
                            countryId: 49
                        },
                        {
                            stateId: 500,
                            name: "Il-Gudja",
                            value: "Il-Gudja",
                            countryId: 49
                        },
                        {
                            stateId: 501,
                            name: "Il-Gżira",
                            value: "Il-Gżira",
                            countryId: 49
                        },
                        {
                            stateId: 502,
                            name: "Il-Kalkara",
                            value: "Il-Kalkara",
                            countryId: 49
                        },
                        {
                            stateId: 503,
                            name: "Il-Marsa",
                            value: "Il-Marsa",
                            countryId: 49
                        },
                        {
                            stateId: 504,
                            name: "Il-Mellieħa",
                            value: "Il-Mellieħa",
                            countryId: 49
                        },
                        {
                            stateId: 505,
                            name: "Il-Mosta",
                            value: "Il-Mosta",
                            countryId: 49
                        },
                        {
                            stateId: 506,
                            name: "Il-Munxar",
                            value: "Il-Munxar",
                            countryId: 49
                        },
                        {
                            stateId: 507,
                            name: "Il-Qala",
                            value: "Il-Qala",
                            countryId: 49
                        },
                        {
                            stateId: 508,
                            name: "Il-Qrendi",
                            value: "Il-Qrendi",
                            countryId: 49
                        },
                        {
                            stateId: 509,
                            name: "Il-Ħamrun",
                            value: "Il-Ħamrun",
                            countryId: 49
                        },
                        {
                            stateId: 517,
                            name: "In-Nadur",
                            value: "In-Nadur",
                            countryId: 49
                        },
                        {
                            stateId: 518,
                            name: "In-Naxxar",
                            value: "In-Naxxar",
                            countryId: 49
                        },
                        {
                            stateId: 522,
                            name: "Ir-Rabat",
                            value: "Ir-Rabat",
                            countryId: 49
                        },
                        {
                            stateId: 523,
                            name: "Is-Siġġiewi",
                            value: "Is-Siġġiewi",
                            countryId: 49
                        },
                        {
                            stateId: 524,
                            name: "Is-Swieqi",
                            value: "Is-Swieqi",
                            countryId: 49
                        },
                        {
                            stateId: 533,
                            name: "Ix-Xagħra",
                            value: "Ix-Xagħra",
                            countryId: 49
                        },
                        {
                            stateId: 534,
                            name: "Ix-Xewkija",
                            value: "Ix-Xewkija",
                            countryId: 49
                        },
                        {
                            stateId: 535,
                            name: "Ix-Xgħajra",
                            value: "Ix-Xgħajra",
                            countryId: 49
                        },
                        {
                            stateId: 536,
                            name: "Iż-Żebbuġ",
                            value: "Iż-Żebbuġ",
                            countryId: 49
                        },
                        {
                            stateId: 537,
                            name: "Iż-Żejtun",
                            value: "Iż-Żejtun",
                            countryId: 49
                        },
                        {
                            stateId: 538,
                            name: "Iż-Żurrieq",
                            value: "Iż-Żurrieq",
                            countryId: 49
                        },
                        {
                            stateId: 620,
                            name: "Kirkop",
                            value: "Kirkop",
                            countryId: 49
                        },
                        {
                            stateId: 653,
                            name: "L-Għarb",
                            value: "L-Għarb",
                            countryId: 49
                        },
                        {
                            stateId: 654,
                            name: "L-Għasri",
                            value: "L-Għasri",
                            countryId: 49
                        },
                        {
                            stateId: 655,
                            name: "L-Iklin",
                            value: "L-Iklin",
                            countryId: 49
                        },
                        {
                            stateId: 656,
                            name: "L-Imdina",
                            value: "L-Imdina",
                            countryId: 49
                        },
                        {
                            stateId: 657,
                            name: "L-Imġarr",
                            value: "L-Imġarr",
                            countryId: 49
                        },
                        {
                            stateId: 658,
                            name: "L-Imqabba",
                            value: "L-Imqabba",
                            countryId: 49
                        },
                        {
                            stateId: 659,
                            name: "L-Imsida",
                            value: "L-Imsida",
                            countryId: 49
                        },
                        {
                            stateId: 660,
                            name: "L-Imtarfa",
                            value: "L-Imtarfa",
                            countryId: 49
                        },
                        {
                            stateId: 661,
                            name: "L-Isla",
                            value: "L-Isla",
                            countryId: 49
                        },
                        {
                            stateId: 693,
                            name: "Lija",
                            value: "Lija",
                            countryId: 49
                        },
                        {
                            stateId: 709,
                            name: "Luqa",
                            value: "Luqa",
                            countryId: 49
                        },
                        {
                            stateId: 742,
                            name: "Marsaskala",
                            value: "Marsaskala",
                            countryId: 49
                        },
                        {
                            stateId: 743,
                            name: "Marsaxlokk",
                            value: "Marsaxlokk",
                            countryId: 49
                        },
                        {
                            stateId: 926,
                            name: "Paola",
                            value: "Paola",
                            countryId: 49
                        },
                        {
                            stateId: 939,
                            name: "Pembroke",
                            value: "Pembroke",
                            countryId: 49
                        },
                        {
                            stateId: 1000,
                            name: "Qormi",
                            value: "Qormi",
                            countryId: 49
                        },
                        {
                            stateId: 1087,
                            name: "Safi",
                            value: "Safi",
                            countryId: 49
                        },
                        {
                            stateId: 1092,
                            name: "Saint John",
                            value: "Saint John",
                            countryId: 49
                        },
                        {
                            stateId: 1093,
                            name: "Saint Julian's",
                            value: "Saint Julian's",
                            countryId: 49
                        },
                        {
                            stateId: 1094,
                            name: "Saint Lawrence",
                            value: "Saint Lawrence",
                            countryId: 49
                        },
                        {
                            stateId: 1095,
                            name: "Saint Lucia",
                            value: "Saint Lucia",
                            countryId: 49
                        },
                        {
                            stateId: 1096,
                            name: "Saint Paul’s Bay",
                            value: "Saint Paul’s Bay",
                            countryId: 49
                        },
                        {
                            stateId: 1097,
                            name: "Saint Venera",
                            value: "Saint Venera",
                            countryId: 49
                        },
                        {
                            stateId: 1128,
                            name: "Sannat",
                            value: "Sannat",
                            countryId: 49
                        },
                        {
                            stateId: 1235,
                            name: "Tal-Pietà",
                            value: "Tal-Pietà",
                            countryId: 49
                        },
                        {
                            stateId: 1243,
                            name: "Tarxien",
                            value: "Tarxien",
                            countryId: 49
                        },
                        {
                            stateId: 1244,
                            name: "Tas-Sliema",
                            value: "Tas-Sliema",
                            countryId: 49
                        },
                        {
                            stateId: 1248,
                            name: "Ta’ Kerċem",
                            value: "Ta’ Kerċem",
                            countryId: 49
                        },
                        {
                            stateId: 1249,
                            name: "Ta’ Xbiex",
                            value: "Ta’ Xbiex",
                            countryId: 49
                        },
                        {
                            stateId: 1361,
                            name: "Victoria",
                            value: "Victoria",
                            countryId: 49
                        },
                        {
                            stateId: 1435,
                            name: "Ħal Għargħur",
                            value: "Ħal Għargħur",
                            countryId: 49
                        },
                        {
                            stateId: 1436,
                            name: "Ħal Għaxaq",
                            value: "Ħal Għaxaq",
                            countryId: 49
                        },
                        {
                            stateId: 1437,
                            name: "Ħaż-Żabbar",
                            value: "Ħaż-Żabbar",
                            countryId: 49
                        },
                        {
                            stateId: 1438,
                            name: "Ħaż-Żebbuġ",
                            value: "Ħaż-Żebbuġ",
                            countryId: 49
                        }
                    ]
                },
                {
                    countryId: 50,
                    code: "MH",
                    name: "Marshall Islands",
                    value: "Marshall Islands",
                    states: [
                        {
                            stateId: 771,
                            name: "Mh",
                            value: "Mh",
                            countryId: 50
                        }
                    ]
                },
                {
                    countryId: 51,
                    code: "MQ",
                    name: "Martinique",
                    value: "Martinique",
                    states: [
                        {
                            stateId: 744,
                            name: "Martinique",
                            value: "Martinique",
                            countryId: 51
                        }
                    ]
                },
                {
                    countryId: 234,
                    code: "MR",
                    name: "Mauritania",
                    value: "Mauritania",
                    states: [
                        {
                            stateId: 1660,
                            name: "Nouakchott",
                            value: "Nouakchott",
                            countryId: 234
                        }
                    ]
                },
                {
                    countryId: 235,
                    code: "MU",
                    name: "Mauritius",
                    value: "Mauritius",
                    states: [
                        {
                            stateId: 1661,
                            name: "Port Louis",
                            value: "Port Louis",
                            countryId: 235
                        }
                    ]
                },
                {
                    countryId: 52,
                    code: "YT",
                    name: "Mayotte",
                    value: "Mayotte",
                    states: [
                        {
                            stateId: 5,
                            name: "Acoua",
                            value: "Acoua",
                            countryId: 52
                        },
                        {
                            stateId: 110,
                            name: "Bandraboua",
                            value: "Bandraboua",
                            countryId: 52
                        },
                        {
                            stateId: 111,
                            name: "Bandrele",
                            value: "Bandrele",
                            countryId: 52
                        },
                        {
                            stateId: 155,
                            name: "Bouéni",
                            value: "Bouéni",
                            countryId: 52
                        },
                        {
                            stateId: 253,
                            name: "Chiconi",
                            value: "Chiconi",
                            countryId: 52
                        },
                        {
                            stateId: 255,
                            name: "Chirongui",
                            value: "Chirongui",
                            countryId: 52
                        },
                        {
                            stateId: 308,
                            name: "Dembeni",
                            value: "Dembeni",
                            countryId: 52
                        },
                        {
                            stateId: 357,
                            name: "Dzaoudzi",
                            value: "Dzaoudzi",
                            countryId: 52
                        },
                        {
                            stateId: 573,
                            name: "Kani-Kéli",
                            value: "Kani-Kéli",
                            countryId: 52
                        },
                        {
                            stateId: 633,
                            name: "Koungou",
                            value: "Koungou",
                            countryId: 52
                        },
                        {
                            stateId: 715,
                            name: "M'Tsangamouji",
                            value: "M'Tsangamouji",
                            countryId: 52
                        },
                        {
                            stateId: 728,
                            name: "Mamoudzou",
                            value: "Mamoudzou",
                            countryId: 52
                        },
                        {
                            stateId: 755,
                            name: "Mayotte (general)",
                            value: "Mayotte (general)",
                            countryId: 52
                        },
                        {
                            stateId: 798,
                            name: "Mtsamboro",
                            value: "Mtsamboro",
                            countryId: 52
                        },
                        {
                            stateId: 915,
                            name: "Ouangani",
                            value: "Ouangani",
                            countryId: 52
                        },
                        {
                            stateId: 924,
                            name: "Pamandzi",
                            value: "Pamandzi",
                            countryId: 52
                        },
                        {
                            stateId: 1086,
                            name: "Sada",
                            value: "Sada",
                            countryId: 52
                        },
                        {
                            stateId: 1302,
                            name: "Tsingoni",
                            value: "Tsingoni",
                            countryId: 52
                        }
                    ]
                },
                {
                    countryId: 53,
                    code: "MX",
                    name: "Mexico",
                    value: "Mexico",
                    states: [
                        {
                            stateId: 23,
                            name: "Aguascalientes",
                            value: "Aguascalientes",
                            countryId: 53
                        },
                        {
                            stateId: 97,
                            name: "Baja California",
                            value: "Baja California",
                            countryId: 53
                        },
                        {
                            stateId: 98,
                            name: "Baja California Sur",
                            value: "Baja California Sur",
                            countryId: 53
                        },
                        {
                            stateId: 195,
                            name: "Campeche",
                            value: "Campeche",
                            countryId: 53
                        },
                        {
                            stateId: 251,
                            name: "Chiapas",
                            value: "Chiapas",
                            countryId: 53
                        },
                        {
                            stateId: 254,
                            name: "Chihuahua",
                            value: "Chihuahua",
                            countryId: 53
                        },
                        {
                            stateId: 272,
                            name: "Coahuila de Zaragoza",
                            value: "Coahuila de Zaragoza",
                            countryId: 53
                        },
                        {
                            stateId: 275,
                            name: "Colima",
                            value: "Colima",
                            countryId: 53
                        },
                        {
                            stateId: 338,
                            name: "Distrito Federal",
                            value: "Distrito Federal",
                            countryId: 53
                        },
                        {
                            stateId: 353,
                            name: "Durango",
                            value: "Durango",
                            countryId: 53
                        },
                        {
                            stateId: 436,
                            name: "Guanajuato",
                            value: "Guanajuato",
                            countryId: 53
                        },
                        {
                            stateId: 444,
                            name: "Guerrero",
                            value: "Guerrero",
                            countryId: 53
                        },
                        {
                            stateId: 472,
                            name: "Hidalgo",
                            value: "Hidalgo",
                            countryId: 53
                        },
                        {
                            stateId: 540,
                            name: "Jalisco",
                            value: "Jalisco",
                            countryId: 53
                        },
                        {
                            stateId: 769,
                            name: "México",
                            value: "México",
                            countryId: 53
                        },
                        {
                            stateId: 773,
                            name: "Michoacán de Ocampo",
                            value: "Michoacán de Ocampo",
                            countryId: 53
                        },
                        {
                            stateId: 795,
                            name: "Morelos",
                            value: "Morelos",
                            countryId: 53
                        },
                        {
                            stateId: 827,
                            name: "Nayarit",
                            value: "Nayarit",
                            countryId: 53
                        },
                        {
                            stateId: 879,
                            name: "Nuevo León",
                            value: "Nuevo León",
                            countryId: 53
                        },
                        {
                            stateId: 882,
                            name: "Oaxaca",
                            value: "Oaxaca",
                            countryId: 53
                        },
                        {
                            stateId: 991,
                            name: "Puebla",
                            value: "Puebla",
                            countryId: 53
                        },
                        {
                            stateId: 1006,
                            name: "Querétaro",
                            value: "Querétaro",
                            countryId: 53
                        },
                        {
                            stateId: 1008,
                            name: "Quintana Roo",
                            value: "Quintana Roo",
                            countryId: 53
                        },
                        {
                            stateId: 1124,
                            name: "San Luis Potosí",
                            value: "San Luis Potosí",
                            countryId: 53
                        },
                        {
                            stateId: 1168,
                            name: "Sinaloa",
                            value: "Sinaloa",
                            countryId: 53
                        },
                        {
                            stateId: 1189,
                            name: "Sonora",
                            value: "Sonora",
                            countryId: 53
                        },
                        {
                            stateId: 1232,
                            name: "Tabasco",
                            value: "Tabasco",
                            countryId: 53
                        },
                        {
                            stateId: 1238,
                            name: "Tamaulipas",
                            value: "Tamaulipas",
                            countryId: 53
                        },
                        {
                            stateId: 1274,
                            name: "Tlaxcala",
                            value: "Tlaxcala",
                            countryId: 53
                        },
                        {
                            stateId: 1351,
                            name: "Veracruz de Ignacio de la Llave",
                            value: "Veracruz de Ignacio de la Llave",
                            countryId: 53
                        },
                        {
                            stateId: 1416,
                            name: "Yucatán",
                            value: "Yucatán",
                            countryId: 53
                        },
                        {
                            stateId: 1418,
                            name: "Zacatecas",
                            value: "Zacatecas",
                            countryId: 53
                        }
                    ]
                },
                {
                    countryId: 54,
                    code: "FM",
                    name: "Micronesia",
                    value: "Micronesia",
                    states: [
                        {
                            stateId: 1206,
                            name: "State of Chuuk",
                            value: "State of Chuuk",
                            countryId: 54
                        },
                        {
                            stateId: 1207,
                            name: "State of Kosrae",
                            value: "State of Kosrae",
                            countryId: 54
                        },
                        {
                            stateId: 1208,
                            name: "State of Pohnpei",
                            value: "State of Pohnpei",
                            countryId: 54
                        },
                        {
                            stateId: 1209,
                            name: "State of Yap",
                            value: "State of Yap",
                            countryId: 54
                        }
                    ]
                },
                {
                    countryId: 55,
                    code: "MD",
                    name: "Moldova",
                    value: "Moldova",
                    states: [
                        {
                            stateId: 57,
                            name: "Anenii Noi",
                            value: "Anenii Noi",
                            countryId: 55
                        },
                        {
                            stateId: 105,
                            name: "Balti",
                            value: "Balti",
                            countryId: 55
                        },
                        {
                            stateId: 131,
                            name: "Bender Tr.",
                            value: "Bender Tr.",
                            countryId: 55
                        },
                        {
                            stateId: 169,
                            name: "Briceni",
                            value: "Briceni",
                            countryId: 55
                        },
                        {
                            stateId: 187,
                            name: "Cahul",
                            value: "Cahul",
                            countryId: 55
                        },
                        {
                            stateId: 189,
                            name: "Calarasi",
                            value: "Calarasi",
                            countryId: 55
                        },
                        {
                            stateId: 193,
                            name: "Camenca Tr.",
                            value: "Camenca Tr.",
                            countryId: 55
                        },
                        {
                            stateId: 204,
                            name: "Cantemir",
                            value: "Cantemir",
                            countryId: 55
                        },
                        {
                            stateId: 210,
                            name: "Cantrmir",
                            value: "Cantrmir",
                            countryId: 55
                        },
                        {
                            stateId: 211,
                            name: "Canul",
                            value: "Canul",
                            countryId: 55
                        },
                        {
                            stateId: 225,
                            name: "Causeni",
                            value: "Causeni",
                            countryId: 55
                        },
                        {
                            stateId: 265,
                            name: "Cimislia",
                            value: "Cimislia",
                            countryId: 55
                        },
                        {
                            stateId: 279,
                            name: "Comrat",
                            value: "Comrat",
                            countryId: 55
                        },
                        {
                            stateId: 291,
                            name: "Criuleni",
                            value: "Criuleni",
                            countryId: 55
                        },
                        {
                            stateId: 292,
                            name: "Criuleni- Dub.",
                            value: "Criuleni- Dub.",
                            countryId: 55
                        },
                        {
                            stateId: 293,
                            name: "Criuleni-Dub.",
                            value: "Criuleni-Dub.",
                            countryId: 55
                        },
                        {
                            stateId: 294,
                            name: "Criulenii-Dub.",
                            value: "Criulenii-Dub.",
                            countryId: 55
                        },
                        {
                            stateId: 344,
                            name: "Donduseni",
                            value: "Donduseni",
                            countryId: 55
                        },
                        {
                            stateId: 348,
                            name: "Drochia",
                            value: "Drochia",
                            countryId: 55
                        },
                        {
                            stateId: 349,
                            name: "Dubasari Cr.",
                            value: "Dubasari Cr.",
                            countryId: 55
                        },
                        {
                            stateId: 350,
                            name: "Dubasari Tr.",
                            value: "Dubasari Tr.",
                            countryId: 55
                        },
                        {
                            stateId: 360,
                            name: "Edinet",
                            value: "Edinet",
                            countryId: 55
                        },
                        {
                            stateId: 383,
                            name: "Falesti",
                            value: "Falesti",
                            countryId: 55
                        },
                        {
                            stateId: 390,
                            name: "Floresti",
                            value: "Floresti",
                            countryId: 55
                        },
                        {
                            stateId: 415,
                            name: "Glodeni",
                            value: "Glodeni",
                            countryId: 55
                        },
                        {
                            stateId: 428,
                            name: "Grigoriopol Tr.",
                            value: "Grigoriopol Tr.",
                            countryId: 55
                        },
                        {
                            stateId: 475,
                            name: "Hincesti",
                            value: "Hincesti",
                            countryId: 55
                        },
                        {
                            stateId: 487,
                            name: "Ialoveni",
                            value: "Ialoveni",
                            countryId: 55
                        },
                        {
                            stateId: 683,
                            name: "Lazo",
                            value: "Lazo",
                            countryId: 55
                        },
                        {
                            stateId: 685,
                            name: "Leova",
                            value: "Leova",
                            countryId: 55
                        },
                        {
                            stateId: 801,
                            name: "Mun.Balti",
                            value: "Mun.Balti",
                            countryId: 55
                        },
                        {
                            stateId: 802,
                            name: "Mun.Chisinau",
                            value: "Mun.Chisinau",
                            countryId: 55
                        },
                        {
                            stateId: 850,
                            name: "Nisporeni",
                            value: "Nisporeni",
                            countryId: 55
                        },
                        {
                            stateId: 885,
                            name: "Ocnita",
                            value: "Ocnita",
                            countryId: 55
                        },
                        {
                            stateId: 906,
                            name: "Orhei",
                            value: "Orhei",
                            countryId: 55
                        },
                        {
                            stateId: 1045,
                            name: "Rezina",
                            value: "Rezina",
                            countryId: 55
                        },
                        {
                            stateId: 1048,
                            name: "Ribnita Tr.",
                            value: "Ribnita Tr.",
                            countryId: 55
                        },
                        {
                            stateId: 1058,
                            name: "Riscani",
                            value: "Riscani",
                            countryId: 55
                        },
                        {
                            stateId: 1170,
                            name: "Singerei",
                            value: "Singerei",
                            countryId: 55
                        },
                        {
                            stateId: 1181,
                            name: "Slobozia Tr.",
                            value: "Slobozia Tr.",
                            countryId: 55
                        },
                        {
                            stateId: 1186,
                            name: "Soldanesti",
                            value: "Soldanesti",
                            countryId: 55
                        },
                        {
                            stateId: 1191,
                            name: "Soroca",
                            value: "Soroca",
                            countryId: 55
                        },
                        {
                            stateId: 1210,
                            name: "Stefan-Voda",
                            value: "Stefan-Voda",
                            countryId: 55
                        },
                        {
                            stateId: 1214,
                            name: "Straseni",
                            value: "Straseni",
                            countryId: 55
                        },
                        {
                            stateId: 1240,
                            name: "Taraclia",
                            value: "Taraclia",
                            countryId: 55
                        },
                        {
                            stateId: 1254,
                            name: "Telenesti",
                            value: "Telenesti",
                            countryId: 55
                        },
                        {
                            stateId: 1270,
                            name: "Tiraspol Tr.",
                            value: "Tiraspol Tr.",
                            countryId: 55
                        },
                        {
                            stateId: 1311,
                            name: "Uhnheni",
                            value: "Uhnheni",
                            countryId: 55
                        },
                        {
                            stateId: 1313,
                            name: "Ungheni",
                            value: "Ungheni",
                            countryId: 55
                        }
                    ]
                },
                {
                    countryId: 56,
                    code: "MC",
                    name: "Monaco",
                    value: "Monaco",
                    states: [
                        {
                            stateId: 791,
                            name: "Monaco",
                            value: "Monaco",
                            countryId: 56
                        }
                    ]
                },
                {
                    countryId: 241,
                    code: "MN",
                    name: "Mongolia",
                    value: "Mongolia",
                    states: [
                        {
                            stateId: 1662,
                            name: "Ulaanbaatar",
                            value: "Ulaanbaatar",
                            countryId: 241
                        }
                    ]
                },
                {
                    countryId: 242,
                    code: "ME",
                    name: "Montenegro",
                    value: "Montenegro",
                    states: [
                        {
                            stateId: 1663,
                            name: "Podgorica",
                            value: "Podgorica",
                            countryId: 242
                        }
                    ]
                },
                {
                    countryId: 243,
                    code: "MS",
                    name: "Montserrat",
                    value: "Montserrat",
                    states: [
                        {
                            stateId: 1664,
                            name: "Brades",
                            value: "Brades",
                            countryId: 243
                        }
                    ]
                },
                {
                    countryId: 244,
                    code: "MA",
                    name: "Morocco",
                    value: "Morocco",
                    states: [
                        {
                            stateId: 1665,
                            name: "Rabat",
                            value: "Rabat",
                            countryId: 244
                        }
                    ]
                },
                {
                    countryId: 245,
                    code: "MZ",
                    name: "Mozambique",
                    value: "Mozambique",
                    states: [
                        {
                            stateId: 1666,
                            name: "Maputo",
                            value: "Maputo",
                            countryId: 245
                        }
                    ]
                },
                {
                    countryId: 246,
                    code: "MM",
                    name: "Myanmar",
                    value: "Myanmar",
                    states: [
                        {
                            stateId: 1667,
                            name: "Nay Pyi Taw",
                            value: "Nay Pyi Taw",
                            countryId: 246
                        }
                    ]
                },
                {
                    countryId: 247,
                    code: "NA",
                    name: "Namibia",
                    value: "Namibia",
                    states: [
                        {
                            stateId: 1668,
                            name: "Windhoek",
                            value: "Windhoek",
                            countryId: 247
                        }
                    ]
                },
                {
                    countryId: 248,
                    code: "NR",
                    name: "Nauru",
                    value: "Nauru",
                    states: [
                        {
                            stateId: 1669,
                            name: "Yaren",
                            value: "Yaren",
                            countryId: 248
                        }
                    ]
                },
                {
                    countryId: 249,
                    code: "NP",
                    name: "Nepal",
                    value: "Nepal",
                    states: [
                        {
                            stateId: 1670,
                            name: "Kathmandu",
                            value: "Kathmandu",
                            countryId: 249
                        }
                    ]
                },
                {
                    countryId: 57,
                    code: "NL",
                    name: "Netherlands",
                    value: "Netherlands",
                    states: [
                        {
                            stateId: 347,
                            name: "Drenthe",
                            value: "Drenthe",
                            countryId: 57
                        },
                        {
                            stateId: 388,
                            name: "Flevoland",
                            value: "Flevoland",
                            countryId: 57
                        },
                        {
                            stateId: 395,
                            name: "Friesland",
                            value: "Friesland",
                            countryId: 57
                        },
                        {
                            stateId: 407,
                            name: "Gelderland",
                            value: "Gelderland",
                            countryId: 57
                        },
                        {
                            stateId: 431,
                            name: "Groningen",
                            value: "Groningen",
                            countryId: 57
                        },
                        {
                            stateId: 695,
                            name: "Limburg",
                            value: "Limburg",
                            countryId: 57
                        },
                        {
                            stateId: 856,
                            name: "Noord-Brabant",
                            value: "Noord-Brabant",
                            countryId: 57
                        },
                        {
                            stateId: 857,
                            name: "Noord-Holland",
                            value: "Noord-Holland",
                            countryId: 57
                        },
                        {
                            stateId: 918,
                            name: "Overijssel",
                            value: "Overijssel",
                            countryId: 57
                        },
                        {
                            stateId: 1320,
                            name: "Utrecht",
                            value: "Utrecht",
                            countryId: 57
                        },
                        {
                            stateId: 1425,
                            name: "Zeeland",
                            value: "Zeeland",
                            countryId: 57
                        },
                        {
                            stateId: 1431,
                            name: "Zuid-Holland",
                            value: "Zuid-Holland",
                            countryId: 57
                        }
                    ]
                },
                {
                    countryId: 58,
                    code: "NC",
                    name: "New Caledonia",
                    value: "New Caledonia",
                    states: [
                        {
                            stateId: 511,
                            name: "Îles Loyauté",
                            value: "Îles Loyauté",
                            countryId: 58
                        },
                        {
                            stateId: 981,
                            name: "Province Nord",
                            value: "Province Nord",
                            countryId: 58
                        },
                        {
                            stateId: 983,
                            name: "Province Sud",
                            value: "Province Sud",
                            countryId: 58
                        }
                    ]
                },
                {
                    countryId: 59,
                    code: "NZ",
                    name: "New Zealand",
                    value: "New Zealand",
                    states: [
                        {
                            stateId: 85,
                            name: "Auckland",
                            value: "Auckland",
                            countryId: 59
                        },
                        {
                            stateId: 123,
                            name: "Bay of Plenty",
                            value: "Bay of Plenty",
                            countryId: 59
                        },
                        {
                            stateId: 205,
                            name: "Canterbury",
                            value: "Canterbury",
                            countryId: 59
                        },
                        {
                            stateId: 413,
                            name: "Gisborne",
                            value: "Gisborne",
                            countryId: 59
                        },
                        {
                            stateId: 468,
                            name: "Hawke's Bay",
                            value: "Hawke's Bay",
                            countryId: 59
                        },
                        {
                            stateId: 730,
                            name: "Manawatu-Wanganui",
                            value: "Manawatu-Wanganui",
                            countryId: 59
                        },
                        {
                            stateId: 741,
                            name: "Marlborough",
                            value: "Marlborough",
                            countryId: 59
                        },
                        {
                            stateId: 832,
                            name: "Nelson",
                            value: "Nelson",
                            countryId: 59
                        },
                        {
                            stateId: 875,
                            name: "Northland",
                            value: "Northland",
                            countryId: 59
                        },
                        {
                            stateId: 914,
                            name: "Otago",
                            value: "Otago",
                            countryId: 59
                        },
                        {
                            stateId: 1203,
                            name: "Southland",
                            value: "Southland",
                            countryId: 59
                        },
                        {
                            stateId: 1241,
                            name: "Taranaki",
                            value: "Taranaki",
                            countryId: 59
                        },
                        {
                            stateId: 1245,
                            name: "Tasman",
                            value: "Tasman",
                            countryId: 59
                        },
                        {
                            stateId: 1382,
                            name: "Waikato",
                            value: "Waikato",
                            countryId: 59
                        },
                        {
                            stateId: 1389,
                            name: "Wellington",
                            value: "Wellington",
                            countryId: 59
                        },
                        {
                            stateId: 1391,
                            name: "West Coast",
                            value: "West Coast",
                            countryId: 59
                        }
                    ]
                },
                {
                    countryId: 253,
                    code: "NI",
                    name: "Nicaragua",
                    value: "Nicaragua",
                    states: [
                        {
                            stateId: 1671,
                            name: "Managua",
                            value: "Managua",
                            countryId: 253
                        }
                    ]
                },
                {
                    countryId: 254,
                    code: "NE",
                    name: "Niger",
                    value: "Niger",
                    states: [
                        {
                            stateId: 1672,
                            name: "Niamey",
                            value: "Niamey",
                            countryId: 254
                        }
                    ]
                },
                {
                    countryId: 255,
                    code: "NG",
                    name: "Nigeria",
                    value: "Nigeria",
                    states: [
                        {
                            stateId: 1673,
                            name: "Abuja",
                            value: "Abuja",
                            countryId: 255
                        }
                    ]
                },
                {
                    countryId: 256,
                    code: "NU",
                    name: "Niue",
                    value: "Niue",
                    states: [
                        {
                            stateId: 1674,
                            name: "Alofi",
                            value: "Alofi",
                            countryId: 256
                        }
                    ]
                },
                {
                    countryId: 257,
                    code: "NF",
                    name: "Norfolk Island",
                    value: "Norfolk Island",
                    states: [
                        {
                            stateId: 1675,
                            name: "Kingston",
                            value: "Kingston",
                            countryId: 257
                        }
                    ]
                },
                {
                    countryId: 60,
                    code: "MK",
                    name: "North Macedonia",
                    value: "North Macedonia",
                    states: [
                        {
                            stateId: 1676,
                            name: "Skopje",
                            value: "Skopje",
                            countryId: 60
                        }
                    ]
                },
                {
                    countryId: 61,
                    code: "MP",
                    name: "Northern Mariana Islands",
                    value: "Northern Mariana Islands",
                    states: [
                        {
                            stateId: 1069,
                            name: "Rota",
                            value: "Rota",
                            countryId: 61
                        },
                        {
                            stateId: 1099,
                            name: "Saipan",
                            value: "Saipan",
                            countryId: 61
                        },
                        {
                            stateId: 1268,
                            name: "Tinian",
                            value: "Tinian",
                            countryId: 61
                        }
                    ]
                },
                {
                    countryId: 62,
                    code: "NO",
                    name: "Norway",
                    value: "Norway",
                    states: [
                        {
                            stateId: 30,
                            name: "Akershus",
                            value: "Akershus",
                            countryId: 62
                        },
                        {
                            stateId: 86,
                            name: "Aust-Agder",
                            value: "Aust-Agder",
                            countryId: 62
                        },
                        {
                            stateId: 182,
                            name: "Buskerud",
                            value: "Buskerud",
                            countryId: 62
                        },
                        {
                            stateId: 387,
                            name: "Finnmark",
                            value: "Finnmark",
                            countryId: 62
                        },
                        {
                            stateId: 469,
                            name: "Hedmark",
                            value: "Hedmark",
                            countryId: 62
                        },
                        {
                            stateId: 479,
                            name: "Hordaland",
                            value: "Hordaland",
                            countryId: 62
                        },
                        {
                            stateId: 807,
                            name: "Møre og Romsdal",
                            value: "Møre og Romsdal",
                            countryId: 62
                        },
                        {
                            stateId: 858,
                            name: "Nordland",
                            value: "Nordland",
                            countryId: 62
                        },
                        {
                            stateId: 900,
                            name: "Oppland",
                            value: "Oppland",
                            countryId: 62
                        },
                        {
                            stateId: 910,
                            name: "Oslo County",
                            value: "Oslo County",
                            countryId: 62
                        },
                        {
                            stateId: 1063,
                            name: "Rogaland",
                            value: "Rogaland",
                            countryId: 62
                        },
                        {
                            stateId: 1185,
                            name: "Sogn og Fjordane",
                            value: "Sogn og Fjordane",
                            countryId: 62
                        },
                        {
                            stateId: 1253,
                            name: "Telemark",
                            value: "Telemark",
                            countryId: 62
                        },
                        {
                            stateId: 1299,
                            name: "Troms",
                            value: "Troms",
                            countryId: 62
                        },
                        {
                            stateId: 1301,
                            name: "Trøndelag",
                            value: "Trøndelag",
                            countryId: 62
                        },
                        {
                            stateId: 1353,
                            name: "Vest-Agder",
                            value: "Vest-Agder",
                            countryId: 62
                        },
                        {
                            stateId: 1354,
                            name: "Vestfold",
                            value: "Vestfold",
                            countryId: 62
                        },
                        {
                            stateId: 1434,
                            name: "Østfold",
                            value: "Østfold",
                            countryId: 62
                        }
                    ]
                },
                {
                    countryId: 261,
                    code: "OM",
                    name: "Oman",
                    value: "Oman",
                    states: [
                        {
                            stateId: 1677,
                            name: "Muscat",
                            value: "Muscat",
                            countryId: 261
                        }
                    ]
                },
                {
                    countryId: 63,
                    code: "PK",
                    name: "Pakistan",
                    value: "Pakistan",
                    states: [
                        {
                            stateId: 104,
                            name: "Balochisan",
                            value: "Balochisan",
                            countryId: 63
                        },
                        {
                            stateId: 385,
                            name: "Federal Capial &AJK",
                            value: "Federal Capial &AJK",
                            countryId: 63
                        },
                        {
                            stateId: 484,
                            name: "Hyderabad",
                            value: "Hyderabad",
                            countryId: 63
                        },
                        {
                            stateId: 672,
                            name: "Lahore",
                            value: "Lahore",
                            countryId: 63
                        },
                        {
                            stateId: 860,
                            name: "Norhern Punajb Rawalpindi",
                            value: "Norhern Punajb Rawalpindi",
                            countryId: 63
                        },
                        {
                            stateId: 881,
                            name: "NWFP Peshawar",
                            value: "NWFP Peshawar",
                            countryId: 63
                        },
                        {
                            stateId: 1192,
                            name: "Souhern Punajb Mulan",
                            value: "Souhern Punajb Mulan",
                            countryId: 63
                        }
                    ]
                },
                {
                    countryId: 64,
                    code: "PW",
                    name: "Palau",
                    value: "Palau",
                    states: [
                        {
                            stateId: 1678,
                            name: "Melekeok",
                            value: "Melekeok",
                            countryId: 64
                        }
                    ]
                },
                {
                    countryId: 264,
                    code: "PS",
                    name: "Palestine, State of",
                    value: "Palestine, State of",
                    states: [
                        {
                            stateId: 1679,
                            name: "Ramallah",
                            value: "Ramallah",
                            countryId: 264
                        }
                    ]
                },
                {
                    countryId: 265,
                    code: "PA",
                    name: "Panama",
                    value: "Panama",
                    states: [
                        {
                            stateId: 1680,
                            name: "Panama City",
                            value: "Panama City",
                            countryId: 265
                        }
                    ]
                },
                {
                    countryId: 266,
                    code: "PG",
                    name: "Papua New Guinea",
                    value: "Papua New Guinea",
                    states: [
                        {
                            stateId: 1681,
                            name: "Port Moresby",
                            value: "Port Moresby",
                            countryId: 266
                        }
                    ]
                },
                {
                    countryId: 267,
                    code: "PY",
                    name: "Paraguay",
                    value: "Paraguay",
                    states: [
                        {
                            stateId: 1682,
                            name: "Asunción",
                            value: "Asunción",
                            countryId: 267
                        }
                    ]
                },
                {
                    countryId: 268,
                    code: "PE",
                    name: "Peru",
                    value: "Peru",
                    states: [
                        {
                            stateId: 1683,
                            name: "Lima",
                            value: "Lima",
                            countryId: 268
                        }
                    ]
                },
                {
                    countryId: 65,
                    code: "PH",
                    name: "Philippines",
                    value: "Philippines",
                    states: [
                        {
                            stateId: 1684,
                            name: "Manila",
                            value: "Manila",
                            countryId: 65
                        }
                    ]
                },
                {
                    countryId: 270,
                    code: "PN",
                    name: "Pitcairn",
                    value: "Pitcairn",
                    states: [
                        {
                            stateId: 1685,
                            name: "Adamstown",
                            value: "Adamstown",
                            countryId: 270
                        }
                    ]
                },
                {
                    countryId: 66,
                    code: "PL",
                    name: "Poland",
                    value: "Poland",
                    states: [
                        {
                            stateId: 426,
                            name: "Greater Poland",
                            value: "Greater Poland",
                            countryId: 66
                        },
                        {
                            stateId: 643,
                            name: "Kujawsko-Pomorskie",
                            value: "Kujawsko-Pomorskie",
                            countryId: 66
                        },
                        {
                            stateId: 687,
                            name: "Lesser Poland",
                            value: "Lesser Poland",
                            countryId: 66
                        },
                        {
                            stateId: 703,
                            name: "Lower Silesia",
                            value: "Lower Silesia",
                            countryId: 66
                        },
                        {
                            stateId: 705,
                            name: "Lublin",
                            value: "Lublin",
                            countryId: 66
                        },
                        {
                            stateId: 706,
                            name: "Lubusz",
                            value: "Lubusz",
                            countryId: 66
                        },
                        {
                            stateId: 756,
                            name: "Mazovia",
                            value: "Mazovia",
                            countryId: 66
                        },
                        {
                            stateId: 899,
                            name: "Opole Voivodeship",
                            value: "Opole Voivodeship",
                            countryId: 66
                        },
                        {
                            stateId: 962,
                            name: "Podlasie",
                            value: "Podlasie",
                            countryId: 66
                        },
                        {
                            stateId: 965,
                            name: "Pomerania",
                            value: "Pomerania",
                            countryId: 66
                        },
                        {
                            stateId: 1167,
                            name: "Silesia",
                            value: "Silesia",
                            countryId: 66
                        },
                        {
                            stateId: 1217,
                            name: "Subcarpathia",
                            value: "Subcarpathia",
                            countryId: 66
                        },
                        {
                            stateId: 1227,
                            name: "Świętokrzyskie",
                            value: "Świętokrzyskie",
                            countryId: 66
                        },
                        {
                            stateId: 1386,
                            name: "Warmia-Masuria",
                            value: "Warmia-Masuria",
                            countryId: 66
                        },
                        {
                            stateId: 1392,
                            name: "West Pomerania",
                            value: "West Pomerania",
                            countryId: 66
                        },
                        {
                            stateId: 1439,
                            name: "Łódź Voivodeship",
                            value: "Łódź Voivodeship",
                            countryId: 66
                        }
                    ]
                },
                {
                    countryId: 67,
                    code: "PT",
                    name: "Portugal",
                    value: "Portugal",
                    states: [
                        {
                            stateId: 89,
                            name: "Aveiro",
                            value: "Aveiro",
                            countryId: 67
                        },
                        {
                            stateId: 91,
                            name: "Azores",
                            value: "Azores",
                            countryId: 67
                        },
                        {
                            stateId: 128,
                            name: "Beja",
                            value: "Beja",
                            countryId: 67
                        },
                        {
                            stateId: 160,
                            name: "Braga",
                            value: "Braga",
                            countryId: 67
                        },
                        {
                            stateId: 161,
                            name: "Bragança",
                            value: "Bragança",
                            countryId: 67
                        },
                        {
                            stateId: 218,
                            name: "Castelo Branco",
                            value: "Castelo Branco",
                            countryId: 67
                        },
                        {
                            stateId: 274,
                            name: "Coimbra",
                            value: "Coimbra",
                            countryId: 67
                        },
                        {
                            stateId: 380,
                            name: "Évora",
                            value: "Évora",
                            countryId: 67
                        },
                        {
                            stateId: 384,
                            name: "Faro",
                            value: "Faro",
                            countryId: 67
                        },
                        {
                            stateId: 438,
                            name: "Guarda",
                            value: "Guarda",
                            countryId: 67
                        },
                        {
                            stateId: 684,
                            name: "Leiria",
                            value: "Leiria",
                            countryId: 67
                        },
                        {
                            stateId: 696,
                            name: "Lisboa",
                            value: "Lisboa",
                            countryId: 67
                        },
                        {
                            stateId: 716,
                            name: "Madeira",
                            value: "Madeira",
                            countryId: 67
                        },
                        {
                            stateId: 968,
                            name: "Portalegre",
                            value: "Portalegre",
                            countryId: 67
                        },
                        {
                            stateId: 969,
                            name: "Porto",
                            value: "Porto",
                            countryId: 67
                        },
                        {
                            stateId: 1135,
                            name: "Santarém",
                            value: "Santarém",
                            countryId: 67
                        },
                        {
                            stateId: 1154,
                            name: "Setúbal",
                            value: "Setúbal",
                            countryId: 67
                        },
                        {
                            stateId: 1357,
                            name: "Viana do Castelo",
                            value: "Viana do Castelo",
                            countryId: 67
                        },
                        {
                            stateId: 1364,
                            name: "Vila Real",
                            value: "Vila Real",
                            countryId: 67
                        },
                        {
                            stateId: 1373,
                            name: "Viseu",
                            value: "Viseu",
                            countryId: 67
                        }
                    ]
                },
                {
                    countryId: 68,
                    code: "PR",
                    name: "Puerto Rico",
                    value: "Puerto Rico",
                    states: [
                        {
                            stateId: 10,
                            name: "Adjuntas",
                            value: "Adjuntas",
                            countryId: 68
                        },
                        {
                            stateId: 20,
                            name: "Aguada",
                            value: "Aguada",
                            countryId: 68
                        },
                        {
                            stateId: 21,
                            name: "Aguadilla",
                            value: "Aguadilla",
                            countryId: 68
                        },
                        {
                            stateId: 22,
                            name: "Aguas Buenas",
                            value: "Aguas Buenas",
                            countryId: 68
                        },
                        {
                            stateId: 24,
                            name: "Aibonito",
                            value: "Aibonito",
                            countryId: 68
                        },
                        {
                            stateId: 52,
                            name: "Anasco",
                            value: "Anasco",
                            countryId: 68
                        },
                        {
                            stateId: 70,
                            name: "Arecibo",
                            value: "Arecibo",
                            countryId: 68
                        },
                        {
                            stateId: 74,
                            name: "Arroyo",
                            value: "Arroyo",
                            countryId: 68
                        },
                        {
                            stateId: 115,
                            name: "Barceloneta",
                            value: "Barceloneta",
                            countryId: 68
                        },
                        {
                            stateId: 117,
                            name: "Barranquitas",
                            value: "Barranquitas",
                            countryId: 68
                        },
                        {
                            stateId: 124,
                            name: "Bayamon",
                            value: "Bayamon",
                            countryId: 68
                        },
                        {
                            stateId: 185,
                            name: "Cabo Rojo",
                            value: "Cabo Rojo",
                            countryId: 68
                        },
                        {
                            stateId: 186,
                            name: "Caguas",
                            value: "Caguas",
                            countryId: 68
                        },
                        {
                            stateId: 196,
                            name: "Camuy",
                            value: "Camuy",
                            countryId: 68
                        },
                        {
                            stateId: 202,
                            name: "Canovanas",
                            value: "Canovanas",
                            countryId: 68
                        },
                        {
                            stateId: 216,
                            name: "Carolina",
                            value: "Carolina",
                            countryId: 68
                        },
                        {
                            stateId: 223,
                            name: "Catano",
                            value: "Catano",
                            countryId: 68
                        },
                        {
                            stateId: 226,
                            name: "Cayey",
                            value: "Cayey",
                            countryId: 68
                        },
                        {
                            stateId: 228,
                            name: "Ceiba",
                            value: "Ceiba",
                            countryId: 68
                        },
                        {
                            stateId: 262,
                            name: "Ciales",
                            value: "Ciales",
                            countryId: 68
                        },
                        {
                            stateId: 264,
                            name: "Cidra",
                            value: "Cidra",
                            countryId: 68
                        },
                        {
                            stateId: 273,
                            name: "Coamo",
                            value: "Coamo",
                            countryId: 68
                        },
                        {
                            stateId: 278,
                            name: "Comerio",
                            value: "Comerio",
                            countryId: 68
                        },
                        {
                            stateId: 286,
                            name: "Corozal",
                            value: "Corozal",
                            countryId: 68
                        },
                        {
                            stateId: 296,
                            name: "Culebra",
                            value: "Culebra",
                            countryId: 68
                        },
                        {
                            stateId: 346,
                            name: "Dorado",
                            value: "Dorado",
                            countryId: 68
                        },
                        {
                            stateId: 382,
                            name: "Fajardo",
                            value: "Fajardo",
                            countryId: 68
                        },
                        {
                            stateId: 391,
                            name: "Florida",
                            value: "Florida",
                            countryId: 68
                        },
                        {
                            stateId: 437,
                            name: "Guanica",
                            value: "Guanica",
                            countryId: 68
                        },
                        {
                            stateId: 440,
                            name: "Guayama",
                            value: "Guayama",
                            countryId: 68
                        },
                        {
                            stateId: 441,
                            name: "Guayanilla",
                            value: "Guayanilla",
                            countryId: 68
                        },
                        {
                            stateId: 442,
                            name: "Guaynabo",
                            value: "Guaynabo",
                            countryId: 68
                        },
                        {
                            stateId: 449,
                            name: "Gurabo",
                            value: "Gurabo",
                            countryId: 68
                        },
                        {
                            stateId: 465,
                            name: "Hatillo",
                            value: "Hatillo",
                            countryId: 68
                        },
                        {
                            stateId: 480,
                            name: "Hormigueros",
                            value: "Hormigueros",
                            countryId: 68
                        },
                        {
                            stateId: 482,
                            name: "Humacao",
                            value: "Humacao",
                            countryId: 68
                        },
                        {
                            stateId: 525,
                            name: "Isabela",
                            value: "Isabela",
                            countryId: 68
                        },
                        {
                            stateId: 549,
                            name: "Jayuya",
                            value: "Jayuya",
                            countryId: 68
                        },
                        {
                            stateId: 559,
                            name: "Juana Diaz",
                            value: "Juana Diaz",
                            countryId: 68
                        },
                        {
                            stateId: 561,
                            name: "Juncos",
                            value: "Juncos",
                            countryId: 68
                        },
                        {
                            stateId: 673,
                            name: "Lajas",
                            value: "Lajas",
                            countryId: 68
                        },
                        {
                            stateId: 678,
                            name: "Lares",
                            value: "Lares",
                            countryId: 68
                        },
                        {
                            stateId: 679,
                            name: "Las Marias",
                            value: "Las Marias",
                            countryId: 68
                        },
                        {
                            stateId: 680,
                            name: "Las Piedras",
                            value: "Las Piedras",
                            countryId: 68
                        },
                        {
                            stateId: 699,
                            name: "Loiza",
                            value: "Loiza",
                            countryId: 68
                        },
                        {
                            stateId: 710,
                            name: "Luquillo",
                            value: "Luquillo",
                            countryId: 68
                        },
                        {
                            stateId: 729,
                            name: "Manati",
                            value: "Manati",
                            countryId: 68
                        },
                        {
                            stateId: 738,
                            name: "Maricao",
                            value: "Maricao",
                            countryId: 68
                        },
                        {
                            stateId: 752,
                            name: "Maunabo",
                            value: "Maunabo",
                            countryId: 68
                        },
                        {
                            stateId: 754,
                            name: "Mayaguez",
                            value: "Mayaguez",
                            countryId: 68
                        },
                        {
                            stateId: 787,
                            name: "Moca",
                            value: "Moca",
                            countryId: 68
                        },
                        {
                            stateId: 796,
                            name: "Morovis",
                            value: "Morovis",
                            countryId: 68
                        },
                        {
                            stateId: 813,
                            name: "Naguabo",
                            value: "Naguabo",
                            countryId: 68
                        },
                        {
                            stateId: 822,
                            name: "Naranjito",
                            value: "Naranjito",
                            countryId: 68
                        },
                        {
                            stateId: 907,
                            name: "Orocovis",
                            value: "Orocovis",
                            countryId: 68
                        },
                        {
                            stateId: 934,
                            name: "Patillas",
                            value: "Patillas",
                            countryId: 68
                        },
                        {
                            stateId: 942,
                            name: "Penuelas",
                            value: "Penuelas",
                            countryId: 68
                        },
                        {
                            stateId: 966,
                            name: "Ponce",
                            value: "Ponce",
                            countryId: 68
                        },
                        {
                            stateId: 1004,
                            name: "Quebradillas",
                            value: "Quebradillas",
                            countryId: 68
                        },
                        {
                            stateId: 1050,
                            name: "Rincon",
                            value: "Rincon",
                            countryId: 68
                        },
                        {
                            stateId: 1052,
                            name: "Rio Grande",
                            value: "Rio Grande",
                            countryId: 68
                        },
                        {
                            stateId: 1080,
                            name: "Sabana Grande",
                            value: "Sabana Grande",
                            countryId: 68
                        },
                        {
                            stateId: 1107,
                            name: "Salinas",
                            value: "Salinas",
                            countryId: 68
                        },
                        {
                            stateId: 1118,
                            name: "San German",
                            value: "San German",
                            countryId: 68
                        },
                        {
                            stateId: 1121,
                            name: "San Juan",
                            value: "San Juan",
                            countryId: 68
                        },
                        {
                            stateId: 1122,
                            name: "San Lorenzo",
                            value: "San Lorenzo",
                            countryId: 68
                        },
                        {
                            stateId: 1125,
                            name: "San Sebastian",
                            value: "San Sebastian",
                            countryId: 68
                        },
                        {
                            stateId: 1133,
                            name: "Santa Isabel",
                            value: "Santa Isabel",
                            countryId: 68
                        },
                        {
                            stateId: 1276,
                            name: "Toa Alta",
                            value: "Toa Alta",
                            countryId: 68
                        },
                        {
                            stateId: 1277,
                            name: "Toa Baja",
                            value: "Toa Baja",
                            countryId: 68
                        },
                        {
                            stateId: 1300,
                            name: "Trujillo Alto",
                            value: "Trujillo Alto",
                            countryId: 68
                        },
                        {
                            stateId: 1324,
                            name: "Utuado",
                            value: "Utuado",
                            countryId: 68
                        },
                        {
                            stateId: 1347,
                            name: "Vega Alta",
                            value: "Vega Alta",
                            countryId: 68
                        },
                        {
                            stateId: 1348,
                            name: "Vega Baja",
                            value: "Vega Baja",
                            countryId: 68
                        },
                        {
                            stateId: 1362,
                            name: "Vieques",
                            value: "Vieques",
                            countryId: 68
                        },
                        {
                            stateId: 1368,
                            name: "Villalba",
                            value: "Villalba",
                            countryId: 68
                        },
                        {
                            stateId: 1405,
                            name: "Yabucoa",
                            value: "Yabucoa",
                            countryId: 68
                        },
                        {
                            stateId: 1413,
                            name: "Yauco",
                            value: "Yauco",
                            countryId: 68
                        }
                    ]
                },
                {
                    countryId: 274,
                    code: "QA",
                    name: "Qatar",
                    value: "Qatar",
                    states: [
                        {
                            stateId: 1686,
                            name: "Doha",
                            value: "Doha",
                            countryId: 274
                        }
                    ]
                },
                {
                    countryId: 275,
                    code: "XK",
                    name: "Republic of Kosovo",
                    value: "Republic of Kosovo",
                    states: [
                        {
                            stateId: 1687,
                            name: "Pristina",
                            value: "Pristina",
                            countryId: 275
                        }
                    ]
                },
                {
                    countryId: 69,
                    code: "RE",
                    name: "Reunion",
                    value: "Reunion",
                    states: [
                        {
                            stateId: 1042,
                            name: "Réunion",
                            value: "Réunion",
                            countryId: 69
                        },
                        {
                            stateId: 1043,
                            name: "Reunion (general)",
                            value: "Reunion (general)",
                            countryId: 69
                        }
                    ]
                },
                {
                    countryId: 70,
                    code: "RO",
                    name: "Romania",
                    value: "Romania",
                    states: [
                        {
                            stateId: 39,
                            name: "Alba",
                            value: "Alba",
                            countryId: 70
                        },
                        {
                            stateId: 65,
                            name: "Arad",
                            value: "Arad",
                            countryId: 70
                        },
                        {
                            stateId: 71,
                            name: "Argeş",
                            value: "Argeş",
                            countryId: 70
                        },
                        {
                            stateId: 93,
                            name: "Bacău",
                            value: "Bacău",
                            countryId: 70
                        },
                        {
                            stateId: 136,
                            name: "Bihor",
                            value: "Bihor",
                            countryId: 70
                        },
                        {
                            stateId: 143,
                            name: "Bistriţa-Năsăud",
                            value: "Bistriţa-Năsăud",
                            countryId: 70
                        },
                        {
                            stateId: 154,
                            name: "Botoşani",
                            value: "Botoşani",
                            countryId: 70
                        },
                        {
                            stateId: 162,
                            name: "Brăila",
                            value: "Brăila",
                            countryId: 70
                        },
                        {
                            stateId: 164,
                            name: "Braşov",
                            value: "Braşov",
                            countryId: 70
                        },
                        {
                            stateId: 174,
                            name: "Bucureşti",
                            value: "Bucureşti",
                            countryId: 70
                        },
                        {
                            stateId: 183,
                            name: "Buzău",
                            value: "Buzău",
                            countryId: 70
                        },
                        {
                            stateId: 190,
                            name: "Călăraşi",
                            value: "Călăraşi",
                            countryId: 70
                        },
                        {
                            stateId: 214,
                            name: "Caraş-Severin",
                            value: "Caraş-Severin",
                            countryId: 70
                        },
                        {
                            stateId: 271,
                            name: "Cluj",
                            value: "Cluj",
                            countryId: 70
                        },
                        {
                            stateId: 282,
                            name: "Constanţa",
                            value: "Constanţa",
                            countryId: 70
                        },
                        {
                            stateId: 290,
                            name: "Covasna",
                            value: "Covasna",
                            countryId: 70
                        },
                        {
                            stateId: 303,
                            name: "Dâmboviţa",
                            value: "Dâmboviţa",
                            countryId: 70
                        },
                        {
                            stateId: 343,
                            name: "Dolj",
                            value: "Dolj",
                            countryId: 70
                        },
                        {
                            stateId: 401,
                            name: "Galaţi",
                            value: "Galaţi",
                            countryId: 70
                        },
                        {
                            stateId: 414,
                            name: "Giurgiu",
                            value: "Giurgiu",
                            countryId: 70
                        },
                        {
                            stateId: 420,
                            name: "Gorj",
                            value: "Gorj",
                            countryId: 70
                        },
                        {
                            stateId: 461,
                            name: "Harghita",
                            value: "Harghita",
                            countryId: 70
                        },
                        {
                            stateId: 483,
                            name: "Hunedoara",
                            value: "Hunedoara",
                            countryId: 70
                        },
                        {
                            stateId: 486,
                            name: "Ialomiţa",
                            value: "Ialomiţa",
                            countryId: 70
                        },
                        {
                            stateId: 488,
                            name: "Iaşi",
                            value: "Iaşi",
                            countryId: 70
                        },
                        {
                            stateId: 512,
                            name: "Ilfov",
                            value: "Ilfov",
                            countryId: 70
                        },
                        {
                            stateId: 734,
                            name: "Maramureş",
                            value: "Maramureş",
                            countryId: 70
                        },
                        {
                            stateId: 761,
                            name: "Mehedinţi",
                            value: "Mehedinţi",
                            countryId: 70
                        },
                        {
                            stateId: 804,
                            name: "Mureş",
                            value: "Mureş",
                            countryId: 70
                        },
                        {
                            stateId: 828,
                            name: "Neamţ",
                            value: "Neamţ",
                            countryId: 70
                        },
                        {
                            stateId: 897,
                            name: "Olt",
                            value: "Olt",
                            countryId: 70
                        },
                        {
                            stateId: 973,
                            name: "Prahova",
                            value: "Prahova",
                            countryId: 70
                        },
                        {
                            stateId: 1103,
                            name: "Sălaj",
                            value: "Sălaj",
                            countryId: 70
                        },
                        {
                            stateId: 1143,
                            name: "Satu Mare",
                            value: "Satu Mare",
                            countryId: 70
                        },
                        {
                            stateId: 1161,
                            name: "Sibiu",
                            value: "Sibiu",
                            countryId: 70
                        },
                        {
                            stateId: 1218,
                            name: "Suceava",
                            value: "Suceava",
                            countryId: 70
                        },
                        {
                            stateId: 1255,
                            name: "Teleorman",
                            value: "Teleorman",
                            countryId: 70
                        },
                        {
                            stateId: 1266,
                            name: "Timiş",
                            value: "Timiş",
                            countryId: 70
                        },
                        {
                            stateId: 1305,
                            name: "Tulcea",
                            value: "Tulcea",
                            countryId: 70
                        },
                        {
                            stateId: 1328,
                            name: "Vâlcea",
                            value: "Vâlcea",
                            countryId: 70
                        },
                        {
                            stateId: 1339,
                            name: "Vaslui",
                            value: "Vaslui",
                            countryId: 70
                        },
                        {
                            stateId: 1380,
                            name: "Vrancea",
                            value: "Vrancea",
                            countryId: 70
                        }
                    ]
                },
                {
                    countryId: 71,
                    code: "RU",
                    name: "Russia",
                    value: "Russia",
                    states: [
                        {
                            stateId: 1440,
                            name: "Адыгея Республика",
                            value: "Адыгея Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1441,
                            name: "Алтай Республика",
                            value: "Алтай Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1442,
                            name: "Алтайский Край",
                            value: "Алтайский Край",
                            countryId: 71
                        },
                        {
                            stateId: 1443,
                            name: "Амурская Область",
                            value: "Амурская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1444,
                            name: "Архангельская Область",
                            value: "Архангельская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1445,
                            name: "Астраханская Область",
                            value: "Астраханская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1446,
                            name: "Байконур",
                            value: "Байконур",
                            countryId: 71
                        },
                        {
                            stateId: 1447,
                            name: "Башкортостан Республика",
                            value: "Башкортостан Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1448,
                            name: "Белгородская Область",
                            value: "Белгородская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1450,
                            name: "Брянская Область",
                            value: "Брянская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1452,
                            name: "Бурятия Республика",
                            value: "Бурятия Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1456,
                            name: "Владимирская Область",
                            value: "Владимирская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1457,
                            name: "Волгоградская Область",
                            value: "Волгоградская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1458,
                            name: "Вологодская Область",
                            value: "Вологодская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1459,
                            name: "Воронежская Область",
                            value: "Воронежская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1462,
                            name: "Дагестан Республика",
                            value: "Дагестан Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1464,
                            name: "Ивановская Область",
                            value: "Ивановская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1465,
                            name: "Ингушетия Республика",
                            value: "Ингушетия Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1466,
                            name: "Иркутская Область",
                            value: "Иркутская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1467,
                            name: "Кабардино-Балкарская Республика",
                            value: "Кабардино-Балкарская Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1468,
                            name: "Калининградская Область",
                            value: "Калининградская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1469,
                            name: "Калмыкия Республика",
                            value: "Калмыкия Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1470,
                            name: "Калужская Область",
                            value: "Калужская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1471,
                            name: "Камчатская Область",
                            value: "Камчатская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1472,
                            name: "Карачаево-Черкесская Республика",
                            value: "Карачаево-Черкесская Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1473,
                            name: "Карелия Республика",
                            value: "Карелия Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1474,
                            name: "Кемеровская Область",
                            value: "Кемеровская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1475,
                            name: "Кировская Область",
                            value: "Кировская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1476,
                            name: "Коми Республика",
                            value: "Коми Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1477,
                            name: "Костромская Область",
                            value: "Костромская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1478,
                            name: "Краснодарский Край",
                            value: "Краснодарский Край",
                            countryId: 71
                        },
                        {
                            stateId: 1479,
                            name: "Красноярский Край",
                            value: "Красноярский Край",
                            countryId: 71
                        },
                        {
                            stateId: 1480,
                            name: "Курганская Область",
                            value: "Курганская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1481,
                            name: "Курская Область",
                            value: "Курская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1484,
                            name: "Ленинградская Область",
                            value: "Ленинградская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1485,
                            name: "Липецкая Область",
                            value: "Липецкая Область",
                            countryId: 71
                        },
                        {
                            stateId: 1487,
                            name: "Магаданская Область",
                            value: "Магаданская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1488,
                            name: "Марий Эл Республика",
                            value: "Марий Эл Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1490,
                            name: "Мордовия Республика",
                            value: "Мордовия Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1491,
                            name: "Москва",
                            value: "Москва",
                            countryId: 71
                        },
                        {
                            stateId: 1492,
                            name: "Московская Область",
                            value: "Московская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1493,
                            name: "Мурманская Область",
                            value: "Мурманская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1494,
                            name: "Нижегородская Область",
                            value: "Нижегородская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1495,
                            name: "Новгородская Область",
                            value: "Новгородская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1496,
                            name: "Новосибирская Область",
                            value: "Новосибирская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1497,
                            name: "Омская Область",
                            value: "Омская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1498,
                            name: "Оренбургская Область",
                            value: "Оренбургская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1499,
                            name: "Орловская Область",
                            value: "Орловская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1501,
                            name: "Пензенская Область",
                            value: "Пензенская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1502,
                            name: "Пермский Край",
                            value: "Пермский Край",
                            countryId: 71
                        },
                        {
                            stateId: 1506,
                            name: "Приморский Край",
                            value: "Приморский Край",
                            countryId: 71
                        },
                        {
                            stateId: 1507,
                            name: "Псковская Область",
                            value: "Псковская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1509,
                            name: "Ростовская Область",
                            value: "Ростовская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1511,
                            name: "Рязанская Область",
                            value: "Рязанская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1512,
                            name: "Самарская Область",
                            value: "Самарская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1513,
                            name: "Санкт-Петербург",
                            value: "Санкт-Петербург",
                            countryId: 71
                        },
                        {
                            stateId: 1514,
                            name: "Саратовская Область",
                            value: "Саратовская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1515,
                            name: "Саха (Якутия) Республика",
                            value: "Саха (Якутия) Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1516,
                            name: "Сахалинская Область",
                            value: "Сахалинская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1517,
                            name: "Свердловская Область",
                            value: "Свердловская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1518,
                            name: "Северная Осетия-Алания Республика",
                            value: "Северная Осетия-Алания Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1521,
                            name: "Смоленская Область",
                            value: "Смоленская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1525,
                            name: "Ставропольский Край",
                            value: "Ставропольский Край",
                            countryId: 71
                        },
                        {
                            stateId: 1527,
                            name: "Тамбовская Область",
                            value: "Тамбовская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1528,
                            name: "Татарстан Республика",
                            value: "Татарстан Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1529,
                            name: "Тверская Область",
                            value: "Тверская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1530,
                            name: "Томская Область",
                            value: "Томская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1531,
                            name: "Тульская Область",
                            value: "Тульская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1533,
                            name: "Тыва Республика",
                            value: "Тыва Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1534,
                            name: "Тюменская Область",
                            value: "Тюменская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1535,
                            name: "Удмуртская Республика",
                            value: "Удмуртская Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1536,
                            name: "Ульяновская Область",
                            value: "Ульяновская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1537,
                            name: "Хабаровский Край",
                            value: "Хабаровский Край",
                            countryId: 71
                        },
                        {
                            stateId: 1538,
                            name: "Хакасия Республика",
                            value: "Хакасия Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1540,
                            name: "Челябинская Область",
                            value: "Челябинская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1541,
                            name: "Чеченская Республика",
                            value: "Чеченская Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1542,
                            name: "Читинская Область",
                            value: "Читинская Область",
                            countryId: 71
                        },
                        {
                            stateId: 1543,
                            name: "Чувашская Республика",
                            value: "Чувашская Республика",
                            countryId: 71
                        },
                        {
                            stateId: 1546,
                            name: "Ярославская Область",
                            value: "Ярославская Область",
                            countryId: 71
                        }
                    ]
                },
                {
                    countryId: 279,
                    code: "RW",
                    name: "Rwanda",
                    value: "Rwanda",
                    states: [
                        {
                            stateId: 1688,
                            name: "Kigali",
                            value: "Kigali",
                            countryId: 279
                        }
                    ]
                },
                {
                    countryId: 280,
                    code: "BL",
                    name: "Saint Barthélemy",
                    value: "Saint Barthélemy",
                    states: [
                        {
                            stateId: 1689,
                            name: "Gustavia",
                            value: "Gustavia",
                            countryId: 280
                        }
                    ]
                },
                {
                    countryId: 281,
                    code: "SH",
                    name: "Saint Helena, Ascension and Tristan da Cunha",
                    value: "Saint Helena, Ascension and Tristan da Cunha",
                    states: [
                        {
                            stateId: 1690,
                            name: "Jamestown",
                            value: "Jamestown",
                            countryId: 281
                        }
                    ]
                },
                {
                    countryId: 282,
                    code: "KN",
                    name: "Saint Kitts and Nevis",
                    value: "Saint Kitts and Nevis",
                    states: [
                        {
                            stateId: 1691,
                            name: "Basseterre",
                            value: "Basseterre",
                            countryId: 35
                        }
                    ]
                },
                {
                    countryId: 283,
                    code: "LC",
                    name: "Saint Lucia",
                    value: "Saint Lucia",
                    states: [
                        {
                            stateId: 1692,
                            name: "Castries",
                            value: "Castries",
                            countryId: 283
                        }
                    ]
                },
                {
                    countryId: 284,
                    code: "MF",
                    name: "Saint Martin (French part)",
                    value: "Saint Martin (French part)",
                    states: [
                        {
                            stateId: 1693,
                            name: "Marigot",
                            value: "Marigot",
                            countryId: 284
                        }
                    ]
                },
                {
                    countryId: 72,
                    code: "PM",
                    name: "Saint Pierre And Miquelon",
                    value: "Saint Pierre And Miquelon",
                    states: [
                        {
                            stateId: 780,
                            name: "Miquelon-Langlade",
                            value: "Miquelon-Langlade",
                            countryId: 72
                        },
                        {
                            stateId: 1098,
                            name: "Saint-Pierre",
                            value: "Saint-Pierre",
                            countryId: 72
                        }
                    ]
                },
                {
                    countryId: 286,
                    code: "VC",
                    name: "Saint Vincent and the Grenadines",
                    value: "Saint Vincent and the Grenadines",
                    states: [
                        {
                            stateId: 1694,
                            name: "Kingstown",
                            value: "Kingstown",
                            countryId: 286
                        }
                    ]
                },
                {
                    countryId: 287,
                    code: "WS",
                    name: "Samoa",
                    value: "Samoa",
                    states: [
                        {
                            stateId: 1695,
                            name: "Apia",
                            value: "Apia",
                            countryId: 287
                        }
                    ]
                },
                {
                    countryId: 73,
                    code: "SM",
                    name: "San Marino",
                    value: "San Marino",
                    states: [
                        {
                            stateId: 1696,
                            name: "San Marino",
                            value: "San Marino",
                            countryId: 73
                        }
                    ]
                },
                {
                    countryId: 289,
                    code: "ST",
                    name: "Sao Tome and Principe",
                    value: "Sao Tome and Principe",
                    states: [
                        {
                            stateId: 1697,
                            name: "São Tomé",
                            value: "São Tomé",
                            countryId: 289
                        }
                    ]
                },
                {
                    countryId: 290,
                    code: "SA",
                    name: "Saudi Arabia",
                    value: "Saudi Arabia",
                    states: [
                        {
                            stateId: 1698,
                            name: "Riyadh",
                            value: "Riyadh",
                            countryId: 290
                        }
                    ]
                },
                {
                    countryId: 291,
                    code: "SN",
                    name: "Senegal",
                    value: "Senegal",
                    states: [
                        {
                            stateId: 1699,
                            name: "Dakar",
                            value: "Dakar",
                            countryId: 291
                        }
                    ]
                },
                {
                    countryId: 292,
                    code: "RS",
                    name: "Serbia",
                    value: "Serbia",
                    states: [
                        {
                            stateId: 1700,
                            name: "Belgrade",
                            value: "Belgrade",
                            countryId: 292
                        }
                    ]
                },
                {
                    countryId: 293,
                    code: "SC",
                    name: "Seychelles",
                    value: "Seychelles",
                    states: [
                        {
                            stateId: 1701,
                            name: "Victoria",
                            value: "Victoria",
                            countryId: 293
                        }
                    ]
                },
                {
                    countryId: 294,
                    code: "SL",
                    name: "Sierra Leone",
                    value: "Sierra Leone",
                    states: [
                        {
                            stateId: 1702,
                            name: "Freetown",
                            value: "Freetown",
                            countryId: 294
                        }
                    ]
                },
                {
                    countryId: 74,
                    code: "SG",
                    name: "Singapore",
                    value: "Singapore",
                    states: [
                        {
                            stateId: 1703,
                            name: "Singapore",
                            value: "Singapore",
                            countryId: 74
                        }
                    ]
                },
                {
                    countryId: 296,
                    code: "SX",
                    name: "Sint Maarten (Dutch part)",
                    value: "Sint Maarten (Dutch part)",
                    states: [
                        {
                            stateId: 1704,
                            name: "Philipsburg",
                            value: "Philipsburg",
                            countryId: 296
                        }
                    ]
                },
                {
                    countryId: 75,
                    code: "SK",
                    name: "Slovakia",
                    value: "Slovakia",
                    states: [
                        {
                            stateId: 113,
                            name: "Banskobystrický kraj",
                            value: "Banskobystrický kraj",
                            countryId: 75
                        },
                        {
                            stateId: 165,
                            name: "Bratislavský kraj",
                            value: "Bratislavský kraj",
                            countryId: 75
                        },
                        {
                            stateId: 632,
                            name: "Košický kraj",
                            value: "Košický kraj",
                            countryId: 75
                        },
                        {
                            stateId: 851,
                            name: "Nitriansky kraj",
                            value: "Nitriansky kraj",
                            countryId: 75
                        },
                        {
                            stateId: 975,
                            name: "Prešovský kraj",
                            value: "Prešovský kraj",
                            countryId: 75
                        },
                        {
                            stateId: 1293,
                            name: "Trenčiansky kraj",
                            value: "Trenčiansky kraj",
                            countryId: 75
                        },
                        {
                            stateId: 1298,
                            name: "Trnavský kraj",
                            value: "Trnavský kraj",
                            countryId: 75
                        },
                        {
                            stateId: 1427,
                            name: "Žilinský kraj",
                            value: "Žilinský kraj",
                            countryId: 75
                        }
                    ]
                },
                {
                    countryId: 76,
                    code: "SI",
                    name: "Slovenia",
                    value: "Slovenia",
                    states: [
                        {
                            stateId: 1705,
                            name: "Ljubljana",
                            value: "Ljubljana",
                            countryId: 76
                        }
                    ]
                },
                {
                    countryId: 299,
                    code: "SB",
                    name: "Solomon Islands",
                    value: "Solomon Islands",
                    states: [
                        {
                            stateId: 1706,
                            name: "Honiara",
                            value: "Honiara",
                            countryId: 299
                        }
                    ]
                },
                {
                    countryId: 300,
                    code: "SO",
                    name: "Somalia",
                    value: "Somalia",
                    states: [
                        {
                            stateId: 1707,
                            name: "Mogadishu",
                            value: "Mogadishu",
                            countryId: 300
                        }
                    ]
                },
                {
                    countryId: 77,
                    code: "ZA",
                    name: "South Africa",
                    value: "South Africa",
                    states: [
                        {
                            stateId: 1708,
                            name: "Pretoria",
                            value: "Pretoria",
                            countryId: 77
                        }
                    ]
                },
                {
                    countryId: 302,
                    code: "GS",
                    name: "South Georgia and the South Sandwich Islands",
                    value: "South Georgia and the South Sandwich Islands",
                    states: [
                        {
                            stateId: 1709,
                            name: "King Edward Point",
                            value: "King Edward Point",
                            countryId: 302
                        }
                    ]
                },
                {
                    countryId: 78,
                    code: "KR",
                    name: "South Korea",
                    value: "South Korea",
                    states: [
                        {
                            stateId: 1547,
                            name: "강원도",
                            value: "강원도",
                            countryId: 78
                        },
                        {
                            stateId: 1548,
                            name: "경기도",
                            value: "경기도",
                            countryId: 78
                        },
                        {
                            stateId: 1549,
                            name: "경상남도",
                            value: "경상남도",
                            countryId: 78
                        },
                        {
                            stateId: 1550,
                            name: "경상북도",
                            value: "경상북도",
                            countryId: 78
                        },
                        {
                            stateId: 1551,
                            name: "광주광역시",
                            value: "광주광역시",
                            countryId: 78
                        },
                        {
                            stateId: 1552,
                            name: "대구광역시",
                            value: "대구광역시",
                            countryId: 78
                        },
                        {
                            stateId: 1553,
                            name: "대전광역시",
                            value: "대전광역시",
                            countryId: 78
                        },
                        {
                            stateId: 1554,
                            name: "부산광역시",
                            value: "부산광역시",
                            countryId: 78
                        },
                        {
                            stateId: 1555,
                            name: "서울특별시",
                            value: "서울특별시",
                            countryId: 78
                        },
                        {
                            stateId: 1556,
                            name: "세종특별자치시",
                            value: "세종특별자치시",
                            countryId: 78
                        },
                        {
                            stateId: 1557,
                            name: "울산광역시",
                            value: "울산광역시",
                            countryId: 78
                        },
                        {
                            stateId: 1558,
                            name: "인천광역시",
                            value: "인천광역시",
                            countryId: 78
                        },
                        {
                            stateId: 1559,
                            name: "전라남도",
                            value: "전라남도",
                            countryId: 78
                        },
                        {
                            stateId: 1560,
                            name: "전라북도",
                            value: "전라북도",
                            countryId: 78
                        },
                        {
                            stateId: 1561,
                            name: "제주특별자치도",
                            value: "제주특별자치도",
                            countryId: 78
                        },
                        {
                            stateId: 1562,
                            name: "충청남도",
                            value: "충청남도",
                            countryId: 78
                        },
                        {
                            stateId: 1563,
                            name: "충청북도",
                            value: "충청북도",
                            countryId: 78
                        }
                    ]
                },
                {
                    countryId: 304,
                    code: "SS",
                    name: "South Sudan",
                    value: "South Sudan",
                    states: [
                        {
                            stateId: 1710,
                            name: "Juba",
                            value: "Juba",
                            countryId: 304
                        }
                    ]
                },
                {
                    countryId: 79,
                    code: "ES",
                    name: "Spain",
                    value: "Spain",
                    states: [
                        {
                            stateId: 53,
                            name: "Andalucia",
                            value: "Andalucia",
                            countryId: 79
                        },
                        {
                            stateId: 66,
                            name: "Aragon",
                            value: "Aragon",
                            countryId: 79
                        },
                        {
                            stateId: 81,
                            name: "Asturias",
                            value: "Asturias",
                            countryId: 79
                        },
                        {
                            stateId: 102,
                            name: "Baleares",
                            value: "Baleares",
                            countryId: 79
                        },
                        {
                            stateId: 198,
                            name: "Canarias",
                            value: "Canarias",
                            countryId: 79
                        },
                        {
                            stateId: 203,
                            name: "Cantabria",
                            value: "Cantabria",
                            countryId: 79
                        },
                        {
                            stateId: 219,
                            name: "Castilla - La Mancha",
                            value: "Castilla - La Mancha",
                            countryId: 79
                        },
                        {
                            stateId: 220,
                            name: "Castilla - Leon",
                            value: "Castilla - Leon",
                            countryId: 79
                        },
                        {
                            stateId: 221,
                            name: "Cataluna",
                            value: "Cataluna",
                            countryId: 79
                        },
                        {
                            stateId: 238,
                            name: "Ceuta",
                            value: "Ceuta",
                            countryId: 79
                        },
                        {
                            stateId: 280,
                            name: "Comunidad Valenciana",
                            value: "Comunidad Valenciana",
                            countryId: 79
                        },
                        {
                            stateId: 381,
                            name: "Extremadura",
                            value: "Extremadura",
                            countryId: 79
                        },
                        {
                            stateId: 402,
                            name: "Galicia",
                            value: "Galicia",
                            countryId: 79
                        },
                        {
                            stateId: 667,
                            name: "La Rioja",
                            value: "La Rioja",
                            countryId: 79
                        },
                        {
                            stateId: 719,
                            name: "Madrid",
                            value: "Madrid",
                            countryId: 79
                        },
                        {
                            stateId: 763,
                            name: "Melilla",
                            value: "Melilla",
                            countryId: 79
                        },
                        {
                            stateId: 803,
                            name: "Murcia",
                            value: "Murcia",
                            countryId: 79
                        },
                        {
                            stateId: 826,
                            name: "Navarra",
                            value: "Navarra",
                            countryId: 79
                        },
                        {
                            stateId: 923,
                            name: "Pais Vasco",
                            value: "Pais Vasco",
                            countryId: 79
                        }
                    ]
                },
                {
                    countryId: 80,
                    code: "LK",
                    name: "Sri Lanka",
                    value: "Sri Lanka",
                    states: [
                        {
                            stateId: 231,
                            name: "Central Province",
                            value: "Central Province",
                            countryId: 80
                        },
                        {
                            stateId: 358,
                            name: "Eastern Province",
                            value: "Eastern Province",
                            countryId: 80
                        },
                        {
                            stateId: 865,
                            name: "North Central Province",
                            value: "North Central Province",
                            countryId: 80
                        },
                        {
                            stateId: 869,
                            name: "North Western Province",
                            value: "North Western Province",
                            countryId: 80
                        },
                        {
                            stateId: 871,
                            name: "Northern Province",
                            value: "Northern Province",
                            countryId: 80
                        },
                        {
                            stateId: 982,
                            name: "Province of Uva",
                            value: "Province of Uva",
                            countryId: 80
                        },
                        {
                            stateId: 1081,
                            name: "Sabaragamuwa Province",
                            value: "Sabaragamuwa Province",
                            countryId: 80
                        },
                        {
                            stateId: 1200,
                            name: "Southern Province",
                            value: "Southern Province",
                            countryId: 80
                        },
                        {
                            stateId: 1395,
                            name: "Western Province",
                            value: "Western Province",
                            countryId: 80
                        }
                    ]
                },
                {
                    countryId: 307,
                    code: "SD",
                    name: "Sudan",
                    value: "Sudan",
                    states: [
                        {
                            stateId: 1711,
                            name: "Khartoum",
                            value: "Khartoum",
                            countryId: 35
                        }
                    ]
                },
                {
                    countryId: 308,
                    code: "SR",
                    name: "Suriname",
                    value: "Suriname",
                    states: [
                        {
                            stateId: 1712,
                            name: "Paramaribo",
                            value: "Paramaribo",
                            countryId: 309
                        }
                    ]
                },
                {
                    countryId: 81,
                    code: "SJ",
                    name: "Svalbard And Jan Mayen",
                    value: "Svalbard And Jan Mayen",
                    states: [
                        {
                            stateId: 543,
                            name: "Jan Mayen",
                            value: "Jan Mayen",
                            countryId: 81
                        },
                        {
                            stateId: 1226,
                            name: "Svalbard",
                            value: "Svalbard",
                            countryId: 81
                        }
                    ]
                },
                {
                    countryId: 310,
                    code: "SZ",
                    name: "Swaziland",
                    value: "Swaziland",
                    states: [
                        {
                            stateId: 1713,
                            name: "Mbabana",
                            value: "Mbabana",
                            countryId: 310
                        }
                    ]
                },
                {
                    countryId: 82,
                    code: "SE",
                    name: "Sweden",
                    value: "Sweden",
                    states: [
                        {
                            stateId: 146,
                            name: "Blekinge",
                            value: "Blekinge",
                            countryId: 82
                        },
                        {
                            stateId: 301,
                            name: "Dalarna",
                            value: "Dalarna",
                            countryId: 82
                        },
                        {
                            stateId: 405,
                            name: "Gävleborg",
                            value: "Gävleborg",
                            countryId: 82
                        },
                        {
                            stateId: 421,
                            name: "Gotland",
                            value: "Gotland",
                            countryId: 82
                        },
                        {
                            stateId: 458,
                            name: "Halland",
                            value: "Halland",
                            countryId: 82
                        },
                        {
                            stateId: 542,
                            name: "Jämtland",
                            value: "Jämtland",
                            countryId: 82
                        },
                        {
                            stateId: 558,
                            name: "Jönköping",
                            value: "Jönköping",
                            countryId: 82
                        },
                        {
                            stateId: 568,
                            name: "Kalmar",
                            value: "Kalmar",
                            countryId: 82
                        },
                        {
                            stateId: 640,
                            name: "Kronoberg",
                            value: "Kronoberg",
                            countryId: 82
                        },
                        {
                            stateId: 862,
                            name: "Norrbotten",
                            value: "Norrbotten",
                            countryId: 82
                        },
                        {
                            stateId: 904,
                            name: "Örebro",
                            value: "Örebro",
                            countryId: 82
                        },
                        {
                            stateId: 912,
                            name: "Östergötland",
                            value: "Östergötland",
                            countryId: 82
                        },
                        {
                            stateId: 1177,
                            name: "Skåne",
                            value: "Skåne",
                            countryId: 82
                        },
                        {
                            stateId: 1184,
                            name: "Södermanland",
                            value: "Södermanland",
                            countryId: 82
                        },
                        {
                            stateId: 1212,
                            name: "Stockholm",
                            value: "Stockholm",
                            countryId: 82
                        },
                        {
                            stateId: 1314,
                            name: "Uppsala",
                            value: "Uppsala",
                            countryId: 82
                        },
                        {
                            stateId: 1337,
                            name: "Värmland",
                            value: "Värmland",
                            countryId: 82
                        },
                        {
                            stateId: 1340,
                            name: "Västerbotten",
                            value: "Västerbotten",
                            countryId: 82
                        },
                        {
                            stateId: 1341,
                            name: "Västernorrland",
                            value: "Västernorrland",
                            countryId: 82
                        },
                        {
                            stateId: 1342,
                            name: "Västmanland",
                            value: "Västmanland",
                            countryId: 82
                        },
                        {
                            stateId: 1343,
                            name: "Västra Götaland",
                            value: "Västra Götaland",
                            countryId: 82
                        }
                    ]
                },
                {
                    countryId: 83,
                    code: "CH",
                    name: "Switzerland",
                    value: "Switzerland",
                    states: [
                        {
                            stateId: 206,
                            name: "Canton de Berne",
                            value: "Canton de Berne",
                            countryId: 83
                        },
                        {
                            stateId: 207,
                            name: "Canton de Fribourg",
                            value: "Canton de Fribourg",
                            countryId: 83
                        },
                        {
                            stateId: 208,
                            name: "Canton de Vaud",
                            value: "Canton de Vaud",
                            countryId: 83
                        },
                        {
                            stateId: 209,
                            name: "Canton du Valais",
                            value: "Canton du Valais",
                            countryId: 83
                        },
                        {
                            stateId: 408,
                            name: "Genève",
                            value: "Genève",
                            countryId: 83
                        },
                        {
                            stateId: 562,
                            name: "Jura",
                            value: "Jura",
                            countryId: 83
                        },
                        {
                            stateId: 576,
                            name: "Kanton Aargau",
                            value: "Kanton Aargau",
                            countryId: 83
                        },
                        {
                            stateId: 577,
                            name: "Kanton Appenzell Ausserrhoden",
                            value: "Kanton Appenzell Ausserrhoden",
                            countryId: 83
                        },
                        {
                            stateId: 578,
                            name: "Kanton Appenzell Innerrhoden",
                            value: "Kanton Appenzell Innerrhoden",
                            countryId: 83
                        },
                        {
                            stateId: 579,
                            name: "Kanton Basel-Landschaft",
                            value: "Kanton Basel-Landschaft",
                            countryId: 83
                        },
                        {
                            stateId: 580,
                            name: "Kanton Basel-Stadt",
                            value: "Kanton Basel-Stadt",
                            countryId: 83
                        },
                        {
                            stateId: 581,
                            name: "Kanton Glarus",
                            value: "Kanton Glarus",
                            countryId: 83
                        },
                        {
                            stateId: 582,
                            name: "Kanton Graubünden",
                            value: "Kanton Graubünden",
                            countryId: 83
                        },
                        {
                            stateId: 583,
                            name: "Kanton Luzern",
                            value: "Kanton Luzern",
                            countryId: 83
                        },
                        {
                            stateId: 584,
                            name: "Kanton Nidwalden",
                            value: "Kanton Nidwalden",
                            countryId: 83
                        },
                        {
                            stateId: 585,
                            name: "Kanton Obwalden",
                            value: "Kanton Obwalden",
                            countryId: 83
                        },
                        {
                            stateId: 586,
                            name: "Kanton Schaffhausen",
                            value: "Kanton Schaffhausen",
                            countryId: 83
                        },
                        {
                            stateId: 587,
                            name: "Kanton Schwyz",
                            value: "Kanton Schwyz",
                            countryId: 83
                        },
                        {
                            stateId: 588,
                            name: "Kanton Solothurn",
                            value: "Kanton Solothurn",
                            countryId: 83
                        },
                        {
                            stateId: 589,
                            name: "Kanton St. Gallen",
                            value: "Kanton St. Gallen",
                            countryId: 83
                        },
                        {
                            stateId: 590,
                            name: "Kanton Thurgau",
                            value: "Kanton Thurgau",
                            countryId: 83
                        },
                        {
                            stateId: 591,
                            name: "Kanton Uri",
                            value: "Kanton Uri",
                            countryId: 83
                        },
                        {
                            stateId: 592,
                            name: "Kanton Zug",
                            value: "Kanton Zug",
                            countryId: 83
                        },
                        {
                            stateId: 593,
                            name: "Kanton Zürich",
                            value: "Kanton Zürich",
                            countryId: 83
                        },
                        {
                            stateId: 834,
                            name: "Neuchâtel",
                            value: "Neuchâtel",
                            countryId: 83
                        },
                        {
                            stateId: 1264,
                            name: "Ticino",
                            value: "Ticino",
                            countryId: 83
                        }
                    ]
                },
                {
                    countryId: 313,
                    code: "SY",
                    name: "Syrian Arab Republic",
                    value: "Syrian Arab Republic",
                    states: [
                        {
                            stateId: 1714,
                            name: "Damascus",
                            value: "Damascus",
                            countryId: 313
                        }
                    ]
                },
                {
                    countryId: 314,
                    code: "TW",
                    name: "Taiwan",
                    value: "Taiwan",
                    states: [
                        {
                            stateId: 1715,
                            name: "Taipei",
                            value: "Taipei",
                            countryId: 314
                        }
                    ]
                },
                {
                    countryId: 315,
                    code: "TJ",
                    name: "Tajikistan",
                    value: "Tajikistan",
                    states: [
                        {
                            stateId: 1716,
                            name: "Dushanbe",
                            value: "Dushanbe",
                            countryId: 315
                        }
                    ]
                },
                {
                    countryId: 316,
                    code: "TZ",
                    name: "Tanzania, United Republic of",
                    value: "Tanzania, United Republic of",
                    states: [
                        {
                            stateId: 1717,
                            name: "Dodoma",
                            value: "Dodoma",
                            countryId: 316
                        }
                    ]
                },
                {
                    countryId: 84,
                    code: "TH",
                    name: "Thailand",
                    value: "Thailand",
                    states: [
                        {
                            stateId: 51,
                            name: "Amnat Charoen",
                            value: "Amnat Charoen",
                            countryId: 84
                        },
                        {
                            stateId: 58,
                            name: "Ang Thong",
                            value: "Ang Thong",
                            countryId: 84
                        },
                        {
                            stateId: 112,
                            name: "Bangkok",
                            value: "Bangkok",
                            countryId: 84
                        },
                        {
                            stateId: 179,
                            name: "Buri Ram",
                            value: "Buri Ram",
                            countryId: 84
                        },
                        {
                            stateId: 239,
                            name: "Chachoengsao",
                            value: "Chachoengsao",
                            countryId: 84
                        },
                        {
                            stateId: 241,
                            name: "Chai Nat",
                            value: "Chai Nat",
                            countryId: 84
                        },
                        {
                            stateId: 242,
                            name: "Chaiyaphum",
                            value: "Chaiyaphum",
                            countryId: 84
                        },
                        {
                            stateId: 244,
                            name: "Chanthaburi",
                            value: "Chanthaburi",
                            countryId: 84
                        },
                        {
                            stateId: 249,
                            name: "Chiang Mai",
                            value: "Chiang Mai",
                            countryId: 84
                        },
                        {
                            stateId: 250,
                            name: "Chiang Rai",
                            value: "Chiang Rai",
                            countryId: 84
                        },
                        {
                            stateId: 259,
                            name: "Chon Buri",
                            value: "Chon Buri",
                            countryId: 84
                        },
                        {
                            stateId: 261,
                            name: "Chumphon",
                            value: "Chumphon",
                            countryId: 84
                        },
                        {
                            stateId: 567,
                            name: "Kalasin",
                            value: "Kalasin",
                            countryId: 84
                        },
                        {
                            stateId: 569,
                            name: "Kamphaeng Phet",
                            value: "Kamphaeng Phet",
                            countryId: 84
                        },
                        {
                            stateId: 571,
                            name: "Kanchanaburi",
                            value: "Kanchanaburi",
                            countryId: 84
                        },
                        {
                            stateId: 615,
                            name: "Khon Kaen",
                            value: "Khon Kaen",
                            countryId: 84
                        },
                        {
                            stateId: 634,
                            name: "Krabi",
                            value: "Krabi",
                            countryId: 84
                        },
                        {
                            stateId: 675,
                            name: "Lampang",
                            value: "Lampang",
                            countryId: 84
                        },
                        {
                            stateId: 676,
                            name: "Lamphun",
                            value: "Lamphun",
                            countryId: 84
                        },
                        {
                            stateId: 698,
                            name: "Loei",
                            value: "Loei",
                            countryId: 84
                        },
                        {
                            stateId: 701,
                            name: "Lopburi",
                            value: "Lopburi",
                            countryId: 84
                        },
                        {
                            stateId: 720,
                            name: "Mae Hong Son",
                            value: "Mae Hong Son",
                            countryId: 84
                        },
                        {
                            stateId: 722,
                            name: "Maha Sarakham",
                            value: "Maha Sarakham",
                            countryId: 84
                        },
                        {
                            stateId: 800,
                            name: "Mukdahan",
                            value: "Mukdahan",
                            countryId: 84
                        },
                        {
                            stateId: 814,
                            name: "Nakhon Nayok",
                            value: "Nakhon Nayok",
                            countryId: 84
                        },
                        {
                            stateId: 815,
                            name: "Nakhon Pathom",
                            value: "Nakhon Pathom",
                            countryId: 84
                        },
                        {
                            stateId: 816,
                            name: "Nakhon Phanom",
                            value: "Nakhon Phanom",
                            countryId: 84
                        },
                        {
                            stateId: 817,
                            name: "Nakhon Ratchasima",
                            value: "Nakhon Ratchasima",
                            countryId: 84
                        },
                        {
                            stateId: 818,
                            name: "Nakhon Sawan",
                            value: "Nakhon Sawan",
                            countryId: 84
                        },
                        {
                            stateId: 819,
                            name: "Nakhon Si Thammarat",
                            value: "Nakhon Si Thammarat",
                            countryId: 84
                        },
                        {
                            stateId: 820,
                            name: "Nan",
                            value: "Nan",
                            countryId: 84
                        },
                        {
                            stateId: 823,
                            name: "Narathiwat",
                            value: "Narathiwat",
                            countryId: 84
                        },
                        {
                            stateId: 853,
                            name: "Nong Bua Lam Phu",
                            value: "Nong Bua Lam Phu",
                            countryId: 84
                        },
                        {
                            stateId: 854,
                            name: "Nong Khai",
                            value: "Nong Khai",
                            countryId: 84
                        },
                        {
                            stateId: 855,
                            name: "Nonthaburi",
                            value: "Nonthaburi",
                            countryId: 84
                        },
                        {
                            stateId: 933,
                            name: "Pathum Thani",
                            value: "Pathum Thani",
                            countryId: 84
                        },
                        {
                            stateId: 935,
                            name: "Pattani",
                            value: "Pattani",
                            countryId: 84
                        },
                        {
                            stateId: 947,
                            name: "Phang Nga",
                            value: "Phang Nga",
                            countryId: 84
                        },
                        {
                            stateId: 948,
                            name: "Phatthalung",
                            value: "Phatthalung",
                            countryId: 84
                        },
                        {
                            stateId: 949,
                            name: "Phayao",
                            value: "Phayao",
                            countryId: 84
                        },
                        {
                            stateId: 950,
                            name: "Phetchaburi",
                            value: "Phetchaburi",
                            countryId: 84
                        },
                        {
                            stateId: 951,
                            name: "Phichit",
                            value: "Phichit",
                            countryId: 84
                        },
                        {
                            stateId: 952,
                            name: "Phitsanulok",
                            value: "Phitsanulok",
                            countryId: 84
                        },
                        {
                            stateId: 953,
                            name: "Phra Nakhon Si Ayutthaya",
                            value: "Phra Nakhon Si Ayutthaya",
                            countryId: 84
                        },
                        {
                            stateId: 954,
                            name: "Phrae",
                            value: "Phrae",
                            countryId: 84
                        },
                        {
                            stateId: 955,
                            name: "Phuket",
                            value: "Phuket",
                            countryId: 84
                        },
                        {
                            stateId: 971,
                            name: "Prachin Buri",
                            value: "Prachin Buri",
                            countryId: 84
                        },
                        {
                            stateId: 972,
                            name: "Prachuap Khiri Khan",
                            value: "Prachuap Khiri Khan",
                            countryId: 84
                        },
                        {
                            stateId: 1014,
                            name: "Ranong",
                            value: "Ranong",
                            countryId: 84
                        },
                        {
                            stateId: 1016,
                            name: "Ratchaburi",
                            value: "Ratchaburi",
                            countryId: 84
                        },
                        {
                            stateId: 1018,
                            name: "Rayong",
                            value: "Rayong",
                            countryId: 84
                        },
                        {
                            stateId: 1064,
                            name: "Roi Et",
                            value: "Roi Et",
                            countryId: 84
                        },
                        {
                            stateId: 1075,
                            name: "Sa Kaeo",
                            value: "Sa Kaeo",
                            countryId: 84
                        },
                        {
                            stateId: 1102,
                            name: "Sakon Nakhon",
                            value: "Sakon Nakhon",
                            countryId: 84
                        },
                        {
                            stateId: 1114,
                            name: "Samut Prakan",
                            value: "Samut Prakan",
                            countryId: 84
                        },
                        {
                            stateId: 1115,
                            name: "Samut Sakhon",
                            value: "Samut Sakhon",
                            countryId: 84
                        },
                        {
                            stateId: 1116,
                            name: "Samut Songkhram",
                            value: "Samut Songkhram",
                            countryId: 84
                        },
                        {
                            stateId: 1138,
                            name: "Saraburi",
                            value: "Saraburi",
                            countryId: 84
                        },
                        {
                            stateId: 1144,
                            name: "Satun",
                            value: "Satun",
                            countryId: 84
                        },
                        {
                            stateId: 1158,
                            name: "Si Sa Ket",
                            value: "Si Sa Ket",
                            countryId: 84
                        },
                        {
                            stateId: 1169,
                            name: "Sing Buri",
                            value: "Sing Buri",
                            countryId: 84
                        },
                        {
                            stateId: 1188,
                            name: "Songkhla",
                            value: "Songkhla",
                            countryId: 84
                        },
                        {
                            stateId: 1220,
                            name: "Sukhothai",
                            value: "Sukhothai",
                            countryId: 84
                        },
                        {
                            stateId: 1223,
                            name: "Suphanburi",
                            value: "Suphanburi",
                            countryId: 84
                        },
                        {
                            stateId: 1224,
                            name: "Surat Thani",
                            value: "Surat Thani",
                            countryId: 84
                        },
                        {
                            stateId: 1234,
                            name: "Tak",
                            value: "Tak",
                            countryId: 84
                        },
                        {
                            stateId: 1290,
                            name: "Trang",
                            value: "Trang",
                            countryId: 84
                        },
                        {
                            stateId: 1291,
                            name: "Trat",
                            value: "Trat",
                            countryId: 84
                        },
                        {
                            stateId: 1308,
                            name: "Ubon Ratchathani",
                            value: "Ubon Ratchathani",
                            countryId: 84
                        },
                        {
                            stateId: 1310,
                            name: "Udon Thani",
                            value: "Udon Thani",
                            countryId: 84
                        },
                        {
                            stateId: 1319,
                            name: "Uthai Thani",
                            value: "Uthai Thani",
                            countryId: 84
                        },
                        {
                            stateId: 1322,
                            name: "Uttaradit",
                            value: "Uttaradit",
                            countryId: 84
                        },
                        {
                            stateId: 1406,
                            name: "Yala",
                            value: "Yala",
                            countryId: 84
                        },
                        {
                            stateId: 1412,
                            name: "Yasothon",
                            value: "Yasothon",
                            countryId: 84
                        }
                    ]
                },
                {
                    countryId: 318,
                    code: "TL",
                    name: "Timor-Leste",
                    value: "Timor-Leste",
                    states: [
                        {
                            stateId: 1718,
                            name: "Dili",
                            value: "Dili",
                            countryId: 318
                        }
                    ]
                },
                {
                    countryId: 319,
                    code: "TG",
                    name: "Togo",
                    value: "Togo",
                    states: [
                        {
                            stateId: 1719,
                            name: "Lomé",
                            value: "Lomé",
                            countryId: 319
                        }
                    ]
                },
                {
                    countryId: 320,
                    code: "TK",
                    name: "Tokelau",
                    value: "Tokelau",
                    states: [
                        {
                            stateId: 1720,
                            name: "Nukunonu",
                            value: "Nukunonu",
                            countryId: 320
                        }
                    ]
                },
                {
                    countryId: 321,
                    code: "TO",
                    name: "Tonga",
                    value: "Tonga",
                    states: [
                        {
                            stateId: 1721,
                            name: "Nuku‘alofa",
                            value: "Nuku‘alofa",
                            countryId: 321
                        }
                    ]
                },
                {
                    countryId: 322,
                    code: "TT",
                    name: "Trinidad and Tobago",
                    value: "Trinidad and Tobago",
                    states: [
                        {
                            stateId: 1722,
                            name: "Port-of-Spain",
                            value: "Port-of-Spain",
                            countryId: 322
                        }
                    ]
                },
                {
                    countryId: 323,
                    code: "TN",
                    name: "Tunisia",
                    value: "Tunisia",
                    states: [
                        {
                            stateId: 1723,
                            name: "Tunis",
                            value: "Tunis",
                            countryId: 323
                        }
                    ]
                },
                {
                    countryId: 85,
                    code: "TR",
                    name: "Turkey",
                    value: "Turkey",
                    states: [
                        {
                            stateId: 7,
                            name: "Adana",
                            value: "Adana",
                            countryId: 85
                        },
                        {
                            stateId: 9,
                            name: "Adiyaman",
                            value: "Adiyaman",
                            countryId: 85
                        },
                        {
                            stateId: 12,
                            name: "Afyonkarahisar",
                            value: "Afyonkarahisar",
                            countryId: 85
                        },
                        {
                            stateId: 17,
                            name: "Ağri",
                            value: "Ağri",
                            countryId: 85
                        },
                        {
                            stateId: 33,
                            name: "Aksaray",
                            value: "Aksaray",
                            countryId: 85
                        },
                        {
                            stateId: 47,
                            name: "Amasya",
                            value: "Amasya",
                            countryId: 85
                        },
                        {
                            stateId: 59,
                            name: "Ankara",
                            value: "Ankara",
                            countryId: 85
                        },
                        {
                            stateId: 61,
                            name: "Antalya",
                            value: "Antalya",
                            countryId: 85
                        },
                        {
                            stateId: 69,
                            name: "Ardahan",
                            value: "Ardahan",
                            countryId: 85
                        },
                        {
                            stateId: 76,
                            name: "Artvin",
                            value: "Artvin",
                            countryId: 85
                        },
                        {
                            stateId: 90,
                            name: "Aydin",
                            value: "Aydin",
                            countryId: 85
                        },
                        {
                            stateId: 103,
                            name: "Balikesir",
                            value: "Balikesir",
                            countryId: 85
                        },
                        {
                            stateId: 118,
                            name: "Bartin",
                            value: "Bartin",
                            countryId: 85
                        },
                        {
                            stateId: 120,
                            name: "Batman",
                            value: "Batman",
                            countryId: 85
                        },
                        {
                            stateId: 125,
                            name: "Bayburt",
                            value: "Bayburt",
                            countryId: 85
                        },
                        {
                            stateId: 137,
                            name: "Bilecik",
                            value: "Bilecik",
                            countryId: 85
                        },
                        {
                            stateId: 139,
                            name: "Bingöl",
                            value: "Bingöl",
                            countryId: 85
                        },
                        {
                            stateId: 144,
                            name: "Bitlis",
                            value: "Bitlis",
                            countryId: 85
                        },
                        {
                            stateId: 150,
                            name: "Bolu",
                            value: "Bolu",
                            countryId: 85
                        },
                        {
                            stateId: 177,
                            name: "Burdur",
                            value: "Burdur",
                            countryId: 85
                        },
                        {
                            stateId: 180,
                            name: "Bursa",
                            value: "Bursa",
                            countryId: 85
                        },
                        {
                            stateId: 197,
                            name: "Çanakkale",
                            value: "Çanakkale",
                            countryId: 85
                        },
                        {
                            stateId: 201,
                            name: "Çankiri",
                            value: "Çankiri",
                            countryId: 85
                        },
                        {
                            stateId: 289,
                            name: "Çorum",
                            value: "Çorum",
                            countryId: 85
                        },
                        {
                            stateId: 309,
                            name: "Denizli",
                            value: "Denizli",
                            countryId: 85
                        },
                        {
                            stateId: 339,
                            name: "Diyarbakir",
                            value: "Diyarbakir",
                            countryId: 85
                        },
                        {
                            stateId: 356,
                            name: "Düzce",
                            value: "Düzce",
                            countryId: 85
                        },
                        {
                            stateId: 361,
                            name: "Edirne",
                            value: "Edirne",
                            countryId: 85
                        },
                        {
                            stateId: 366,
                            name: "Elaziğ",
                            value: "Elaziğ",
                            countryId: 85
                        },
                        {
                            stateId: 373,
                            name: "Erzincan",
                            value: "Erzincan",
                            countryId: 85
                        },
                        {
                            stateId: 374,
                            name: "Erzurum",
                            value: "Erzurum",
                            countryId: 85
                        },
                        {
                            stateId: 378,
                            name: "Eskişehir",
                            value: "Eskişehir",
                            countryId: 85
                        },
                        {
                            stateId: 406,
                            name: "Gaziantep",
                            value: "Gaziantep",
                            countryId: 85
                        },
                        {
                            stateId: 412,
                            name: "Giresun",
                            value: "Giresun",
                            countryId: 85
                        },
                        {
                            stateId: 448,
                            name: "Gümüşhane",
                            value: "Gümüşhane",
                            countryId: 85
                        },
                        {
                            stateId: 457,
                            name: "Hakkari",
                            value: "Hakkari",
                            countryId: 85
                        },
                        {
                            stateId: 464,
                            name: "Hatay",
                            value: "Hatay",
                            countryId: 85
                        },
                        {
                            stateId: 493,
                            name: "Iğdir",
                            value: "Iğdir",
                            countryId: 85
                        },
                        {
                            stateId: 528,
                            name: "Isparta",
                            value: "Isparta",
                            countryId: 85
                        },
                        {
                            stateId: 529,
                            name: "İstanbul",
                            value: "İstanbul",
                            countryId: 85
                        },
                        {
                            stateId: 539,
                            name: "İzmir",
                            value: "İzmir",
                            countryId: 85
                        },
                        {
                            stateId: 565,
                            name: "Kahramanmaraş",
                            value: "Kahramanmaraş",
                            countryId: 85
                        },
                        {
                            stateId: 594,
                            name: "Karabük",
                            value: "Karabük",
                            countryId: 85
                        },
                        {
                            stateId: 595,
                            name: "Karaman",
                            value: "Karaman",
                            countryId: 85
                        },
                        {
                            stateId: 600,
                            name: "Kars",
                            value: "Kars",
                            countryId: 85
                        },
                        {
                            stateId: 602,
                            name: "Kastamonu",
                            value: "Kastamonu",
                            countryId: 85
                        },
                        {
                            stateId: 604,
                            name: "Kayseri",
                            value: "Kayseri",
                            countryId: 85
                        },
                        {
                            stateId: 617,
                            name: "Kilis",
                            value: "Kilis",
                            countryId: 85
                        },
                        {
                            stateId: 618,
                            name: "Kirikkale",
                            value: "Kirikkale",
                            countryId: 85
                        },
                        {
                            stateId: 619,
                            name: "Kirklareli",
                            value: "Kirklareli",
                            countryId: 85
                        },
                        {
                            stateId: 622,
                            name: "Kirşehir",
                            value: "Kirşehir",
                            countryId: 85
                        },
                        {
                            stateId: 623,
                            name: "Kktc",
                            value: "Kktc",
                            countryId: 85
                        },
                        {
                            stateId: 625,
                            name: "Kocaeli",
                            value: "Kocaeli",
                            countryId: 85
                        },
                        {
                            stateId: 630,
                            name: "Konya",
                            value: "Konya",
                            countryId: 85
                        },
                        {
                            stateId: 647,
                            name: "Kütahya",
                            value: "Kütahya",
                            countryId: 85
                        },
                        {
                            stateId: 725,
                            name: "Malatya",
                            value: "Malatya",
                            countryId: 85
                        },
                        {
                            stateId: 732,
                            name: "Manisa",
                            value: "Manisa",
                            countryId: 85
                        },
                        {
                            stateId: 737,
                            name: "Mardin",
                            value: "Mardin",
                            countryId: 85
                        },
                        {
                            stateId: 766,
                            name: "Mersin(İçel)",
                            value: "Mersin(İçel)",
                            countryId: 85
                        },
                        {
                            stateId: 799,
                            name: "Muğla",
                            value: "Muğla",
                            countryId: 85
                        },
                        {
                            stateId: 805,
                            name: "Muş",
                            value: "Muş",
                            countryId: 85
                        },
                        {
                            stateId: 837,
                            name: "Nevşehir",
                            value: "Nevşehir",
                            countryId: 85
                        },
                        {
                            stateId: 848,
                            name: "Niğde",
                            value: "Niğde",
                            countryId: 85
                        },
                        {
                            stateId: 903,
                            name: "Ordu",
                            value: "Ordu",
                            countryId: 85
                        },
                        {
                            stateId: 911,
                            name: "Osmaniye",
                            value: "Osmaniye",
                            countryId: 85
                        },
                        {
                            stateId: 1061,
                            name: "Rize",
                            value: "Rize",
                            countryId: 85
                        },
                        {
                            stateId: 1101,
                            name: "Sakarya",
                            value: "Sakarya",
                            countryId: 85
                        },
                        {
                            stateId: 1113,
                            name: "Samsun",
                            value: "Samsun",
                            countryId: 85
                        },
                        {
                            stateId: 1127,
                            name: "Şanliurfa",
                            value: "Şanliurfa",
                            countryId: 85
                        },
                        {
                            stateId: 1165,
                            name: "Siirt",
                            value: "Siirt",
                            countryId: 85
                        },
                        {
                            stateId: 1171,
                            name: "Sinop",
                            value: "Sinop",
                            countryId: 85
                        },
                        {
                            stateId: 1172,
                            name: "Şirnak",
                            value: "Şirnak",
                            countryId: 85
                        },
                        {
                            stateId: 1175,
                            name: "Sivas",
                            value: "Sivas",
                            countryId: 85
                        },
                        {
                            stateId: 1251,
                            name: "Tekirdağ",
                            value: "Tekirdağ",
                            countryId: 85
                        },
                        {
                            stateId: 1280,
                            name: "Tokat",
                            value: "Tokat",
                            countryId: 85
                        },
                        {
                            stateId: 1289,
                            name: "Trabzon",
                            value: "Trabzon",
                            countryId: 85
                        },
                        {
                            stateId: 1306,
                            name: "Tunceli",
                            value: "Tunceli",
                            countryId: 85
                        },
                        {
                            stateId: 1315,
                            name: "Uşak",
                            value: "Uşak",
                            countryId: 85
                        },
                        {
                            stateId: 1333,
                            name: "Van",
                            value: "Van",
                            countryId: 85
                        },
                        {
                            stateId: 1407,
                            name: "Yalova",
                            value: "Yalova",
                            countryId: 85
                        },
                        {
                            stateId: 1415,
                            name: "Yozgat",
                            value: "Yozgat",
                            countryId: 85
                        },
                        {
                            stateId: 1430,
                            name: "Zonguldak",
                            value: "Zonguldak",
                            countryId: 85
                        }
                    ]
                },
                {
                    countryId: 325,
                    code: "TM",
                    name: "Turkmenistan",
                    value: "Turkmenistan",
                    states: [
                        {
                            stateId: 1724,
                            name: "Ashgabat",
                            value: "Ashgabat",
                            countryId: 325
                        }
                    ]
                },
                {
                    countryId: 326,
                    code: "TC",
                    name: "Turks and Caicos Islands",
                    value: "Turks and Caicos Islands",
                    states: [
                        {
                            stateId: 1725,
                            name: "Cockburn Town",
                            value: "Cockburn Town",
                            countryId: 326
                        }
                    ]
                },
                {
                    countryId: 327,
                    code: "TV",
                    name: "Tuvalu",
                    value: "Tuvalu",
                    states: [
                        {
                            stateId: 1726,
                            name: "Funafuti",
                            value: "Funafuti",
                            countryId: 327
                        }
                    ]
                },
                {
                    countryId: 86,
                    code: "VI",
                    name: "U.S. Virgin Islands",
                    value: "U.S. Virgin Islands",
                    states: [
                        {
                            stateId: 1356,
                            name: "Vi",
                            value: "Vi",
                            countryId: 86
                        }
                    ]
                },
                {
                    countryId: 328,
                    code: "UG",
                    name: "Uganda",
                    value: "Uganda",
                    states: [
                        {
                            stateId: 1727,
                            name: "Kampala",
                            value: "Kampala",
                            countryId: 328
                        }
                    ]
                },
                {
                    countryId: 87,
                    code: "UA",
                    name: "Ukraine",
                    value: "Ukraine",
                    states: [
                        {
                            stateId: 246,
                            name: "Cherkaska",
                            value: "Cherkaska",
                            countryId: 87
                        },
                        {
                            stateId: 247,
                            name: "Chernihivska",
                            value: "Chernihivska",
                            countryId: 87
                        },
                        {
                            stateId: 248,
                            name: "Chernivetska",
                            value: "Chernivetska",
                            countryId: 87
                        },
                        {
                            stateId: 341,
                            name: "Dnipropetrovska",
                            value: "Dnipropetrovska",
                            countryId: 87
                        },
                        {
                            stateId: 345,
                            name: "Donetska",
                            value: "Donetska",
                            countryId: 87
                        },
                        {
                            stateId: 531,
                            name: "Ivano-Frankivska",
                            value: "Ivano-Frankivska",
                            countryId: 87
                        },
                        {
                            stateId: 611,
                            name: "Kharkivska",
                            value: "Kharkivska",
                            countryId: 87
                        },
                        {
                            stateId: 613,
                            name: "Khersonska",
                            value: "Khersonska",
                            countryId: 87
                        },
                        {
                            stateId: 614,
                            name: "Khmelnytska",
                            value: "Khmelnytska",
                            countryId: 87
                        },
                        {
                            stateId: 621,
                            name: "Kirovohradska",
                            value: "Kirovohradska",
                            countryId: 87
                        },
                        {
                            stateId: 648,
                            name: "Kyiv",
                            value: "Kyiv",
                            countryId: 87
                        },
                        {
                            stateId: 649,
                            name: "Kyivska",
                            value: "Kyivska",
                            countryId: 87
                        },
                        {
                            stateId: 708,
                            name: "Luhanska",
                            value: "Luhanska",
                            countryId: 87
                        },
                        {
                            stateId: 712,
                            name: "Lvivska",
                            value: "Lvivska",
                            countryId: 87
                        },
                        {
                            stateId: 806,
                            name: "Mykolaivska",
                            value: "Mykolaivska",
                            countryId: 87
                        },
                        {
                            stateId: 886,
                            name: "Odeska",
                            value: "Odeska",
                            countryId: 87
                        },
                        {
                            stateId: 963,
                            name: "Poltavska",
                            value: "Poltavska",
                            countryId: 87
                        },
                        {
                            stateId: 1060,
                            name: "Rivnenska",
                            value: "Rivnenska",
                            countryId: 87
                        },
                        {
                            stateId: 1222,
                            name: "Sumska",
                            value: "Sumska",
                            countryId: 87
                        },
                        {
                            stateId: 1259,
                            name: "Ternopilska",
                            value: "Ternopilska",
                            countryId: 87
                        },
                        {
                            stateId: 1370,
                            name: "Vinnytska",
                            value: "Vinnytska",
                            countryId: 87
                        },
                        {
                            stateId: 1377,
                            name: "Volynska",
                            value: "Volynska",
                            countryId: 87
                        },
                        {
                            stateId: 1421,
                            name: "Zakarpatska",
                            value: "Zakarpatska",
                            countryId: 87
                        },
                        {
                            stateId: 1423,
                            name: "Zaporizka",
                            value: "Zaporizka",
                            countryId: 87
                        },
                        {
                            stateId: 1426,
                            name: "Zhytomyrska",
                            value: "Zhytomyrska",
                            countryId: 87
                        }
                    ]
                },
                {
                    countryId: 330,
                    code: "AE",
                    name: "United Arab Emirates",
                    value: "United Arab Emirates",
                    states: [
                        {
                            stateId: 1728,
                            name: "Abu Dhabi",
                            value: "Abu Dhabi",
                            countryId: 330
                        }
                    ]
                },
                {
                    countryId: 88,
                    code: "GB",
                    name: "United Kingdom",
                    value: "United Kingdom",
                    states: [
                        {
                            stateId: 369,
                            name: "England",
                            value: "England",
                            countryId: 88
                        },
                        {
                            stateId: 870,
                            name: "Northern Ireland",
                            value: "Northern Ireland",
                            countryId: 88
                        },
                        {
                            stateId: 1149,
                            name: "Scotland",
                            value: "Scotland",
                            countryId: 88
                        },
                        {
                            stateId: 1384,
                            name: "Wales",
                            value: "Wales",
                            countryId: 88
                        }
                    ]
                },
                {
                    countryId: 126,
                    code: "UM",
                    name: "United States Minor Outlying Islands",
                    value: "United States Minor Outlying Islands",
                    states: []
                },
                {
                    countryId: 90,
                    code: "UY",
                    name: "Uruguay",
                    value: "Uruguay",
                    states: [
                        {
                            stateId: 75,
                            name: "Artigas",
                            value: "Artigas",
                            countryId: 90
                        },
                        {
                            stateId: 199,
                            name: "Canelones",
                            value: "Canelones",
                            countryId: 90
                        },
                        {
                            stateId: 234,
                            name: "Cerro Largo",
                            value: "Cerro Largo",
                            countryId: 90
                        },
                        {
                            stateId: 276,
                            name: "Colonia",
                            value: "Colonia",
                            countryId: 90
                        },
                        {
                            stateId: 354,
                            name: "Durazno",
                            value: "Durazno",
                            countryId: 90
                        },
                        {
                            stateId: 389,
                            name: "Flores",
                            value: "Flores",
                            countryId: 90
                        },
                        {
                            stateId: 393,
                            name: "Florida",
                            value: "Florida",
                            countryId: 90
                        },
                        {
                            stateId: 681,
                            name: "Lavalleja",
                            value: "Lavalleja",
                            countryId: 90
                        },
                        {
                            stateId: 726,
                            name: "Maldonado",
                            value: "Maldonado",
                            countryId: 90
                        },
                        {
                            stateId: 793,
                            name: "Montevideo",
                            value: "Montevideo",
                            countryId: 90
                        },
                        {
                            stateId: 938,
                            name: "Paysandu",
                            value: "Paysandu",
                            countryId: 90
                        },
                        {
                            stateId: 1056,
                            name: "Rio Negro",
                            value: "Rio Negro",
                            countryId: 90
                        },
                        {
                            stateId: 1059,
                            name: "Rivera",
                            value: "Rivera",
                            countryId: 90
                        },
                        {
                            stateId: 1062,
                            name: "Rocha",
                            value: "Rocha",
                            countryId: 90
                        },
                        {
                            stateId: 1109,
                            name: "Salto",
                            value: "Salto",
                            countryId: 90
                        },
                        {
                            stateId: 1119,
                            name: "San Jose",
                            value: "San Jose",
                            countryId: 90
                        },
                        {
                            stateId: 1190,
                            name: "Soriano",
                            value: "Soriano",
                            countryId: 90
                        },
                        {
                            stateId: 1233,
                            name: "Tacuarembo",
                            value: "Tacuarembo",
                            countryId: 90
                        },
                        {
                            stateId: 1292,
                            name: "Treinta y Tres",
                            value: "Treinta y Tres",
                            countryId: 90
                        }
                    ]
                },
                {
                    countryId: 334,
                    code: "UZ",
                    name: "Uzbekistan",
                    value: "Uzbekistan",
                    states: [
                        {
                            stateId: 1729,
                            name: "Tashkent",
                            value: "Tashkent",
                            countryId: 334
                        }
                    ]
                },
                {
                    countryId: 335,
                    code: "VU",
                    name: "Vanuatu",
                    value: "Vanuatu",
                    states: [
                        {
                            stateId: 1730,
                            name: "Port-Vila",
                            value: "Port-Vila",
                            countryId: 335
                        }
                    ]
                },
                {
                    countryId: 91,
                    code: "VA",
                    name: "Vatican City",
                    value: "Vatican City",
                    states: [
                        {
                            stateId: 1731,
                            name: "Vatican City",
                            value: "Vatican City",
                            countryId: 91
                        }
                    ]
                },
                {
                    countryId: 336,
                    code: "VE",
                    name: "Venezuela (Bolivarian Republic of)",
                    value: "Venezuela (Bolivarian Republic of)",
                    states: [
                        {
                            stateId: 1732,
                            name: "Caracas",
                            value: "Caracas",
                            countryId: 336
                        }
                    ]
                },
                {
                    countryId: 337,
                    code: "VN",
                    name: "Viet Nam",
                    value: "Viet Nam",
                    states: [
                        {
                            stateId: 1733,
                            name: "Hanoi",
                            value: "Hanoi",
                            countryId: 337
                        }
                    ]
                },
                {
                    countryId: 127,
                    code: "VG",
                    name: "Virgin Islands (British)",
                    value: "Virgin Islands (British)",
                    states: [
                        {
                            stateId: 1734,
                            name: "Road Town",
                            value: "Road Town",
                            countryId: 127
                        }
                    ]
                },
                {
                    countryId: 92,
                    code: "WF",
                    name: "Wallis And Futuna",
                    value: "Wallis And Futuna",
                    states: [
                        {
                            stateId: 266,
                            name: "Circonscription d'Alo",
                            value: "Circonscription d'Alo",
                            countryId: 92
                        },
                        {
                            stateId: 267,
                            name: "Circonscription d'Uvéa",
                            value: "Circonscription d'Uvéa",
                            countryId: 92
                        },
                        {
                            stateId: 268,
                            name: "Circonscription de Sigave",
                            value: "Circonscription de Sigave",
                            countryId: 92
                        }
                    ]
                },
                {
                    countryId: 339,
                    code: "EH",
                    name: "Western Sahara",
                    value: "Western Sahara",
                    states: [
                        {
                            stateId: 1735,
                            name: "El Aaiún",
                            value: "El Aaiún",
                            countryId: 339
                        }
                    ]
                },
                {
                    countryId: 340,
                    code: "YE",
                    name: "Yemen",
                    value: "Yemen",
                    states: [
                        {
                            stateId: 1736,
                            name: "Sanaa",
                            value: "Sanaa",
                            countryId: 340
                        }
                    ]
                },
                {
                    countryId: 341,
                    code: "ZM",
                    name: "Zambia",
                    value: "Zambia",
                    states: [
                        {
                            stateId: 1737,
                            name: "Lusaka",
                            value: "Lusaka",
                            countryId: 341
                        }
                    ]
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "relationShip", {
        get: function () {
            return [
                { id: 1, value: "Parent", label: "Parent" },
                { id: 2, value: "Guardian", label: "Guardian" },
                { id: 3, value: "Spouse", label: "Spouse" },
                { id: 4, value: "Partner", label: "Partner" },
                { id: 5, value: "Medical representative", label: "Medical representative" },
                { id: 6, value: "Power attorney", label: "Power attorney" },
                { id: 7, value: "Family", label: "Family" },
                { id: 8, value: "Other", label: "Other" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "citizenships", {
        get: function () {
            return [
                { id: 1, value: "us-citizen", label: "US Citizen" },
                { id: 2, value: "resident-alien", label: "Resident Alien" },
                { id: 3, value: "non-resident-alien", label: "Non-Resident Alien" },
                { id: 4, value: "asylum", label: "Asylum" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    DataStore.prototype.getStatesByCountryName = function (countryCode) {
        var countries = this.countries;
        if (countries) {
            var country = countries.filter(function (country) { return country.code === countryCode; })[0];
            if (country) {
                return country.states;
            }
            return [];
        }
        return [];
    };
    Object.defineProperty(DataStore.prototype, "suffixList", {
        get: function () {
            return [
                { label: "II", value: "II" },
                { label: "III", value: "III" },
                { label: "IV", value: "IV" },
                { label: "Jr.", value: "Jr." },
                { label: "MD", value: "MD" },
                { label: "P.E.", value: "P.E." },
                { label: "PHD", value: "PHD" },
                { label: "RN", value: "RN" },
                { label: "Sr.", value: "Sr." },
                { label: "V", value: "V" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    DataStore.prototype.getTotalCredits = function () {
        return this.json.totalCredits;
    };
    DataStore.prototype.getCampusesBySlug = function (slug) {
        var campusesBySlug = this.json[slug];
        if (!campusesBySlug) {
            var campus = this.json.default;
            return [
                {
                    id: campus.id,
                    name: campus.name,
                    code: campus.code,
                    address: campus.address,
                    state: campus.state,
                    phone: campus.phone,
                    school_code: campus.school_code
                }
            ];
        }
        return campusesBySlug.campuses.map(function (_a) {
            var id = _a.id, name = _a.name, code = _a.code, address = _a.address, state = _a.state, phone = _a.phone, school_code = _a.school_code;
            return ({
                id: id,
                name: name,
                code: code,
                address: address,
                state: state,
                phone: phone,
                school_code: school_code
            });
        });
    };
    DataStore.prototype.getProgramsBySlugAndCampusId = function (slug, campusId) {
        var campusesBySlug = this.json[slug];
        if (!campusesBySlug) {
            var program_1 = this.json.default.programs[0];
            return [
                {
                    id: program_1.id,
                    name: program_1.name,
                    code: program_1.name,
                    charge: program_1.charge,
                    quant_hours: program_1.quant_hours
                }
            ];
        }
        var campusIndexFound = campusesBySlug.campuses.findIndex(function (_a) {
            var id = _a.id;
            return campusId === id;
        });
        if (campusIndexFound > -1) {
            var programs = campusesBySlug.campuses[campusIndexFound].programs.map(function (_a) {
                var id = _a.id, name = _a.name, code = _a.code, charge = _a.charge, quant_hours = _a.quant_hours;
                return ({
                    id: id,
                    name: name,
                    code: code,
                    charge: charge,
                    quant_hours: quant_hours
                });
            });
            return programs;
        }
        var program = this.json.default.programs[0];
        return [
            {
                id: program.id,
                name: program.name,
                code: program.name,
                charge: program.charge,
                quant_hours: program.quant_hours
            }
        ];
    };
    DataStore.prototype.getSpfBySlugCampusIdAndProgramId = function (slug, campusId, programId) {
        var campusesBySlug = this.json[slug];
        if (!campusesBySlug || !campusId || !programId) {
            var program_2 = this.json.default.programs[0];
            return program_2.spfInfo;
        }
        var campusIndexFound = campusesBySlug.campuses.findIndex(function (_a) {
            var id = _a.id;
            return campusId === id;
        });
        if (campusIndexFound > -1) {
            var programIndexFound = campusesBySlug.campuses[campusIndexFound].programs.findIndex(function (_a) {
                var id = _a.id;
                return id === programId;
            });
            if (programIndexFound > -1) {
                var programFound = campusesBySlug.campuses[campusIndexFound].programs[programIndexFound];
                return programFound.spfInfo;
            }
            var program_3 = this.json.default.programs[0];
            return program_3.spfInfo;
        }
        var program = this.json.default.programs[0];
        return program.spfInfo;
    };
    return DataStore;
}());
exports.DataStore = DataStore;
//# sourceMappingURL=data:application/json;base64,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